//bc-sf-filter.js
// Override Settings
window.addEventListener("load", function () {
	//loadMinicart();
});
var bcSfFilterSettings = {
	general: {
		limit: 30,
		/* Optional */
		loadProductFirst: true,
	},
};

//console.log(data_critic_reviews);
var dataCart = (function () {
	var jqXHR = jQ.ajax({
		url: "/cart.js",
		async: false,
	});
	var data = JSON.parse(jqXHR.responseText);
	return data;
})();

sessionStorage.setItem("firstLoad", 1);

var bcSfFilterTemplate = {
	soldOutClass: "product-price--sold-out grid-view-item--sold-out",

	// Grid Template
	vendorGridHtml: "", //'<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
	soldOutLabelGridHtml:
		' <span class="product-price__sold-out">' +
		bcSfFilterConfig.label.sold_out +
		"</span>",
	productGridItemHtml:
		'<div class="grid__item {{itemGridWidthClass}} grid__item_{{itemId}} {{bundlebuilder}}">' +
		'<div class="grid-view-item {{itemSoldOutClass}} {{is_active}}">' +
		'<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
		'<a class="grid-view-item__link" href="{{itemUrl}}" onclick="showAdd2CartForm()">' +
		"{{itemImages}}" +
		"{{iconAward}}" +
		"{{itemIcons}}" +
		"{{iconVeganPro}}" +
		"</a>" +
		'<div class="producer"><span>{{producer}}</span></div>' +
		'<h3 class="grid-view-item__title">' +
		'<a href="{{itemUrl}}" >{{itemTitle}}</a>' +
		"</h3>" +
		"{{itemVendor}}" +
		'<div class="grid-view-item__meta">{{itemPrice}}</div>' +
		"{{onlyAvailable}}" +
		'<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
		'<div class="product-card-add {{is_added}} {{is_active}} {{bundlebuilder}}" data-product-id="{{variantFirstId}}">' +
		'<div class="product-card-wrap">' +
		
		// '<div class="product-quantity">' +
		// '<div class="price-variant price-variant-bottle {{showBottle}}">' +
		// '<div class="title-variant">Bottle(s)</div>' +
		// '<div class="title-variant bundlebuilder">Case(s)</div>' +
		// '<div class="add-remove-actions">' +
		// '<span class="{{disabledBtClass}} fa-stack fa-1x bt-dec-{{variantFirstId}}" onclick="bottleQuantyDecrease(\'{{variantFirstId}}\',\'{{itemTitleInCart}}\')"><i class="fa fa-stack-2x fa-circle"></i><i class="fa fa-minus fa-stack-1x"></i></span>' +
		// '<div class="count">' +
		// '<div class="total">' +
		// '<input maxlength="3" type="number" min="{{minQtyBottle}}" step="{{stepQtyBottle}}" max="{{maxQtyBottle}}" value="{{itemBottleQty}}" class="ng-untouched ng-pristine ng-valid bold-text" id="bottle_qty_{{variantFirstId}}" {{bottlePrice}} onchange="changeQty(this)" />' +
		// "</div>" +
		// "</div>" +
		// '<span class="{{disabledBtIncClass}} fa-stack fa-1x bt-inc-{{variantFirstId}}" onclick="bottleQuantyIncrease(\'{{variantFirstId}}\',\'{{itemTitleInCart}}\', \'{{producer}}\', {{isBundlebuilder}})"><i class="fa fa-stack-2x fa-circle"></i><i class="fa fa-plus fa-stack-1x"></i></span>' +
		// "</div>" +
		// '<div class="label">in cart</div>' +
		// "</div>" +
		// '<div class="price-variant price-variant-case {{showCase}}">' +
		// '<div class="title-variant">Case(s)</div>' +
		// '<div class="add-remove-actions">' +
		// '<span class="{{disabledCsClass}} fa-stack fa-1x cs-dec-{{variantFirstId}}" onclick="caseQuantyDecrease(\'{{variantFirstId}}\',\'{{itemTitleInCart}}\', \'{{producer}}\', {{isBundlebuilder}})"><i class="fa fa-stack-2x fa-circle"></i><i class="fa fa-minus fa-stack-1x"></i></span>' +
		// '<div class="count">' +
		// '<div class="total">' +
		// '<input maxlength="3" type="number" min="{{minQtyCase}}" max="{{maxQtyCase}}" value="{{itemCaseQty}}" class="ng-untouched ng-pristine ng-valid bold-text" id="case_qty_{{variantFirstId}}" {{caseQtys}} {{casePrice}}  onchange="changeQty(this)" />' +
		// "</div>" +
		// "</div>" +
		// '<span class="{{disabledCsIncreaseClass}} fa-stack fa-1x cs-inc-{{variantFirstId}}" onclick="caseQuantyIncrease(\'{{variantFirstId}}\',\'{{itemTitleInCart}}\', \'{{producer}}\', {{isBundlebuilder}})"><i class="fa fa-stack-2x fa-circle"></i><i class="fa fa-plus fa-stack-1x"></i></span>' +
		// "</div>" +
		// '<div class="label">in cart</div>' +
		// "</div>" +
		// "</div>" +
		'<div class="price-description">' +
		'<div class="list-view-item__price-column">{{itemPrice}}</div>' +
		"{{salePercent}}" +
		"</div>" +
		'<div class="product-card-add-list">' +
		'{{quantityProduct}}'+
		"</div>" +
		'<div class="actions">' +
		'<button {{isAddProductDisabled}} id="btn_list_{{variantFirstId}}" title="{{buttonText}}" class="btn btn-action card-btn {{buttonAdded}}" onclick="addProductToCart(dataCart, this, {{variantFirstId}},\'{{itemTitleInCart}}\', \'{{producer}}\', {{isBundlebuilder}})">' +
		"<span>{{buttonText}}</span>" +
		"</button>" +
		"</div>" +
		// '<div class="subtotal">' +
		// '<div class="subtotal-text">Subtotal</div>' +
		// '<div class="subtotal-price">{{subtotalPriceitem}}</div>' +
		// "</div>" +
		"</div>" +
		'<div class="spinner">' +
		'<div class="fa-pulse"><i class="fa fa-spinner fa-3x fa-fw"></i></div>' +
		"</div>" +
		'<div class="product-card-continue" style="display: none;">' +
		'<p class="at-least">This item can only be added at least <span class="min-qty">\'{{minQtyBottle}}\'</span>. Would you like to continue.</p>' +
		'<p class="at-most" style="display: none">This item can only be added at most <span class="max-qty">\'{{maxQtyBottle}}\'</span>. Would you like to continue.</p>' +
		"<button class=\"btn btn-continue btn-continue-{{variantFirstId}} min-continue\" onclick=\"btnQuantyMin('{{variantFirstId}}','{{itemTitleInCart}}', '{{producer}}', {{isBundlebuilder}}, {{minQtyBottle}})\">Yes, Continue</button>" +
		"<button class=\"btn btn-continue btn-continue-{{variantFirstId}} max-continue\" style=\"display: none\" onclick=\"btnQuantyMin('{{variantFirstId}}','{{itemTitleInCart}}', '{{producer}}', {{isBundlebuilder}}, {{maxQtyBottle}})\">Yes, Continue</button>" +
		"</div>" +
		'<div class="product-card-case-continue" style="display: none;">' +
		'<p class="at-least">This item can only be added at least <span class="min-qty">\'{{minQtyBottle}}\'</span>. Would you like to continue.</p>' +
		'<p class="at-most" style="display: none">This item can only be added at most <span class="min-qty">\'{{maxQtyBottle}}\'</span>. Would you like to continue.</p>' +
		"<button class=\"btn btn-continue btn-continue-{{variantFirstId}} min-continue\" onclick=\"btnCaseQuantyMin('{{variantFirstId}}','{{itemTitleInCart}}', '{{producer}}', {{isBundlebuilder}},{{minQtyBottle}})\">Yes, Continue</button>" +
		"<button class=\"btn btn-continue btn-continue-{{variantFirstId}} max-continue\" style=\"display: none\" onclick=\"btnCaseQuantyMin('{{variantFirstId}}','{{itemTitleInCart}}', '{{producer}}', {{isBundlebuilder}},{{maxQtyBottle}})\">Yes, Continue</button>" +
		"</div>" +
		"</div>" +
		'<button {{isAddProductDisabled}} class="btn btn-action card-btn {{customClass}}" onclick="showAdd2CartForm(this)">' +
		"<span>{{buttonTitle}}</span>" +
		"</button>" +
		"{{mixedCaseButton}}" +
		'<form method="post" action="/cart/add" class="add-to-cart-from-collection">' +
		'<input type="hidden" name="id" value="{{variantFirstId}}" />' +
		'<input min="0" type="number" id="quantity" name="quantity" value="0"/>' +
		'<input type="submit" value="Add to cart" class="btn" />' +
		"</form>" +
		"</div>" +
		"</div>",

	// List Template
	vendorSmallListHtml:
		'<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
	vendorMediumListHtml:
		'<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
	saleLabelListHtml:
		'<div class="list-view-item__on-sale">' +
		bcSfFilterConfig.label.sale +
		"</div>",
	soldOutLabelListHtml:
		'<div class="list-view-item__sold-out">' +
		bcSfFilterConfig.label.sold_out +
		"</div>",
	productListItemHtml:
		'<div class="list-view-item {{bundlebuilder}}">' +
		'<div class="list-view-item__image-column">' +
		'<div class="list-view-item__image-wrapper">' +
		'<a href="{{itemUrl}}" >' +
		'<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
		"</a>" +
		"{{iconAward}}" +
		"{{itemIcons}}" +
		"{{iconVeganPro}}" +
		"</div>" +
		"</div>" +
		'<div class="list-view-item__title-column">' +
		'<div class="producer"><a href="{{itemUrl}}" ><span>{{producer}}</span></a></div>' +
		'<div class="list-view-item__title">' +
		'<a href="{{itemUrl}}" >' +
		"{{itemTitle}}" +
		"</a>" +
		"</div>" +
		'<div class="style-address">{{style}}</div>' +
		'<div class="list-view-item__description">' +
		"{{itemDescription}}" +
		"</div>" +
		'<a href="{{itemUrl}}" class="more-info">' +
		'More info <i class="fa fa-angle-right" aria-hidden="true"></i>' +
		"</a>" +
		"</div>" +
		'<div class="list-view-item__form-column">' +
		'<div class="list-view-item-wrapper">' +
		'<div class="price-description">' +
		"{{priceDescription}}" +
		'<div class="list-view-item__price-column">{{itemPrice}}</div>' +
		"{{salePercent}}" +
		"</div>" +
		'<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
		'<div class="product-card-add-list">' +
		'<div class="product-card-wrap {{is_show}}">' +
		"{{onlyAvailable}}" +
		'<div class="product-quantity">' +
		'<div class="price-variant">' +
		'<div class="add-remove-actions">' +
		'<div class="count">' +
		'<div class="total">' +
		'<div class="type-qtys">' +
		'<input type="hidden" id="btcs_list_{{variantFirstId}}" name="btcs_list_{{variantFirstId}}" value="0">' +
		'<select class="select {{is_show}}" min="{{minSelectQty}}" max="{{maxSelectQty}}" policy="{{inventoryPolicy}}" id="btcs_qty_{{variantFirstId}}" onchange="updatePriceText(this, {{regularPrice}}, {{comparePrice}}, this.value, {{variantFirstId}})" {{bottleQtys}} {{caseSixQtys}} {{caseTwelveQtys}}>' +
		"{{typeQtys}}" +
		"</select>" +
		"</div>" +
		'<div class="type-options">' +
		'<select class="select {{is_show}} {{selectSingle}}" id="type_{{variantFirstId}}" data-regular-price="{{regularPrice}}" data-compare-price="{{comparePrice}}" onchange="updateQty(this, {{variantFirstId}})">' +
		"{{typeOptions}}" +
		"</select>" +
		"</div>" +
		"</div>" +
		"</div>" +
		"</div>" +
		"</div>" +
		"</div>" +
		'<div class="per-bottle-html" data-listPrice="{{listPrice}}">' +
		'<div id="listprice_{{variantFirstId}}" data-tier={{_per_bottle_html_code}}>{{_per_bottle_html}}</div>' +
		'<div id ="listprice1_{{variantFirstId}}" data-tier="{{_per_bottle_html_code1}}">{{_per_bottle_html_2}}</div>' +
		"</div>" +
		"</div>" +
		"</div>" +
		'<div class="bold_qb_grid" data-variant-id="{{data_variant_id}}"></div>' +
		"</div>" +
		"{{mixedCaseButton}}" +
		'<button {{isAddProductDisabled}} id="btn_list_{{variantFirstId}}" title="{{buttonText}}" class="btn btn-action card-btn {{buttonAdded}}" onclick="addProductToCart(dataCart, this, {{variantFirstId}},\'{{itemTitleInCart}}\', \'{{producer}}\', {{isBundlebuilder}})">' +
		"<span>{{buttonText}}</span>" +
		"</button>" +
		"</div>" +
		"</div>",

	// Pagination Template
	previousActiveHtml:
		'<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></a></li>',
	previousDisabledHtml:
		'<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-left" viewBox="0 0 20 8"><path d="M4.814 7.555C3.95 6.61 3.2 5.893 2.568 5.4 1.937 4.91 1.341 4.544.781 4.303v-.44a9.933 9.933 0 0 0 1.875-1.196c.606-.485 1.328-1.196 2.168-2.134h.752c-.612 1.309-1.253 2.315-1.924 3.018H19.23v.986H3.652c.495.632.84 1.1 1.036 1.406.195.306.485.843.869 1.612h-.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Previous</span></div></li>',
	nextActiveHtml:
		'<li><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></a></li>',
	nextDisabledHtml:
		'<li><div class="btn btn--secondary btn--narrow btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-arrow-right" viewBox="0 0 20 8"><path d="M15.186.445c.865.944 1.614 1.662 2.246 2.154.631.491 1.227.857 1.787 1.098v.44a9.933 9.933 0 0 0-1.875 1.196c-.606.485-1.328 1.196-2.168 2.134h-.752c.612-1.309 1.253-2.315 1.924-3.018H.77v-.986h15.577c-.495-.632-.84-1.1-1.035-1.406-.196-.306-.486-.843-.87-1.612h.743z" fill="#000" fill-rule="evenodd"></path></svg><span class="icon__fallback-text">Next</span></div></li>',
	paginateHtml:
		'<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',

	// Sorting Template
	sortingHtml:
		'<label class="label--hidden">' +
		bcSfFilterConfig.label.sorting +
		'</label><select class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function (data) {
	//console.log(data);
	/*** Prepare data ***/
	if (sessionStorage.getItem("firstLoad") == 2) {
		dataCart = (function () {
			var jqXHR = jQ.ajax({
				url: "/cart.js",
				async: false,
			});
			var data = JSON.parse(jqXHR.responseText);
			return data;
		})();
		sessionStorage.setItem("firstLoad", 1);
	}
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data["variants"][0];
	if (getParam("variant") !== null && getParam("variant") != "") {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam("variant");
		});
		if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data["variants"].length; i++) {
			if (data["variants"][i].available) {
				firstVariant = data["variants"][i];
				break;
			}
		}
	}
	//console.log(data);
	var itemTags = data.tags;

	var is_case6 = false,
		is_case12 = false;
	var is_bottle = false;
	if (itemTags.indexOf("case: 6") >= 0) {
		is_case6 = true;
	}
	if (itemTags.indexOf("case: 12") >= 0) {
		is_case12 = true;
	}
	if (
		itemTags.indexOf("bottle") >= 0 ||
		(is_case6 != true && is_case12 != true)
	) {
		is_bottle = true;
	}
	if (is_case6 == false && is_case12 == false) var itemQtys = 0;
	else
		var itemQtys = data["variants"][0].inventory_quantity
			? data["variants"][0].inventory_quantity
			: "0";

	var priceDescription = "";
	/*** End Prepare data ***/
	//console.log(data);
	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	if (data.template_suffix == "subscription") {
		is_bottle = false;
		if (
			data["variants"][0].id == "23844343119953" ||
			data["variants"][0].id == "23844338171985" ||
			data["variants"][0].id == "23844330242129"
		) {
			(is_case6 = true), (is_case12 = false);
		} else {
			(is_case6 = false), (is_case12 = true);
		}
	}

	// Add a specific class for grid item
	var itemGridWidthClass = "";
	var imageSize = "600x600";

	switch (bcSfFilterConfig.custom.products_per_row) {
		case 2:
			itemGridWidthClass = "medium-up--one-half";
			imageSize = "540x600";
			break;
		case 3:
			itemGridWidthClass = "small--one-half medium-up--one-third";
			imageSize = "345x550";
			break;
		case 4:
			itemGridWidthClass = "small--one-half medium-up--one-quarter";
			imageSize = "250x";
			break;
		case 5:
			itemGridWidthClass = "small--one-half medium-up--one-fifth";
			imageSize = "195x";
			break;
	}
	itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

	// Add soldOut class
	var itemSoldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : "";
	itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

	// Add soldOut label
	var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelGridHtml : "";
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

	var imgId = "ProductCardImage-" + data.id;
	var wrapperId = "ProductCardImageWrapper-" + data.id;
	//console.log(itemTags);
	//Add producer

	var iconVeganPro = (iconOrganicPro = iconBiodynamicPro = iconAwardHtml = "");
	for (itemTag of itemTags) {
		if (itemTag.indexOf("vegan") >= 0 || itemTag.indexOf("Vegan") >= 0) {
			var iconVeganUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/vegan-icon.png?115137";
			iconVeganPro =
				'<div class="icon-vegan-pro"><div class="item-vegan"><img src="' +
				iconVeganUrl +
				'" alt="Vegan" title="Vegan"></div></div>';
		}
		if (itemTag.indexOf("organic") >= 0 || itemTag.indexOf("Organic") >= 0) {
			var iconOrganicUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/Organic_80593388-8979-497d-9736-7ede4b5a2a8a.png?117071";
			iconOrganicPro =
				'<div class="icon-vegan-pro"><div class="item-vegan"><img src="' +
				iconOrganicUrl +
				'" alt="Vegan" title="Vegan"></div></div>';
		}
		if (
			itemTag.indexOf("biodynamic") >= 0 ||
			itemTag.indexOf("Biodynamic") >= 0
		) {
			var iconBioUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/biodynamic_63b1ecde-348d-4cb3-a83d-5ee762654414.png?117071";
			iconBiodynamicPro =
				'<div class="icon-vegan-pro"><div class="item-vegan"><img src="' +
				iconBioUrl +
				'" alt="Vegan" title="Vegan"></div></div>';
		}
		if (itemTag.indexOf("award") >= 0 || itemTag.indexOf("Award") >= 0) {
			var iconAwardUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/award_3x_7cd0c5c8-6666-4886-8a36-0c8062e16dbc.png?112431";
			iconAwardHtml =
				'<div class="award-icon"><div class="award-icon-product"><img src="' +
				iconAwardUrl +
				'" alt="Award" title="Award"></div></div>';
		}
	}

	if (iconBiodynamicPro != "") {
		itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, iconBiodynamicPro);
	} else {
		if (iconOrganicPro != "") {
			itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, iconOrganicPro);
		} else {
			if (iconVeganPro != "") {
				itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, iconVeganPro);
			} else {
				itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, "");
			}
		}
	}

	itemHtml = itemHtml.replace(/{{iconAward}}/g, iconAwardHtml);

	var producerText = "";
	for (var i = 0; i < itemTags.length; i++) {
		if (itemTags[i].indexOf("producer") >= 0) {
			var producerArray = itemTags[i].split(":");
			producerText = producerArray[1];
		}
	}

	itemHtml = itemHtml.replace(/{{producer}}/g, producerText);

	// Build Image style
	var imageStyle = buildImageStyle(data);
	itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

	if (data["variants"][0].available) {
		if (is_case6 == true && is_case12 == false) {
			itemQtys = 6;
		} else {
			itemQtys = 12;
		}
	}

	/* var dataCart = (function() {
		var jqXHR = jQ.ajax({
			url: '/cart.js',
			async: false
		});
		var data = JSON.parse(jqXHR.responseText);
		return data;
	})(); */
	var itemBottleQty = getQuantityItem(
		dataCart,
		data.variants[0].id,
		"bottle",
		itemQtys
	);
	var handleProduct = data.handle;
	if (typeof minMaxify != "undefined")
		var minMaxQty = minMaxify.getLimitsFor({ handle: handleProduct });
	/* if(itemBottleQty < minMaxQty.min && itemBottleQty <= 0) {
	itemHtml = itemHtml.replace(/{{itemBottleQty}}/g, minMaxQty.min);
	} else {
	itemHtml = itemHtml.replace(/{{itemBottleQty}}/g, itemBottleQty);
	} */

	if (itemBottleQty > 0)
		itemHtml = itemHtml.replace(/{{itemBottleQty}}/g, itemBottleQty);
	else itemHtml = itemHtml.replace(/{{itemBottleQty}}/g, 0);

	var inventory_policy = data.variants[0].inventory_policy;

	var maxQty = data.variants[0].inventory_quantity;
	if (data.variants[0].available) {
		if (maxQty <= 0) maxQty = 24;
	}

	if (maxQty < 24 && inventory_policy == "continue") {
		maxQty = 24;
	}

	var countAvailableInfo = 0;
	if (is_bottle == false) countAvailableInfo += 1;
	if (typeof minMaxQty != "undefined") {
		if (countAvailableInfo == 0)
			if (minMaxQty.multiple > 1) countAvailableInfo += 1;
		if (countAvailableInfo == 0) if (minMaxQty.min > 1) countAvailableInfo += 1;
		if (minMaxQty.max > 0) countAvailableInfo += 1;
	}
	var countAvailableClass = "";

	if (countAvailableInfo == 1) countAvailableClass = "single-item";
	if (countAvailableInfo == 2) countAvailableClass = "double-items";
	var onlyAvailable = "";
	if (is_bottle == false) {
		onlyAvailable +=
			'<div class="only-available-section ' + countAvailableClass + '">';
		onlyAvailable +=
			'<div class="only-available 1 multiples">Only available in multiples of ' +
			itemQtys +
			"</div>";
	}
	if (typeof minMaxQty != "undefined") {
		if (onlyAvailable == "")
			onlyAvailable =
				'<div class="only-available-section ' + countAvailableClass + '">';
		if (minMaxQty.multiple > 1) {
			onlyAvailable =
				'<div class="only-available-section ' + countAvailableClass + '">';
			onlyAvailable +=
				'<div class="only-available 2 multiples">Only available in multiples of ' +
				minMaxQty.multiple +
				"</div>";
		}
		if (minMaxQty.min > 1 && is_bottle == true && minMaxQty.multiple <= 1) {
			onlyAvailable +=
				'<div class="only-available minimum">Only available in minimum of ' +
				minMaxQty.min +
				"</div>";
		}
		if (minMaxQty.max > 0) {
			onlyAvailable +=
				'<div class="only-available maximum">Maximum order of ' +
				minMaxQty.max +
				" per customer</div>";
		}
	}

	if (onlyAvailable != "") onlyAvailable += "</div>";

	itemHtml = itemHtml.replace(/{{onlyAvailable}}/g, onlyAvailable);

	if (typeof minMaxQty != "undefined") {
		itemHtml = itemHtml.replace(/{{minQtyBottle}}/g, minMaxQty.min);
		if (minMaxQty.max > 0) {
			if (minMaxQty.max < maxQty) maxQty = minMaxQty.max;
			itemHtml = itemHtml.replace(/{{maxQtyBottle}}/g, maxQty);
			var maxCaseQty = Math.floor(maxQty / itemQtys);
			itemHtml = itemHtml.replace(/{{maxQtyCase}}/g, maxQty);
		} else {
			itemHtml = itemHtml.replace(/{{maxQtyBottle}}/g, maxQty);
			itemHtml = itemHtml.replace(/{{maxQtyCase}}/g, maxQty);
		}
		var minCaseQty = Math.ceil(minMaxQty.min / itemQtys);
		itemHtml = itemHtml.replace(/{{minQtyCase}}/g, minMaxQty.min);
	} else {
		itemHtml = itemHtml.replace(/{{minQtyBottle}}/g, 1);
		itemHtml = itemHtml.replace(/{{minQtyCase}}/g, 1);
		itemHtml = itemHtml.replace(/{{maxQtyBottle}}/g, maxQty);
		itemHtml = itemHtml.replace(/{{maxQtyCase}}/g, maxQty);
	}

	var itemCaseQty = getQuantityItem(
		dataCart,
		data.variants[0].id,
		"case",
		itemQtys
	);
	itemHtml = itemHtml.replace(/{{itemCaseQty}}/g, itemCaseQty);
	var subtotalPriceitem = "";

	var currentCaseQty = parseInt(itemQtys) * parseInt(itemCaseQty);

	if (itemBottleQty > 0) {
		itemHtml = itemHtml.replace(/{{disabledBtClass}}/g, "");
	} else {
		itemHtml = itemHtml.replace(/{{disabledBtClass}}/g, "disabled");
	}
	if (typeof minMaxQty != "undefined") {
		itemHtml = itemHtml.replace(/{{stepQtyBottle}}/g, minMaxQty.multiple);
	} else {
		itemHtml = itemHtml.replace(/{{stepQtyBottle}}/g, "1");
	}
	var nextQty =
		itemQtys + getQuantityItem(dataCart, data.variants[0].id, "bottle", 0);
	if (nextQty > maxQty)
		itemHtml = itemHtml.replace(/{{disabledCsIncreaseClass}}/g, "disabled");
	else itemHtml = itemHtml.replace(/{{disabledCsIncreaseClass}}/g, "");

	if (itemCaseQty > 0) {
		itemHtml = itemHtml.replace(/{{disabledCsClass}}/g, "");
	} else {
		itemHtml = itemHtml.replace(/{{disabledCsClass}}/g, "disabled");
	}

	if (itemBottleQty > 0 || itemCaseQty > 0) {
		if (itemCaseQty * itemQtys + itemBottleQty + 1 > maxQty) {
			itemHtml = itemHtml.replace(/{{disabledBtIncClass}}/g, "disabled");
		} else {
			itemHtml = itemHtml.replace(/{{disabledBtIncClass}}/g, "");
		}

		if ((itemCaseQty + 1) * itemQtys + itemBottleQty > maxQty) {
			itemHtml = itemHtml.replace(/{{disabledCsClass}}/g, "disabled");
		} else {
			itemHtml = itemHtml.replace(/{{disabledCsClass}}/g, "");
		}
	}

	//console.log(itemBottleQty +'--'+itemCaseQty+'---'+itemQtys);
	var buttonTitle = "";
	if (itemBottleQty > 0 || itemCaseQty > 0) {
		if (itemBottleQty != "") {
			if (itemBottleQty > 0) {
				if (itemCaseQty != "" && itemCaseQty > 0) {
					subtotalPriceitem = bcsffilter.formatMoney(
						data.price_min * itemBottleQty + data.price_min * currentCaseQty,
						bcsffilter.moneyFormat
					);
				} else {
					subtotalPriceitem = bcsffilter.formatMoney(
						data.price_min * itemBottleQty,
						bcsffilter.moneyFormat
					);
				}
			} else {
				if (itemCaseQty != "" && itemCaseQty > 0) {
					subtotalPriceitem = bcsffilter.formatMoney(
						data.price_min * currentCaseQty,
						bcsffilter.moneyFormat
					);
				} else {
					subtotalPriceitem = bcsffilter.formatMoney(0, bcsffilter.moneyFormat);
				}
			}
		} else {
			if (itemCaseQty != "" && itemCaseQty > 0) {
				subtotalPriceitem = bcsffilter.formatMoney(
					data.price_min * currentCaseQty,
					bcsffilter.moneyFormat
				);
			} else {
				subtotalPriceitem = bcsffilter.formatMoney(0, bcsffilter.moneyFormat);
			}
		}
		itemHtml = itemHtml.replace(/{{subtotalPriceitem}}/g, subtotalPriceitem);

		itemHtml = itemHtml.replace(/{{customClass}}/g, "btn-viewcart");
		itemHtml = itemHtml.replace(/{{is_active}}/g, "active");
		itemHtml = itemHtml.replace(/{{is_added}}/g, "added");
		buttonTitle = "View Cart";
	} else {
		itemHtml = itemHtml.replace(/{{customClass}}/g, "");
		itemHtml = itemHtml.replace(/{{is_active}}/g, "");
		itemHtml = itemHtml.replace(/{{is_added}}/g, "");
		buttonTitle = "Add to cart";

		itemHtml = itemHtml.replace(/{{subtotalPriceitem}}/g, "$0.00");
	}

	var mixedCaseButton = "";
	if (data.template_suffix == "bundlebuilder") {
		mixedCaseButton =
			'<a class="btn btn-action card-btn mixed-case-button" href="/products/' +
			data.handle +
			'"><span>SEE MORE</span></a>';
	}
	itemHtml = itemHtml.replace(/{{mixedCaseButton}}/g, mixedCaseButton);

	var inventory_policy = data["variants"][0].inventory_policy;

	if (!data["variants"][0].available && inventory_policy != "continue") {
		soldOut = true;
	} else {
		var inventory_quantity = data["variants"][0].inventory_quantity;
		if (data["variants"][0].inventory_quantity <= 0) {
			inventory_quantity = 24;
		}
		if (is_bottle == false) {
			if (is_case6 == false) {
				if (typeof minMaxQty != "undefined") {
					if (
						minMaxQty.min > 1 &&
						inventory_quantity < minMaxQty.min &&
						inventory_policy != "continue"
					) {
						soldOut = true;
					} else if (
						is_case12 == true &&
						inventory_quantity < 12 &&
						inventory_policy != "continue"
					) {
						soldOut = true;
					}
				} else {
					if (
						is_case12 == true &&
						inventory_quantity < 12 &&
						inventory_policy != "continue"
					) {
						soldOut = true;
					}
				}
			} else {
				if (typeof minMaxQty != "undefined") {
					if (
						minMaxQty.min > 1 &&
						inventory_quantity < minMaxQty.min &&
						inventory_policy != "continue"
					) {
						soldOut = true;
					} else if (
						is_case12 == false &&
						inventory_quantity < 6 &&
						inventory_policy != "continue"
					) {
						soldOut = true;
					}
				} else {
					if (is_case12 == false && inventory_policy != "continue") {
						if (inventory_quantity < 6 && inventory_policy != "continue") {
							soldOut = true;
						}
					}
				}
			}
		}
	}

	// Disabled button when sold out isAddProductDisabled
	if (soldOut) {
		buttonTitle = "SOLD OUT";
		itemHtml = itemHtml.replace(
			/{{isAddProductDisabled}}/g,
			'disabled="disabled"'
		);
	} else {
		itemHtml = itemHtml.replace(/{{isAddProductDisabled}}/g, "");
	}

	itemHtml = itemHtml.replace(/{{buttonTitle}}/g, buttonTitle);

	// Add Class bundlebuilder
	if (data.template_suffix == "bundlebuilder") {
		itemHtml = itemHtml.replace(/{{bundlebuilder}}/g, " bundlebuilder");
		itemHtml = itemHtml.replace(/{{isBundlebuilder}}/g, true);
	} else {
		itemHtml = itemHtml.replace(/{{isBundlebuilder}}/g, false);
	}

	// Add Images
	var aspect_ratio = "";
	var itemImagesHtml =
		'<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
	itemImagesHtml +=
		'<img id="' +
		imgId +
		'" ' +
		'class="grid-view-item__image lazyload" ' +
		'src="' +
		this.getFeaturedImage(images, "204x204") +
		'" ' +
		'data-src="' +
		this.getFeaturedImage(images, "{width}x") +
		'" ' +
		'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
		'data-aspectratio="' +
		aspect_ratio +
		'" ' +
		'data-sizes="auto" ' +
		'alt="{{itemTitle}}">';
	itemImagesHtml += "</div>";

	var image_size =
		bcSfFilterConfig.custom.max_height +
		"x" +
		bcSfFilterConfig.custom.max_height;
	var max_width =
		images.length > 0 ? bcSfFilterConfig.custom.max_height * aspect_ratio : 0;
	itemImagesHtml +=
		'<noscript><img class="grid-view-item__image" src="' +
		this.getFeaturedImage(images, image_size + "@2x") +
		'" alt="{{itemTitle}}" style="max-width: ' +
		max_width +
		'px;"></noscript>';
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Icons
	var itemIconsHtml = '<div class="icon-for-reviews">';
	var countReviews = 0;
	var sumaryRevies = 0;
	var reviewArray = [];

	for (itemTag of itemTags) {
		if (itemTag.indexOf("review") >= 0 && itemTag.indexOf("|") >= 0) {
			var tagArray = itemTag.split("|");
			reviewArray.push(tagArray[1]);
		}
	}

	reviewArray.sort(function (a, b) {
		if (parseInt(a.split("/")[1]) > parseInt(b.split("/")[1])) {
			return -1;
		} else {
			return 1;
		}
	});

	for (reviewItem of reviewArray) {
		var tagArrayValues = reviewItem.split("/");
		var criticName = tagArrayValues[0].replace("_", " ");
		var criticPoints = tagArrayValues[1];
		var criticDate = tagArrayValues[2].split(".");
		var month = "";
		switch (criticDate[1]) {
			case 1:
				month = "January";
				break;
			case 2:
				month = "February";
				break;
			case 3:
				month = "March";
				break;
			case 4:
				month = "April";
				break;
			case 5:
				month = "May";
				break;
			case 6:
				month = "June";
				break;
			case 7:
				month = "July";
				break;
			case 8:
				month = "August";
				break;
			case 9:
				month = "September";
				break;
			case 10:
				month = "October";
				break;
			case 11:
				month = "November";
				break;
			default:
				month = "December";
		}
		var criticDateText = month + " " + criticDate[2];
		itemIconsHtml +=
			'<div class="icon-review" data-point="' + criticPoints + '">';
		itemIconsHtml +=
			'<div class="box-review-top size-' + criticName.length + '">';
		itemIconsHtml +=
			'<span class="critic-name" aria-label="' + criticName + '">';
		for (var k = 0; k < criticName.length; k++) {
			itemIconsHtml +=
				'<span class="char' +
				(k + 1) +
				'" aria-hidden="true">' +
				criticName.charAt(k) +
				"</span>";
		}
		itemIconsHtml += "</span>";
		itemIconsHtml += "</div>";

		itemIconsHtml += '<div class="box-review-middle">';
		itemIconsHtml +=
			'<span class="critic-point">' +
			criticPoints +
			" <br /><em>points</em></span>";
		itemIconsHtml += "</div>";

		itemIconsHtml +=
			'<div class="box-review-bottom size-' + criticDateText.length + '">';
		itemIconsHtml += '<span class="critic-date ">';
		for (var k = 0; k < criticDateText.length; k++) {
			itemIconsHtml +=
				'<span class="char' +
				(k + 1) +
				'" aria-hidden="true">' +
				criticDateText.charAt(k) +
				"</span>";
		}
		itemIconsHtml += "</span>";
		itemIconsHtml += "</div>";
		itemIconsHtml += "</div>";
		countReviews++;
	}

	itemIconsHtml += "</div>";

	itemHtml = itemHtml.replace(/{{itemIcons}}/g, itemIconsHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable
		? bcSfFilterTemplate.vendorGridHtml
		: "";
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add Price
	//var itemPriceHtml = buildPrice(data, onSale, priceVaries);

	var itemAdded = getQuantityBottle(dataCart, data.variants[0].id);
	//{{buttonText}}
	//console.log('itemAdded: '+itemAdded);
	var buttonText = "Add to cart";
	if (itemAdded > 0) {
		buttonText = "Update to cart";
		itemHtml = itemHtml = itemHtml.replace(
			/{{buttonAdded}}/g,
			"btn-added-list"
		);
	}
	
	if (soldOut) {
		buttonText = "SOLD OUT";
		itemHtml = itemHtml = itemHtml.replace(
			/{{isAddProductDisabled}}/g,
			'disabled="disabled"'
		);
	} else {
		itemHtml = itemHtml = itemHtml.replace(/{{isAddProductDisabled}}/g, "");
	}
	itemHtml = itemHtml.replace(/{{buttonText}}/g, buttonText);

	if (typeof minMaxQty != "undefined") {
		itemHtml = itemHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		if (minMaxQty.min > 1) {
			var itemPriceHtml = buildPriceForList(
				data,
				onSale,
				priceVaries,
				minMaxQty.min,
				0
			);
		} else {
			if (is_bottle == true) {
				var itemPriceHtml = buildPriceForList(data, onSale, priceVaries, 1, 0);
			} else {
				if (is_case6 == true) {
					var itemPriceHtml = buildPriceForList(
						data,
						onSale,
						priceVaries,
						6,
						0
					);
				}
				if (is_case12 == true) {
					var itemPriceHtml = buildPriceForList(
						data,
						onSale,
						priceVaries,
						12,
						0
					);
				}
			}
		}
		if (minMaxQty.max > 0 && minMaxQty.max < itemQtys) {
			itemHtml = itemHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
		} else {
			itemHtml = itemHtml.replace(/{{maxSelectQty}}/g, itemQtys);
		}
	} else {
		var itemPriceHtml = buildPriceForList(data, onSale, priceVaries, 1, 0);
	}

	var inventory_policy = data["variants"][0].inventory_policy;
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add data json
	var self = this;
	var itemJson = {
		id: data.id,
		title: data.title,
		handle: data.handle,
		vendor: data.vendor,
		variants: data.variants,
		url: self.buildProductItemUrl(data),
		options_with_values: data.options_with_values,
		images: data.images,
		available: data.available,
		price_min: data.price_min,
		price_max: data.price_max,
		compare_at_price_min: data.compare_at_price_min,
		compare_at_price_max: data.compare_at_price_max,
	};
	itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(
		/{{itemTitleInCart}}/g,
		data.title.replace(/'/g, "&quot;")
	);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/products/" + data.handle);

	if ((is_case6 == true || is_case12 == true) && is_bottle == true) {
		itemHtml = itemHtml.replace(/{{showBottle}}/g, "show");
		itemHtml = itemHtml.replace(/{{showCase}}/g, "show");
	} else if ((is_case6 == true || is_case12 == true) && is_bottle == false) {
		itemHtml = itemHtml.replace(/{{showBottle}}/g, "hide");
		itemHtml = itemHtml.replace(/{{showCase}}/g, "show");
	} else if ((is_case6 == false || is_case12 == false) && is_bottle == true) {
		itemHtml = itemHtml.replace(/{{showBottle}}/g, "show");
		itemHtml = itemHtml.replace(/{{showCase}}/g, "hide");
	} else {
		itemHtml = itemHtml.replace(/{{showBottle}}/g, "show");
		itemHtml = itemHtml.replace(/{{showCase}}/g, "hide");
	}

	itemHtml = itemHtml.replace(
		/{{bottlePrice}}/g,
		'data-price="' + data.price_min + '"'
	);
	itemHtml = itemHtml.replace(
		/{{caseQtys}}/g,
		'data-caseqty="' + itemQtys + '"'
	);
	itemHtml = itemHtml.replace(
		/{{casePrice}}/g,
		'data-price="' + itemQtys * data.price_min + '"'
	);

	// Build quantityProduct block
	var qtyblock = buildquantityProduct(data);
	itemHtml = itemHtml.replace(/{{quantityProduct}}/g, qtyblock);

	//Sale percent in product grid page
	if (data.compare_at_price_max > data.price_max) {
		var salePercent = Math.round(
			100 - (data.price_max / data.compare_at_price_max) * 100
		);
		var perBottles = 0;
		if ("bundlebuilder" == data.template_suffix) {
			//perBottles = '<p class="per-bottle">'+ bcsffilter.formatMoney(parseFloat(data.price_min / 12, 2), bcsffilter.moneyFormat) +' per bottle</p>';
			perBottles = "";
			itemHtml = itemHtml.replace(
				/{{salePercent}}/g,
				perBottles +
					'<p class="sale-percent-list"><span class="compare-at-price">' +
					bcsffilter.formatMoney(
						parseFloat(data.compare_at_price_max),
						bcsffilter.moneyFormat
					) +
					"</span><span><span>" +
					salePercent +
					"</span><span>% Off</span></span></p>"
			);
		} else {
			itemHtml = itemHtml.replace(
				/{{salePercent}}/g,
				'<p class="price-per-bottle"><span class="b-price" id="pricebottle">' +
					bcsffilter.formatMoney(
						parseFloat(data.price_max),
						bcsffilter.moneyFormat
					) +
					'</span><span class="compare-at-price">' +
					bcsffilter.formatMoney(
						parseFloat(data.compare_at_price_max),
						bcsffilter.moneyFormat
					) +
					'</span><span>per bottle</span></p><p class="sale-percent-list"><span><span>' +
					salePercent +
					"</span><span>% Off</span></span></p>"
			);
		}
	} else {
		itemHtml = itemHtml.replace(
			/{{salePercent}}/g,
			'<p class="price-per-bottle"><span class="b-price">' +
				bcsffilter.formatMoney(
					parseFloat(data.price_max),
					bcsffilter.moneyFormat
				) +
				"</span><span>per bottle</span></p>"
		);
	}

	return itemHtml;
};
// Build quantity block
function buildquantityProduct(data){
	var qtyHtml = '';
	var canAdd = true;
	var productAvailable = true;
	var disabledOption = '';
	var addedQty = getQuantityBottle(dataCart, data.variants[0].id);
	var itemTags = data.tags;
	var handleProduct = data.handle;
	if (typeof minMaxify != "undefined"){
		var minMaxQty = minMaxify.getLimitsFor({ handle: handleProduct });
	}
	console.log("the min is ", minMaxQty);

	
	//console.log(itemTags);
	if(data.variants[0].available){
		if(data.variants[0].inventory_quantity > 0){
			var inventory_quantity_max = data.variants[0].inventory_quantity;
			if(inventory_quantity_max < 24 && variant.inventory_policy == "continue"){
				inventory_quantity_max = 24;
			}
		}else{
			inventory_quantity_max = 24;
		}
	}
	qtyHtml += '<input type="hidden" id="btcs_list_'+ data.variants[0].id +'" name="btcs_list_'+ data.variants[0].id +'" value="{{initialValue}}">';
	qtyHtml += '<input type="hidden" id="Quantity-product-form" name="quantity" value="1" max="'+ inventory_quantity_max +'" min="1" data-added="'+ addedQty +' class="product-form__input" pattern="[0-9]*" data-quantity-input data-price="'+ data.price +'">';
	if(itemTags.indexOf("bottle") >= 0){
		qtyHtml += '<div class="product-form-quantity product-form-quantity-bottle-case">';
		qtyHtml += '<select class="quantity select-quantity-bottle" min="{{minSelectQty}}" max="{{maxSelectQty}}" policy="{{inventoryPolicy}}" id="btcs_qty_{{variantFirstId}}" onchange="updatePriceText(this, {{regularPrice}}, {{comparePrice}}, this.value, {{variantFirstId}})" {{bottleQtys}} {{caseSixQtys}} {{caseTwelveQtys}}">';
		for(variant of data.variants){
			if(data.available){
				if(variant.inventory_quantity > 0){
					var inventory_quantity = variant.inventory_quantity;
					if(inventory_quantity < 24 && variant.inventory_policy == "continue"){
						inventory_quantity = 24;
					}
				}else{
					var inventory_quantity = 24;
				}
				if(addedQty <= inventory_quantity){
					var maxCanAdd = inventory_quantity + addedQty;
				}else{
					canAdd = false;
					var inventory_quantity = 1;
				}

			}else{
				var inventory_quantity = 1;
				productAvailable = false;
			}
			var selected = '';
			var disabled = '';
			
			qtyHtml = qtyHtml.replace(/{{initialValue}}/g, minMaxQty.min);

			qtyHtml = qtyHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		
				if (minMaxQty.max == 0){
					qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, inventory_quantity);
				}
				else if (minMaxQty.max >0) {
				qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
				}
				
				qtyHtml = qtyHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);

			if (minMaxQty.max > 1){
				inventory_quantity = minMaxQty.max;
			}

			for (i = 1; i <= inventory_quantity; i++ ){
				if(i > maxCanAdd){
					disabled = 'disabled';
				}
				if(maxCanAdd <= 1 &&  i == 1){
					selected = 'selected="selected"';
				}
				console.log("minnnn", minMaxQty.min);

			
				if (i >= minMaxQty.min &&  minMaxQty.min > 1) {
				qtyHtml += '<option value="'+ i +'" ' + ' '+ disabled + ' ' + selected +'>'+ i +'</option>';
			}
			else if (minMaxQty.min <= 1) {
				qtyHtml += '<option value="'+ i +'" ' + ' '+ disabled + ' ' + selected +'>'+ i +'</option>';
			}
			}
		}
		qtyHtml += '</select>';
		if (itemTags.indexOf("case: 6") >= 0 || itemTags.indexOf("case:6") >= 0) {
			qtyHtml += '<select class="quantity select-quantity-case" style="display: none;" min="{{minSelectQty}}" max="{{maxSelectQty}}" policy="{{inventoryPolicy}}" id="btcs_qty_{{variantFirstId}}" onchange="updatePriceText(this, {{regularPrice}}, {{comparePrice}}, this.value, {{variantFirstId}})" {{bottleQtys}} {{caseSixQtys}} {{caseTwelveQtys}}">';
			var itemTags = data.tags;

			var is_case6 = false,
				is_case12 = false;
			var is_bottle = false;
			if (itemTags.indexOf("case: 6") >= 0) {
				is_case6 = true;
			}
			if (itemTags.indexOf("case: 12") >= 0) {
				is_case12 = true;
			}
			if (
				itemTags.indexOf("bottle") >= 0 ||
				(is_case6 != true && is_case12 != true)
			) {
				is_bottle = true;
			}		

			var itemQtys = 1;		
				if (is_case12 == true ){
				itemQtys = 12;
			}			
			if (is_case6 == true){
				itemQtys = 6
			}
			if (is_bottle == true){
				itemQtys = 1;
			}

			var caseTwelveQtys;
			var caseSixQtys;
			var bottleQtys;

			if (itemQtys < 1) itemQtys = 1;
			if (itemQtys > 0) {
				if (is_bottle == true) {
					bottleQtys = 'data-bottle="' + itemQtys + '"';
					//priceDescription = '<p class="per-bottle">'+ bcsffilter.formatMoney(data.price, bcsffilter.moneyFormat) +' per bottle</p>';
				}
				if (is_case6 == true) {
					caseSixQtys = 'data-case6="' + parseInt(itemQtys / 6) + '"';
				}
				if (is_case12 == true) {
					caseTwelveQtys = 'data-case12="' + parseInt(itemQtys / 12) + '"';
				}
				qtyHtml = qtyHtml.replace(/{{bottleQtys}}/g, bottleQtys);
				qtyHtml = qtyHtml.replace(/{{caseSixQtys}}/g, caseSixQtys);
				qtyHtml = qtyHtml.replace(/{{caseTwelveQtys}}/g, caseTwelveQtys);
			}

			for(variant of data.variants){
				if (data.available) {
					if(variant.inventory_quantity > 0){
						var inventory_quantity = variant.inventory_quantity;
						if (variant.inventory_quantity < 24 || variant.inventory_policy == "continue") {
							inventory_quantity = 24
						}
					} else {
						var inventory_quantity = 24;
					}
					var newAdded = addedQty + 6;
					if(newAdded > inventory_quantity){
						canAdd = false;
					}else{
						var maxCanAdd = parseInt((inventory_quantity - addedQty) / 4);
					}
				}else{
					var inventory_quantity = 6;
				}
				var qty_bottles = parseInt(inventory_quantity / 6);
				var selected = '';
				var disabled = '';

				if (minMaxQty.max > 1){
					qty_bottles = parseInt(minMaxQty.max / 6);
				}

				for (i = 1; i <= qty_bottles;i++){
					if (variant.quantity || (maxCanAdd <= 1 && i == 1)) {
						selected = 'selected="selected"';
					}
					if(i > maxCanAdd){
						disabled = 'disabled';
					}
					qtyHtml += '<option value="'+ i*6 +'"'+ ' ' + disabled + ' ' + selected +'>' + i +'</option>';
				}
				qtyHtml = qtyHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		
				if (minMaxQty.max == 0){
					qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, inventory_quantity);
				}
				else if (minMaxQty.max >0) {
				qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
				}
				
				qtyHtml = qtyHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);

				//qtyHtml = qtyHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

			qtyHtml = qtyHtml.replace(
				/{{regularPrice}}/g,
			parseFloat(data.price_max) / 100
			);
			qtyHtml = qtyHtml.replace(
			/{{comparePrice}}/g,
			parseFloat(data.compare_at_price_max) / 100
		);
			}
			qtyHtml += '</select>';
			qtyHtml += '<select class="quantity-bottle-case quantity-bottle" onchange="changeTypeBottle(this)" data-price="'+ data.price +'">';
			qtyHtml += '<option value="bottle">Bottle(s)</option>';
			var disabled = '';
			if(canAdd == false){
				disabled = 'disabled';
			}
			qtyHtml += '<option value="case: 6" ' +  disabled + '>Case(s) of 6</option>';
			qtyHtml += '</select>';
		}else if(itemTags.indexOf("case: 12") >= 0){
			qtyHtml += '<select class="quantity select-quantity-case" style="display: none;" min="{{minSelectQty}}" max="{{maxSelectQty}}" policy="{{inventoryPolicy}}" id="btcs_qty_{{variantFirstId}}" onchange="updatePriceText(this, {{regularPrice}}, {{comparePrice}}, this.value, {{variantFirstId}})" {{bottleQtys}} {{caseSixQtys}} {{caseTwelveQtys}}">';
			for(variant of data.variants){
				if(data.available){
					if(variant.inventory_quantity > 0){
						var inventory_quantity = variant.inventory_quantity;
						if(variant.inventory_quantity < 24 && variant.inventory_policy == "continue"){
							inventory_quantity = 24
						}
					}else{
						var inventory_quantity = 24;
					}
					var newAdded = addedQty + 12;
					if(newAdded <= inventory_quantity){
						var maxCanAdd = parseInt((inventory_quantity - addedQty)/12);
					}else{
						var canAdd = false;
					}
				}else{
					var inventory_quantity = 12;
				}
				var qty_bottles = parseInt(inventory_quantity / 12);
				var selected = '';
				var disabled = '';
				for (i = 1; i <= qty_bottles;i++){
					if (variant.quantity || (maxCanAdd <= 1 && i == 1)) {
						selected = 'selected="selected"';
					}
					if(i > maxCanAdd){
						disabled = 'disabled';
					}
					qtyHtml += '<option value="'+ i*12 +'"'+ ' ' + disabled + ' ' + selected +'>' + i +'</option>';
				}
				qtyHtml = qtyHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		
				if (minMaxQty.max == 0){
					qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, inventory_quantity);
				}
				else if (minMaxQty.max >0) {
				qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
				}
				
				qtyHtml = qtyHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);
				
			}
			qtyHtml += '</select>';
			qtyHtml += '<select class="quantity-bottle-case quantity-bottle" onchange="changeTypeBottle(this)" data-price="'+ data.price +'">';
			qtyHtml += '<option value="bottle">Bottle(s)</option>';
			var disabled = '';
			if(canAdd == false){
				disabled = 'disabled';
			}
			qtyHtml += '<option value="case: 6"' +  disabled + '>Case(s) of 6</option>';
			qtyHtml += '</select>';
		}
		else{
			qtyHtml += '<span class="quantity-case">Bottle(s)</span>';
		}
		qtyHtml += '</div>';
	}
	else{
		qtyHtml += '<div class="product-form-quantity">';
		if(itemTags.indexOf("case: 6") >= 0){
			qtyHtml += '<select class="quantity select-quantity-case select-only-quantity-case" min="{{minSelectQty}}" max="{{maxSelectQty}}" policy="{{inventoryPolicy}}" id="btcs_qty_{{variantFirstId}}" onchange="updatePriceText(this, {{regularPrice}}, {{comparePrice}}, this.value, {{variantFirstId}})" {{bottleQtys}} {{caseSixQtys}} {{caseTwelveQtys}}">';
			for(variant of data.variants){
				if(data.available){
					if(variant.inventory_quantity > 0){
						var inventory_quantity = variant.inventory_quantity;
						if(variant.inventory_quantity < 24 && variant.inventory_policy == "continue"){
							inventory_quantity = 24;
						}
					}else{
						var inventory_quantity = 24;
					}
					if(inventory_quantity < 6){
						productAvailable = false;
						var inventory_quantity = 6;
					}
					var newAdded = addedQty + 6;
					if(newAdded <= inventory_quantity){
						var maxCanAdd = parseInt((inventory_quantity - addedQty) / 6);
					}else{
						var canAdd = false;
					}
				}else{
					var inventory_quantity = 6;
					productAvailable = false;
				}

				qtyHtml = qtyHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		
				if (minMaxQty.max == 0){
					qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, variant.inventory_quantity);
				}
				else if (minMaxQty.max >0) {
				qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
				}
				
				qtyHtml = qtyHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);

				var qty_bottles = parseInt(inventory_quantity / 6);
				if (qty_bottles < 1) {
					qty_bottles = 1;
					disabledOption = 'disabled'
				}else{
					disabledOption = '';
				}
				qtyHtml = qtyHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		
				if (minMaxQty.max == 0){
					qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, variant.inventory_quantity);
				}
				else if (minMaxQty.max >0) {
				qtyHtml = qtyHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
				}
				
				qtyHtml = qtyHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);

				var selected = '';
				var disabled = '';
				for (i = 1; i <= qty_bottles;i++){
					if (variant.quantity || (maxCanAdd <= 1 && i == 1)) {
						selected = 'selected="selected"';
					}
					if(i > maxCanAdd){
						disabled = 'disabled';
					}
					qtyHtml += '<option value="'+ i*6 +'"'+ ' ' + disabled + ' ' + selected +'>' + i +'</option>';
				}
			}
			qtyHtml += '</select>';
			qtyHtml += '<span class="quantity-case">Case(s) of 6</span>';
		}else if(itemTags.indexOf("case: 12") >= 0){
			qtyHtml += '<select class="quantity select-quantity-case select-only-quantity-case" min="{{minSelectQty}}" max="{{maxSelectQty}}" policy="{{inventoryPolicy}}" id="btcs_qty_{{variantFirstId}}" onchange="updatePriceText(this, {{regularPrice}}, {{comparePrice}}, this.value, {{variantFirstId}})" {{bottleQtys}} {{caseSixQtys}} {{caseTwelveQtys}}">';
			for(variant of data.variants){
				if(data.available){
					if(variant.inventory_quantity > 0){
						var inventory_quantity = variant.inventory_quantity;
						if(variant.inventory_quantity < 24 && variant.inventory_policy == "continue"){
							inventory_quantity = 24;
						}
					}else{
						var inventory_quantity = 24;
					}
					if(inventory_quantity < 12){
						productAvailable = false;
						var inventory_quantity = 12;
					}
					var newAdded = addedQty + 12;
					if(newAdded <= inventory_quantity){
						var maxCanAdd = parseInt((inventory_quantity - addedQty) / 12);
					}else{
						var canAdd = false;
					}
				}else{
					var inventory_quantity = 12;
					productAvailable = false;
				}

				var qty_bottles = parseInt(inventory_quantity / 12);
				if(qty_bottles < 1){
					qty_bottles = 1;
					disabledOption = 'disabled';
				}else{
					disabledOption = '';
				}

				var selected = '';
				var disabled = '';
				for (i = 1; i <= qty_bottles;i++){
					if (variant.quantity || (maxCanAdd <= 1 && i == 1)) {
						selected = 'selected="selected"';
					}
					if(i > maxCanAdd){
						disabled = 'disabled';
					}
					qtyHtml += '<option value="'+ i*12 +'"'+ ' ' + disabled + ' ' + selected +'>' + i +'</option>';
				}
			}
			qtyHtml += '</select>';
			qtyHtml += '<span class="quantity-case">Case(s) of 12</span>';
		}
		qtyHtml += '</div>';
	}
	var bottleClass = '';
	if (itemTags.indexOf("tier: 12") >= 0 || itemTags.indexOf("tier: 24") >= 0) {
		bottleClass = ' tier-tag';
	}
	qtyHtml += '<div class="per-bottle-html'+ bottleClass +'">';
	if(itemTags.indexOf("bottle") >= 0){
		qtyHtml += '<p id="gridprice_{{variantFirstId}}" style="margin: 5px 0;">' + Shopify.formatMoney(data.price) + ' per bottle</p>';
	}
	if(itemTags.indexOf("tier: 12") >= 0){
		qtyHtml += '<p  id="gridprice1_{{variantFirstId}}" data-tier={{price_tier1}} style="margin: 5px 0;" data-price="'+ Shopify.formatMoney(data.price * 0.95) +'">'+ Shopify.formatMoney(data.price * 0.95) +' per bottle on 12+ (save 5%)</p>';
	}
	if(itemTags.indexOf("tier: 24") >= 0){
		qtyHtml += '<p  id="gridprice2_{{variantFirstId}}" data-tier={{price_tier2}} style="margin: 5px 0;"  data-price="'+ Shopify.formatMoney(data.price * 0.90) +'">'+ Shopify.formatMoney(data.price * 0.90) + ' per bottle on 24+ (save 10%)</p>';
	}
	qtyHtml += '</div>';
	qtyHtml = qtyHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);

	
	var itemTags = data.tags;
	var is_tier12 = false,
		is_tier24 = false;
	var is_bottle = false;
	if (itemTags.indexOf("tier: 12") > 0 || itemTags.indexOf("tier: 12") === 0) {
		is_tier12 = true;
	}
	if (itemTags.indexOf("tier: 24") > 0 || itemTags.indexOf("tier: 24") === 0) {
		is_tier24 = true;
	}

	var price = data.price_max*0.01;
	var tier12price = price*0.95;
	var tier24price = price*0.90;
	
	if (is_tier12){
		
		qtyHtml = qtyHtml.replace(/{{price_tier1}}/g, "12" );

	}
	if (is_tier24){
		
		qtyHtml = qtyHtml.replace(/{{price_tier2}}/g, "24" );
	}
	return qtyHtml;

}
// Build Image style
function buildImageStyle(data) {
	var images = data.images_info;
	var imgId = "ProductCardImage-" + data.id;
	var wrapperId = "ProductCardImageWrapper-" + data.id;
	var imageStyle = "";
	if (images.length > 0) {
		var image = images[0];
		var width = bcSfFilterConfig.custom.max_height;
		var height = bcSfFilterConfig.custom.max_height;
		var aspect_ratio = image.width / image.height;
		var small_style = true;
		var container_aspect_ratio = (width * 1.0) / height;

		if (image.aspect_ratio < 1.0) {
			var maximum_width = height * aspect_ratio;
			if (image.height <= height) {
				var maximum_height = image.height;
				maximum_width = image.width;
			} else {
				var maximum_height = height;
			}
		} else if (aspect_ratio < container_aspect_ratio) {
			var maximum_height = height / aspect_ratio;
			if (image.height <= height) {
				var maximum_height = image.height;
				var maximum_width = image.width;
			} else {
				var maximum_height = height;
				var maximum_width = height * aspect_ratio;
			}
		} else {
			var maximum_height = height / aspect_ratio;
			if (image.width <= width) {
				maximum_height = image.height;
				var maximum_width = image.width;
			} else {
				var maximum_width = width;
				maximum_height = maximum_width / aspect_ratio;
			}
		}

		imageStyle += "<style>";
		if (small_style) imageStyle += "@media screen and (min-width: 750px) {";
		imageStyle +=
			"#" +
			imgId +
			" {" +
			"max-width: " +
			maximum_width +
			"px;" +
			"max-height: " +
			maximum_height +
			"px;" +
			"}" +
			"#" +
			wrapperId +
			" {" +
			"max-width: " +
			maximum_width +
			"px;" +
			"max-height: " +
			maximum_height +
			"px;" +
			"}";
		if (small_style) imageStyle += "}";

		if (small_style) {
			if (aspect_ratio < 1) {
				maximum_width = 750 * aspect_ratio;
			} else {
				if (image.width < 750) {
					maximum_width = image.width;
				} else {
					maximum_width = 750;
				}
			}
			imageStyle += "@media screen and (max-width: 749px) {";
			imageStyle +=
				"#" +
				imgId +
				" {" +
				"max-width: " +
				maximum_width +
				"px;" +
				"max-height: 750px;" +
				"}" +
				"#" +
				wrapperId +
				" {" +
				"max-width: " +
				maximum_width +
				"px;" +
				"}";
			imageStyle += "}";
		}
		imageStyle += "</style>";
	}
	return imageStyle;
}

BCSfFilter.prototype.buildProductListItem = function (data) {
	/*** Prepare data ***/
	//console.log(data);
	if (sessionStorage.getItem("firstLoad") == 2) {
		dataCart = (function () {
			var jqXHR = jQ.ajax({
				url: "/cart.js",
				async: false,
			});
			var data = JSON.parse(jqXHR.responseText);
			return data;
		})();
		sessionStorage.setItem("firstLoad", 1);
	}
	var images = data.images_info;
	// Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data["variants"][0];
	if (getParam("variant") !== null && getParam("variant") != "") {
		var paramVariant = data.variants.filter(function (e) {
			return e.id == getParam("variant");
		});
		if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data["variants"].length; i++) {
			if (data["variants"][i].available) {
				firstVariant = data["variants"][i];
				break;
			}
		}
	}
	var itemTags = data.tags;
	var is_case6 = false,
		is_case12 = false;
	var is_bottle = false;
	var is_number = 0;
	if (itemTags.indexOf("case: 6") > 0 || itemTags.indexOf("case: 6") === 0) {
		is_case6 = true;
		is_number = 1;
	}
	if (itemTags.indexOf("case: 12") > 0 || itemTags.indexOf("case: 12") === 0) {
		is_case12 = true;
		is_number = 1;
	}
	if (
		itemTags.indexOf("bottle") > 0 ||
		itemTags.indexOf("bottle") === 0 ||
		(itemTags.indexOf("case: 6") < 0 && itemTags.indexOf("case: 12") < 0)
	) {
		is_bottle = true;
		is_number = 1;
	}

	if (
		(itemTags.indexOf("case: 6") > 0 || itemTags.indexOf("case: 6") === 0) &&
		(itemTags.indexOf("bottle") > 0 || itemTags.indexOf("bottle") === 0)
	) {
		is_number = 2;
	}
	if (
		(itemTags.indexOf("case: 12") > 0 || itemTags.indexOf("case: 12") === 0) &&
		(itemTags.indexOf("bottle") > 0 || itemTags.indexOf("bottle") === 0)
	) {
		is_number = 2;
	}

	if (data.template_suffix == "subscription") {
		is_bottle = false;
		if (
			data["variants"][0].id == "23844343119953" ||
			data["variants"][0].id == "23844338171985" ||
			data["variants"][0].id == "23844330242129"
		) {
			(is_case6 = true), (is_case12 = false);
		} else {
			(is_case6 = false), (is_case12 = true);
		}
	}

	var selectSingleClass = "";
	if (is_number == 1) {
		selectSingleClass = "select-single";
	}
	var itemQtys = data["variants"][0].inventory_quantity;
	if (data["variants"][0].inventory_quantity <= 0 && data.available == true) {
		itemQtys = 24;
	}
	var description = "";
	if (data.description != "") {
		description = data.description
			.substr(0, 300)
			.replace(/<p[^>]*>/g, "")
			.replace(/<\/p>/g, "<br />");
		description = description.replace(/\.([^.]+)$/, ":$1").split(":");
		description = description[0] + ".";
	}
	var priceDescription = "";
	/*** End Prepare data ***/

	// Get Template
	var itemHtml = bcSfFilterTemplate.productListItemHtml;

	// Add Select Class Single
	itemHtml = itemHtml.replace(/{{selectSingle}}/g, selectSingleClass);

	// Add Icons
	var itemIconsHtml = '<div class="icon-for-reviews">';
	var countReviews = 0;
	var sumaryRevies = 0;
	var reviewArray = [];

	for (itemTag of itemTags) {
		if (itemTag.indexOf("review") >= 0 && itemTag.indexOf("|") >= 0) {
			var tagArray = itemTag.split("|");
			reviewArray.push(tagArray[1]);
		}
	}

	reviewArray.sort(function (a, b) {
		if (parseInt(a.split("/")[1]) > parseInt(b.split("/")[1])) {
			return -1;
		} else {
			return 1;
		}
	});

	for (reviewItem of reviewArray) {
		var tagArrayValues = reviewItem.split("/");
		if (tagArrayValues.length > 2) {
			var criticName = tagArrayValues[0].replace("_", " ");
			var criticPoints = tagArrayValues[1];
			var criticDate = tagArrayValues[2].split(".");
			var month = "";
			switch (criticDate[1]) {
				case 1:
					month = "January";
					break;
				case 2:
					month = "February";
					break;
				case 3:
					month = "March";
					break;
				case 4:
					month = "April";
					break;
				case 5:
					month = "May";
					break;
				case 6:
					month = "June";
					break;
				case 7:
					month = "July";
					break;
				case 8:
					month = "August";
					break;
				case 9:
					month = "September";
					break;
				case 10:
					month = "October";
					break;
				case 11:
					month = "November";
					break;
				default:
					month = "December";
			}
			var criticDateText = month + " " + criticDate[2];
			itemIconsHtml +=
				'<div class="icon-review" data-point="' + criticPoints + '">';
			itemIconsHtml +=
				'<div class="box-review-top size-' + criticName.length + '">';
			itemIconsHtml +=
				'<span class="critic-name" aria-label="' + criticName + '">';
			for (var k = 0; k < criticName.length; k++) {
				itemIconsHtml +=
					'<span class="char' +
					(k + 1) +
					'" aria-hidden="true">' +
					criticName.charAt(k) +
					"</span>";
			}
			itemIconsHtml += "</span>";
			itemIconsHtml += "</div>";

			itemIconsHtml += '<div class="box-review-middle">';
			itemIconsHtml +=
				'<span class="critic-point">' +
				criticPoints +
				" <br /><em>points</em></span>";
			itemIconsHtml += "</div>";

			itemIconsHtml +=
				'<div class="box-review-bottom size-' + criticDateText.length + '">';
			itemIconsHtml += '<span class="critic-date ">';
			for (var k = 0; k < criticDateText.length; k++) {
				itemIconsHtml +=
					'<span class="char' +
					(k + 1) +
					'" aria-hidden="true">' +
					criticDateText.charAt(k) +
					"</span>";
			}
			itemIconsHtml += "</span>";
			itemIconsHtml += "</div>";
			itemIconsHtml += "</div>";
			countReviews++;
		}
	}

	itemIconsHtml += "</div>";

	itemHtml = itemHtml.replace(/{{itemIcons}}/g, itemIconsHtml);

	// Add Class bundlebuilder
	if (data.template_suffix == "bundlebuilder") {
		itemHtml = itemHtml.replace(/{{bundlebuilder}}/g, " bundlebuilder");
		itemHtml = itemHtml.replace(/{{isBundlebuilder}}/g, true);
	} else {
		itemHtml = itemHtml.replace(/{{isBundlebuilder}}/g, false);
	}

	var mixedCaseButton = "";
	if (data.template_suffix == "bundlebuilder") {
		mixedCaseButton =
			'<a class="btn btn-action card-btn mixed-case-button" href="/products/' +
			data.handle +
			'"><span>SEE MORE</span></a>';
	}
	itemHtml = itemHtml.replace(/{{mixedCaseButton}}/g, mixedCaseButton);

	// Add onSale label
	var itemSaleLabel = onSale ? bcSfFilterTemplate.saleLabelListHtml : "";
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

	// Add soldOut label
	var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelListHtml : "";
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

	//Add producer
	var producerText = "";
	var styleText = "";
	var countryText = "";
	var regionText = "";

	for (var i = 0; i < itemTags.length; i++) {
		if (itemTags[i].indexOf("producer") >= 0) {
			var producerArray = itemTags[i].split(":");
			producerText = producerArray[1];
		}

		if (
			itemTags[i].indexOf("red wine") >= 0 ||
			itemTags[i].indexOf("type: red") >= 0
		) {
			styleText = "Red" + " |";
		}

		if (
			itemTags[i].indexOf("white wine") >= 0 ||
			itemTags[i].indexOf("type: white") >= 0
		) {
			styleText = "White" + " |";
		}

		if (itemTags[i].indexOf("sparkling wine") >= 0) {
			styleText = "Sparkling" + " |";
		}

		if (itemTags[i] == "Mixed Cases") {
			styleText = "Mixed" + " |";
		}

		if (itemTags[i].indexOf("country") >= 0) {
			var countryArray = itemTags[i].split(":");
			countryText = countryArray[1];
		}

		if (itemTags[i].indexOf("region") >= 0) {
			var regionArray = itemTags[i].split(":");
			regionText = ", " + regionArray[1];
		}
	}

	itemHtml = itemHtml.replace(/{{producer}}/g, producerText);
	if (data.product_type == "Custom Bundle") {
		styleText = "Mixed | Various Locations";
		itemHtml = itemHtml.replace(/{{style}}/g, styleText);
	} else {
		itemHtml = itemHtml.replace(
			/{{style}}/g,
			styleText + " " + countryText + regionText
		);
	}

	// Add Thumbnail
	var itemThumbUrl =
		images.length > 0
			? this.optimizeImage(images[0]["src"], "600x600")
			: bcSfFilterConfig.general.no_image_url;
	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

	// Add Vendor
	var itemSmallVendorHtml = bcSfFilterConfig.custom.vendor_enable
		? bcSfFilterTemplate.vendorSmallListHtml
		: "";
	itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
	var itemMediumVendorHtml = bcSfFilterConfig.custom.vendor_enable
		? bcSfFilterTemplate.vendorMediumListHtml
		: "";
	itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

	//minSelectQty
	var handleProduct = data.handle;
	if (typeof minMaxify != "undefined")
		var minMaxQty = minMaxify.getLimitsFor({ handle: handleProduct });

	/* var dataCart = (function() {
		var jqXHR = jQ.ajax({
			url: '/cart.js',
			async: false
		});
		var data = JSON.parse(jqXHR.responseText);
		return data;
	})(); */

	var itemAdded = getQuantityBottle(dataCart, data.variants[0].id);
	//{{buttonText}}
	//console.log('itemAdded: '+itemAdded);
	var buttonText = "Add to cart";
	if (itemAdded > 0) {
		buttonText = "Update to cart";
		itemHtml = itemHtml = itemHtml.replace(
			/{{buttonAdded}}/g,
			"btn-added-list"
		);
	}
	// Disabled button when sold out isAddProductDisabled
	/*if(typeof minMaxQty != 'undefined') {
		if(data['variants'][0].inventory_quantity <= minMaxQty.min && data.available == true) {
			itemQtys = 24;
		}
		if(minMaxQty.max > 0 && data['variants'][0].inventory_quantity > minMaxQty.max) {
			itemQtys = minMaxQty.max;
		}
	} */

	var inventory_policy = data["variants"][0].inventory_policy;

	if (data.available == false) {
		soldOut = true;
	} else {
		if (data["variants"][0].inventory_quantity > 0) {
			if (is_bottle == false) {
				if (is_case6 == false) {
					if (typeof minMaxQty != "undefined") {
						if (
							minMaxQty.min > 1 &&
							data["variants"][0].inventory_quantity < minMaxQty.min &&
							inventory_policy != "continue"
						) {
							soldOut = true;
						} else if (
							is_case12 == true &&
							data["variants"][0].inventory_quantity < 12 &&
							inventory_policy != "continue"
						) {
							soldOut = true;
						}
					} else {
						if (
							is_case12 == true &&
							data["variants"][0].inventory_quantity < 12 &&
							inventory_policy != "continue"
						) {
							soldOut = true;
						}
					}
				} else {
					if (typeof minMaxQty != "undefined") {
						if (
							minMaxQty.min > 1 &&
							data["variants"][0].inventory_quantity < minMaxQty.min &&
							inventory_policy != "continue"
						) {
							soldOut = true;
						} else if (
							is_case12 == false &&
							data["variants"][0].inventory_quantity < 6 &&
							inventory_policy != "continue"
						) {
							soldOut = true;
						}
					} else {
						if (is_case12 == false) {
							if (
								data["variants"][0].inventory_quantity < 6 &&
								inventory_policy != "continue"
							) {
								soldOut = true;
							}
						}
					}
				}
			}
		}
	}

	if (soldOut) {
		buttonText = "SOLD OUT";
		itemHtml = itemHtml = itemHtml.replace(
			/{{isAddProductDisabled}}/g,
			'disabled="disabled"'
		);
	} else {
		itemHtml = itemHtml = itemHtml.replace(/{{isAddProductDisabled}}/g, "");
	}

	//var itemPriceHtml = buildPriceForList(data, onSale, priceVaries, minMaxQty.min, itemAdded);
	itemHtml = itemHtml.replace(/{{buttonText}}/g, buttonText);
	if (typeof minMaxQty != "undefined") {
		itemHtml = itemHtml.replace(/{{minSelectQty}}/g, minMaxQty.min);
		if (minMaxQty.min > 1) {
			var itemPriceHtml = buildPriceForList(
				data,
				onSale,
				priceVaries,
				minMaxQty.min,
				0
			);
		} else {
			if (is_bottle == true) {
				var itemPriceHtml = buildPriceForList(data, onSale, priceVaries, 1, 0);
			} else {
				if (is_case6 == true) {
					var itemPriceHtml = buildPriceForList(
						data,
						onSale,
						priceVaries,
						6,
						0
					);
				}
				if (is_case12 == true) {
					var itemPriceHtml = buildPriceForList(
						data,
						onSale,
						priceVaries,
						12,
						0
					);
				}
			}
		}
		if (minMaxQty.max > 0 && minMaxQty.max < itemQtys) {
			itemHtml = itemHtml.replace(/{{maxSelectQty}}/g, minMaxQty.max);
		} else {
			itemHtml = itemHtml.replace(/{{maxSelectQty}}/g, itemQtys);
		}
	} else {
		var itemPriceHtml = buildPriceForList(data, onSale, priceVaries, 1, 0);
	}

	var inventory_policy = data["variants"][0].inventory_policy;

	// Add Price
	//var itemPriceHtml = buildPriceForList(data, onSale, priceVaries, minMaxQty.min);
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	itemHtml = itemHtml.replace(
		/{{regularPrice}}/g,
		parseFloat(data.price_max) / 100
	);
	itemHtml = itemHtml.replace(
		/{{comparePrice}}/g,
		parseFloat(data.compare_at_price_max) / 100
	);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{variantFirstId}}/g, data.variants[0].id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(
		/{{itemTitleInCart}}/g,
		data.title.replace(/'/g, "&quot;")
	);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, "/products/" + data.handle);
	itemHtml = itemHtml.replace(/{{itemDescription}}/g, description);

	if (minMaxQty.max < 24 && inventory_policy == "continue") {
		itemHtml = itemHtml.replace(/{{inventoryPolicy}}/g, 0);
	}

	var typeOptions = "";
	var bottleQtys = "",
		caseSixQtys = "",
		caseTwelveQtys = "";
	/*priceDescription = '<p class="per-bottle">'+ bcsffilter.formatMoney(data.price, bcsffilter.moneyFormat) +' per bottle</p>';
	if(is_bottle == true){
		priceDescription = '<p class="per-bottle">'+ bcsffilter.formatMoney(data.price, bcsffilter.moneyFormat) +' per bottle</p>';
	}
	if(is_case6 == true){
		priceDescription += '<p class="per-case6">'+ bcsffilter.formatMoney((data.price*95/100), bcsffilter.moneyFormat) +' in any 6</p>';
	}
	if(is_case12 == true){
		priceDescription += '<p class="per-case12">'+ bcsffilter.formatMoney((data.price*95/100), bcsffilter.moneyFormat) +' in any 12</p>';
	} */
	if ("bundlebuilder" != data.template_suffix)
		itemHtml = itemHtml.replace(/{{priceDescription}}/g, priceDescription);
	else itemHtml = itemHtml.replace(/{{priceDescription}}/g, "");

	var iconVeganPro = (iconOrganicPro = iconBiodynamicPro = iconAwardHtml = "");
	for (itemTag of itemTags) {
		if (itemTag.indexOf("vegan") >= 0 || itemTag.indexOf("Vegan") >= 0) {
			var iconVeganUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/vegan-icon.png?115137";
			iconVeganPro =
				'<div class="icon-vegan-pro"><div class="item-vegan"><img src="' +
				iconVeganUrl +
				'" alt="Vegan" title="Vegan"></div></div>';
		}
		if (itemTag.indexOf("organic") >= 0 || itemTag.indexOf("Organic") >= 0) {
			var iconOrganicUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/Organic_80593388-8979-497d-9736-7ede4b5a2a8a.png?117071";
			iconOrganicPro =
				'<div class="icon-vegan-pro"><div class="item-vegan"><img src="' +
				iconOrganicUrl +
				'" alt="Vegan" title="Vegan"></div></div>';
		}
		if (
			itemTag.indexOf("biodynamic") >= 0 ||
			itemTag.indexOf("Biodynamic") >= 0
		) {
			var iconBioUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/biodynamic_63b1ecde-348d-4cb3-a83d-5ee762654414.png?117071";
			iconBiodynamicPro =
				'<div class="icon-vegan-pro"><div class="item-vegan"><img src="' +
				iconBioUrl +
				'" alt="Vegan" title="Vegan"></div></div>';
		}

		if (itemTag.indexOf("award") >= 0 || itemTag.indexOf("Award") >= 0) {
			var iconAwardUrl =
				"https://cdn.shopify.com/s/files/1/0092/7960/2769/files/award_3x_7cd0c5c8-6666-4886-8a36-0c8062e16dbc.png?112431";
			iconAwardHtml =
				'<div class="award-icon"><div class="award-icon-product"><img src="' +
				iconAwardUrl +
				'" alt="Award" title="Award"></div></div>';
		}
	}

	if (iconBiodynamicPro != "") {
		itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, iconBiodynamicPro);
	} else {
		if (iconOrganicPro != "") {
			itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, iconOrganicPro);
		} else {
			if (iconVeganPro != "") {
				itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, iconVeganPro);
			} else {
				itemHtml = itemHtml.replace(/{{iconVeganPro}}/g, "");
			}
		}
	}

	itemHtml = itemHtml.replace(/{{iconAward}}/g, iconAwardHtml);

	if (data.metafields.length > 0) {
		var per_bottle_html = data.metafields[0].value;
	} else {
		var per_bottle_html = "";
	}

	var itemTags = data.tags;
	var is_tier12 = false,
		is_tier24 = false;
	var is_bottle = false;
	if (itemTags.indexOf("tier: 12") > 0 || itemTags.indexOf("tier: 12") === 0) {
		is_tier12 = true;
	}
	if (itemTags.indexOf("tier: 24") > 0 || itemTags.indexOf("tier: 24") === 0) {
		is_tier24 = true;
	}

	var price = data.price_max*0.01;
	var tier12price = price*0.95;
	var tier24price = price*0.90;
	
	if (is_tier12){
		itemHtml = itemHtml.replace(/{{_per_bottle_html}}/g, "$" + tier12price.toFixed(2) + " Price per bottle on 12+ (Save 5%)" );
		itemHtml = itemHtml.replace(/{{_per_bottle_html_code}}/g, "12" );

	}
	else {
		itemHtml = itemHtml.replace(/{{_per_bottle_html}}/g, "");
	}

	if (is_tier24){
		itemHtml = itemHtml.replace(/{{_per_bottle_html_2}}/g, "$" + tier24price.toFixed(2) + " Price per bottle on 24+ (Save 10%)");
		itemHtml = itemHtml.replace(/{{_per_bottle_html_code1}}/g, "24" );
	}
	else {
		itemHtml = itemHtml.replace(/{{_per_bottle_html_2}}/g, "");
	}

	var _sofv = data.selected_or_first_available_variant.id;
	itemHtml = itemHtml.replace(/{{data_variant_id}}/g, _sofv);
	var _prices = [];
	for (varian of data.variants) {
		_prices.push(varian.price);
	}
	itemHtml = itemHtml.replace(/{{listPrice}}/g, _prices);
	//Sale percent in product list page
	if (data.compare_at_price_max > data.price_max) {
		var salePercent = Math.round(
			100 - (data.price_max / data.compare_at_price_max) * 100
		);
		var perBottles = 0;
		if ("bundlebuilder" == data.template_suffix) {
			console.log("bundleee");
			//perBottles = '<p class="per-bottle">'+ bcsffilter.formatMoney(parseFloat(data.price_min / 12, 2), bcsffilter.moneyFormat) +' per bottle</p>';
			perBottles = "";
			itemHtml = itemHtml.replace(
				/{{salePercent}}/g,
				'<p class="price-per-bottle"><span class="b-price" id="pricebottle">' +
					bcsffilter.formatMoney(
						parseFloat(data.price_max),
						bcsffilter.moneyFormat
					) +
					'</span><span class="compare-at-price">' +
					bcsffilter.formatMoney(
						parseFloat(data.compare_at_price_max),
						bcsffilter.moneyFormat
					) +
					'</span></p><p class="sale-percent-list"><span><span>' +
					salePercent +
					"</span><span>% Off</span></span></p>"
			);
		} else {
			itemHtml = itemHtml.replace(
				/{{salePercent}}/g,
				'<p class="price-per-bottle"><span class="b-price" id="pricebottle">' +
					bcsffilter.formatMoney(
						parseFloat(data.price_max),
						bcsffilter.moneyFormat
					) +
					'</span><span class="compare-at-price">' +
					bcsffilter.formatMoney(
						parseFloat(data.compare_at_price_max),
						bcsffilter.moneyFormat
					) +
					'</span><span>per bottle</span></p><p class="sale-percent-list"><span><span>' +
					salePercent +
					"</span><span>% Off</span></span></p>"
			);
		}
	} else {
		console.log("here it is");
		console.log(data);
		if ("bundlebuilder" == data.template_suffix) {
			itemHtml = itemHtml.replace(
				/{{salePercent}}/g,
				'<p class="price-per-bottle"><span class="b-price">' +
					bcsffilter.formatMoney(
						parseFloat(data.price_max),
						bcsffilter.moneyFormat
					) 
			);
		}
		else {
		itemHtml = itemHtml.replace(
			/{{salePercent}}/g,
			'<p class="price-per-bottle"><span class="b-price">' +
				bcsffilter.formatMoney(
					parseFloat(data.price_max),
					bcsffilter.moneyFormat
				) +
				"</span><span>per bottle</span></p>"
		);
				}
	}



	//End sale percent in product list page
	if (itemQtys < 1) itemQtys = 1;
	var disabledClassCase = "";
	if (itemQtys > 0) {
		itemHtml = itemHtml.replace(/{{is_show}}/g, "");
		//This does not do what you think it does the opposite
		if (is_bottle == false) {
			typeOptions += '<option value="bottle">Bottle(s)</option>';
			bottleQtys = 'data-bottle="' + itemQtys + '"';
			//priceDescription = '<p class="per-bottle">'+ bcsffilter.formatMoney(data.price, bcsffilter.moneyFormat) +' per bottle</p>';
		}
		if (itemQtys < 6 && inventory_policy != "continue")
			disabledClassCase = "disabled";
		if (is_case6 == true) {
			typeOptions +=
				"<option " + disabledClassCase + ' value="case6">Case(s) of 6</option>';
			caseSixQtys = 'data-case6="' + parseInt(itemQtys / 6) + '"';
			priceDescription +=
				'<p class="per-case6">' +
				bcsffilter.formatMoney(
					(data.price * 95) / 100,
					bcsffilter.moneyFormat
				) +
				" in any 6</p>";
		}
		if (itemQtys < 12 && inventory_policy != "continue")
			disabledClassCase = "disabled";
		if (is_case12 == true) {
			typeOptions +=
				"<option " +
				disabledClassCase +
				' value="case12">Case(s) of 12</option>';
			caseTwelveQtys = 'data-case12="' + parseInt(itemQtys / 12) + '"';
			priceDescription +=
				'<p class="per-case12">' +
				bcsffilter.formatMoney(
					(data.price * 95) / 100,
					bcsffilter.moneyFormat
				) +
				" in any 12</p>";
		}
		itemHtml = itemHtml.replace(/{{typeOptions}}/g, typeOptions);
		itemHtml = itemHtml.replace(/{{bottleQtys}}/g, bottleQtys);
		itemHtml = itemHtml.replace(/{{caseSixQtys}}/g, caseSixQtys);
		itemHtml = itemHtml.replace(/{{caseTwelveQtys}}/g, caseTwelveQtys);

		var typeQtys = "";

		if (itemQtys < 24 && inventory_policy == "continue") {
			itemQtys = 24;
		}

		if (is_bottle == false) {
			for (i = 1; i <= itemQtys; i++) {
				if (typeof minMaxQty != "undefined") {
					var multiple = minMaxQty.multiple;

					var maxQtySelect = itemQtys - itemAdded;

					if (multiple > 1) {
						if (i % multiple == 0) {
							if (i == minMaxQty.min && minMaxQty.min > 1) {
								typeQtys +=
									'<option selected="selected" value="' +
									i +
									'">' +
									i +
									"</option>";
							} else {
								typeQtys += '<option value="' + i + '">' + i + "</option>";
							}
						}
					} else {
						if (minMaxQty.min > 1) {
							if (i == minMaxQty.min) {
								typeQtys +=
									'<option selected="selected" value="' +
									i +
									'">' +
									i +
									"</option>";
							} else {
								if (
									i < minMaxQty.min ||
									(i > minMaxQty.max && minMaxQty.max > 0)
								) {
									typeQtys +=
										'<option disabled value="' + i + '">' + i + "</option>";
								} else {
									typeQtys += '<option value="' + i + '">' + i + "</option>";
								}
							}
						} else {
							if (i > minMaxQty.max && minMaxQty.max > 0) {
								typeQtys +=
									'<option disabled value="' + i + '">' + i + "</option>";
							} else {
								typeQtys += '<option value="' + i + '">' + i + "</option>";
							}
						}
					}
				} else {
					typeQtys += '<option value="' + i + '">' + i + "</option>";
				}
			}
		} else if (is_case6 == true) {
			itemQtys = parseInt(itemQtys / 6);
			var inventory_policy = data["variants"][0].inventory_policy;
			var maxQtySelect = minMaxQty.min - itemAdded;
			if (itemQtys < 1) itemQtys = 1;

			if (itemQtys <= 24 && inventory_policy == "continue") {
				itemQtys = 4;
			}

			for (i = 1; i <= itemQtys; i++) {
				if (typeof minMaxQty != "undefined") {
					if (minMaxQty.min > 1) {
						if (i * 6 == minMaxQty.min) {
							typeQtys +=
								'<option selected="selected" value="' +
								i * 6 +
								'">' +
								i +
								"</option>";
						} else {
							var qtyBottleValue = i * 6;
							if (
								qtyBottleValue < minMaxQty.min ||
								(minMaxQty.max > 0 && qtyBottleValue > minMaxQty.max)
							) {
								typeQtys += '<option value="' + i * 6 + '">' + i + "</option>";
							} else {
								typeQtys += '<option value="' + i * 6 + '">' + i + "</option>";
							}
						}
					} else {
						if (i == 1) {
							typeQtys +=
								'<option selected="selected" value="' +
								i * 6 +
								'">' +
								i +
								"</option>";
						} else {
							var qtyBottleValue = i * 6;
							if (minMaxQty.max > 0 && qtyBottleValue > minMaxQty.max) {
								typeQtys += '<option value="' + i * 6 + '">' + i + "</option>";
							} else {
								typeQtys += '<option value="' + i * 6 + '">' + i + "</option>";
							}
						}
					}
				} else {
					if (i == 1) {
						typeQtys +=
							'<option selected="selected" value="' +
							i * 6 +
							'">' +
							i +
							"</option>";
					} else {
						typeQtys += '<option value="' + i * 6 + '">' + i + "</option>";
					}
				}
			}
		} else if (is_case12 == true) {
			itemQtys = parseInt(itemQtys / 12);
			var maxQtySelect = minMaxQty.min - itemAdded;
			var inventory_policy = data["variants"][0].inventory_policy;
			if (itemQtys < 1) itemQtys = 1;

			if (itemQtys < 24 && inventory_policy == "continue") {
				itemQtys = 2;
			}

			for (i = 1; i <= itemQtys; i++) {
				if (typeof minMaxQty != "undefined") {
					if (minMaxQty.min > 1) {
						if (i * 12 == minMaxQty.min) {
							typeQtys +=
								'<option selected="selected" value="' +
								i * 12 +
								'">' +
								i +
								"</option>";
						} else {
							var qtyBottleValue = i * 12;
							if (minMaxQty.max > 0 && qtyBottleValue > minMaxQty.max) {
								typeQtys += '<option value="' + i * 12 + '">' + i + "</option>";
							} else {
								typeQtys += '<option value="' + i * 12 + '">' + i + "</option>";
							}
						}
					} else {
						if (i == 1) {
							typeQtys +=
								'<option selected="selected" value="' +
								i * 12 +
								'">' +
								i +
								"</option>";
						} else {
							var qtyBottleValue = i * 12;
							if (minMaxQty.max > 0 && qtyBottleValue > minMaxQty.max) {
								typeQtys += '<option value="' + i * 12 + '">' + i + "</option>";
							} else {
								typeQtys += '<option value="' + i * 12 + '">' + i + "</option>";
							}
						}
					}
				} else {
					if (i == 1) {
						typeQtys +=
							'<option selected="selected" value="' +
							i * 12 +
							'">' +
							i +
							"</option>";
					} else {
						typeQtys += '<option value="' + i * 12 + '">' + i + "</option>";
					}
				}
			}
		}
		itemHtml = itemHtml.replace(/{{typeQtys}}/g, typeQtys);
	} else {
		//itemHtml = itemHtml.replace(/{{is_show}}/g, "hide");
		itemHtml = itemHtml.replace(/{{typeOptions}}/g, typeOptions);
		itemHtml = itemHtml.replace(/{{bottleQtys}}/g, bottleQtys);
		itemHtml = itemHtml.replace(/{{caseSixQtys}}/g, caseSixQtys);
		itemHtml = itemHtml.replace(/{{caseTwelveQtys}}/g, caseTwelveQtys);
		itemHtml = itemHtml.replace(/{{typeQtys}}/g, typeQtys);
	}
	if (data["variants"][0].available) {
		if (is_case6 == true && is_case12 == false) {
			itemQtys = 6;
		} else {
			itemQtys = 12;
		}
	}
	var maxQty = data.variants[0].inventory_quantity;
	if (data.variants[0].available) {
		if (maxQty <= 0) maxQty = 24;
	}
	var countAvailableInfo = 0;
	if (is_bottle == false) countAvailableInfo += 1;
	if (typeof minMaxQty != "undefined") {
		if (countAvailableInfo == 0)
			if (minMaxQty.multiple > 1) countAvailableInfo += 1;
		if (countAvailableInfo == 0) if (minMaxQty.min > 1) countAvailableInfo += 1;
		if (minMaxQty.max > 0) countAvailableInfo += 1;
	}
	var countAvailableClass = "";
	if (countAvailableInfo == 1) countAvailableClass = "single-item";
	if (countAvailableInfo == 2) countAvailableClass = "double-items";
	var onlyAvailable = "";
	//This does the opposite of what you think
	if (is_bottle ) {
		onlyAvailable +=
			'<div class="only-available-section ' + countAvailableClass + '">';
		onlyAvailable +=
			'<div class="only-available 3 multiples">Only available in multiples of ' +
			itemQtys +
			"</div>";
	}
	if (typeof minMaxQty != "undefined") {
		if (onlyAvailable == "")
			onlyAvailable =
				'<div class="only-available-section ' + countAvailableClass + '">';
		if (minMaxQty.multiple > 1) {
			onlyAvailable =
				'<div class="only-available-section ' + countAvailableClass + '">';
			onlyAvailable +=
				'<div class="only-available 4 multiples">Only available in multiples of ' +
				minMaxQty.multiple +
				"</div>";
		}
		if (minMaxQty.min > 1 && is_bottle == false && minMaxQty.multiple <= 1) { // This does the opposite of what you think
			onlyAvailable +=
				'<div class="only-available minimum">Only available in minimum of ' +
				minMaxQty.min +
				"</div>";
		}
		if (minMaxQty.max > 0) {
			onlyAvailable +=
				'<div class="only-available maximum">Maximum order of ' +
				minMaxQty.max +
				" per customer</div>";
		}
	}
	if (onlyAvailable != "") onlyAvailable += "</div>";
	itemHtml = itemHtml.replace(/{{onlyAvailable}}/g, onlyAvailable);
	return itemHtml;
};

function buildPrice(data, onSale, priceVaries) {
	var priceHtml = "",
		onSaleClass = onSale ? " price--on-sale" : "";

	priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
	if (bcSfFilterConfig.custom.vendor_enable) {
		priceHtml += '<div class="price__vendor">';
		priceHtml += "<dt>";
		priceHtml +=
			'<span class="visually-hidden">' +
			bcSfFilterConfig.label.vendor +
			"</span>";
		priceHtml += "</dt>";
		priceHtml += "<dd>";
		priceHtml += data.vendor;
		priceHtml += "</dd>";
		priceHtml += "</div>";
	}
	priceHtml += '<div class="price__regular">';
	priceHtml += "<dt>";
	priceHtml +=
		'<span class="visually-hidden visually-hidden--inline">' +
		bcSfFilterConfig.label.regular_price +
		"</span>";
	priceHtml += "</dt>";
	priceHtml += "<dd>";
	priceHtml +=
		'<span class="price-item price-item--regular" data-regular-price>';
	//if (data.available) {
	if (onSale) {
		priceHtml += bcsffilter.formatMoney(
			data.compare_at_price_min,
			bcsffilter.moneyFormat
		);
	} else {
		priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
	}
	//} else {
	//	priceHtml += bcSfFilterConfig.label.sold_out;
	//}
	priceHtml += "</span>";
	priceHtml += "</dd>";
	priceHtml += "</div>";
	priceHtml += '<div class="price__sale">';
	priceHtml += "<dt>";
	priceHtml +=
		'<span class="visually-hidden visually-hidden--inline">' +
		bcSfFilterConfig.label.sale_price +
		"</span>";
	priceHtml += "</dt>";
	priceHtml += "<dd>";
	priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
	priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
	priceHtml += "</span> ";
	//priceHtml += '<span class="price-item__label" aria-hidden="true">' + bcSfFilterConfig.label.sale + '</span>';
	priceHtml += "</dd>";
	priceHtml += "</div>";
	priceHtml += "</dl>";

	return priceHtml;
}

function buildPriceForList(data, onSale, priceVaries, minQty, itemAdded) {
	//console.log(data.variants[0].id);
	//console.log($("select#btcs_qty_"+data.variants[0].id).val());
	//console.log(data);
	var itemTags = data.tags;
	var is_case6 = false,
		is_case12 = false;
	var is_bottle = false;
	if (itemTags.indexOf("case: 6") > 0 || itemTags.indexOf("case: 6") === 0) {
		is_case6 = true;
	}
	if (itemTags.indexOf("case: 12") > 0 || itemTags.indexOf("case: 12") === 0) {
		is_case12 = true;
	}
	if (
		itemTags.indexOf("bottle") > 0 ||
		itemTags.indexOf("bottle") === 0 ||
		(itemTags.indexOf("case: 6") < 0 && itemTags.indexOf("case: 12") < 0)
	) {
		is_bottle = true;
	}

	if (data.template_suffix == "bundlebuilder") {
		is_case6 = is_case12 = false;
		is_bottle = true;
		minQty = 1;
	}

	var priceHtml = "",
		onSaleClass = onSale ? " price--on-sale" : "";

	priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
	if (bcSfFilterConfig.custom.vendor_enable) {
		priceHtml += '<div class="price__vendor">';
		priceHtml += "<dt>";
		priceHtml +=
			'<span class="visually-hidden">' +
			bcSfFilterConfig.label.vendor +
			"</span>";
		priceHtml += "</dt>";
		priceHtml += "<dd>";
		priceHtml += data.vendor;
		priceHtml += "</dd>";
		priceHtml += "</div>";
	}
	priceHtml += '<div class="price__regular">';
	priceHtml += "<dt>";
	priceHtml +=
		'<span class="visually-hidden visually-hidden--inline">' +
		bcSfFilterConfig.label.regular_price +
		"</span>";
	priceHtml += "</dt>";
	priceHtml += "<dd>";
	priceHtml +=
		'<span class="price-item price-item--regular price-list" data-regular-price>';
	//if (data.available) {
	if (onSale) {
		// if(is_bottle == false) {
		// 	if(is_case6 == true || is_case12 == true) {
		// 		if(is_case6 == true ) {
		//console.log('case 6');
		// 			priceHtml += bcsffilter.formatMoney(data.compare_at_price_min*6, bcsffilter.moneyFormat);
		// 		} else if(is_case12 == true) {
		//console.log('case 12');
		// 			priceHtml += bcsffilter.formatMoney(data.compare_at_price_min*12, bcsffilter.moneyFormat);
		// 		}
		// 	} else {
		// 		if(minQty > 1 && itemAdded <= 0 ) {
		// 			priceHtml += bcsffilter.formatMoney(data.compare_at_price_min*minQty, bcsffilter.moneyFormat);
		// 		} else {
		// 			priceHtml += bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat);
		// 		}
		// 	}
		// } else {
		// 	if(minQty > 1 && itemAdded <= 0 ) {
		// 		priceHtml += bcsffilter.formatMoney(data.compare_at_price_min*minQty, bcsffilter.moneyFormat);
		// 	} else {
		// 		priceHtml += bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat);
		// 	}
		// }
	} else {
		if (is_bottle == false) {
			if (is_case6 == true || is_case12 == true) {
				if (is_case6 == true) {
					priceHtml += bcsffilter.formatMoney(
						data.price_min * 6,
						bcsffilter.moneyFormat
					);
				} else if (is_case12 == true) {
					priceHtml += bcsffilter.formatMoney(
						data.price_min * 12,
						bcsffilter.moneyFormat
					);
				}
			} else {
				if (minQty > 1 && itemAdded <= 0) {
					priceHtml += bcsffilter.formatMoney(
						data.price_min * minQty,
						bcsffilter.moneyFormat
					);
				} else {
					priceHtml += bcsffilter.formatMoney(
						data.price_min,
						bcsffilter.moneyFormat
					);
				}
			}
		} else {
			if (minQty > 1 && itemAdded <= 0) {
				priceHtml += bcsffilter.formatMoney(
					data.price_max * minQty,
					bcsffilter.moneyFormat
				);
			} else {
				priceHtml += bcsffilter.formatMoney(
					data.price_max,
					bcsffilter.moneyFormat
				);
			}
		}
	}
	//} else {
	//	priceHtml += bcSfFilterConfig.label.sold_out;
	//}
	priceHtml += "</span>";
	priceHtml += '<span class="price-list-label">total</span>';
	priceHtml += "</dd>";
	priceHtml += "</div>";
	priceHtml += '<div class="price__sale">';
	priceHtml += "<dt>";
	priceHtml +=
		'<span class="visually-hidden visually-hidden--inline">' +
		bcSfFilterConfig.label.sale_price +
		"</span>";
	priceHtml += "</dt>";
	priceHtml += "<dd>";
	priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
	if (minQty > 1 && itemAdded <= 0)
		priceHtml += bcsffilter.formatMoney(
			data.price_min * minQty,
			bcsffilter.moneyFormat
		);
	else
		priceHtml += bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat);
	priceHtml += "</span> ";
	//priceHtml += '<span class="price-item__label" aria-hidden="true">' + bcSfFilterConfig.label.sale + '</span>';
	priceHtml += "</dd>";
	priceHtml += "</div>";
	priceHtml += "</dl>";

	return priceHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		$(this.selector.pagination).html("");
		return false;
	}

	if (this.getSettingValue("general.paginationType") == "default") {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml =
			currentPage > 1
				? bcSfFilterTemplate.previousActiveHtml
				: bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(
			/{{itemUrl}}/g,
			this.buildToolbarLink("page", currentPage, currentPage - 1)
		);
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml =
			currentPage < totalPage
				? bcSfFilterTemplate.nextActiveHtml
				: bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(
			/{{itemUrl}}/g,
			this.buildToolbarLink("page", currentPage, currentPage + 1)
		);
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = bcSfFilterConfig.label.current_page
			.replace(/{{ current }}/g, currentPage)
			.replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		$(this.selector.pagination).html(paginationHtml);
	}
};

BCSfFilter.prototype.buildLoadMoreButton = function (a, data) {
	var b = this.getSelector("loadMore"),
		c = this.getSelector("loadMoreButtonContainer"),
		d = this.queryParams,
		e = Math.ceil(a / d.limit);
	if (0 == $(this.getSelector("loadMoreButtonContainer")).length) {
		var f = this.getTemplate("loadMoreButton").replace(
			"{{label.loadMore}}",
			this.getSettingValue("label.loadMore")
		);
		$(b).prepend(f);
	}
	parseInt(d.page) < e ? ($(b).show(), $(c).show()) : $(b).hide();
	var countItemLoad = $("#bc-sf-filter-products > div").length;
	$(".bc-sf-filter-load-more-text").show();
	$(".bc-sf-filter-load-more").show();
	$(".bc-sf-filter-load-more-count-item").text(countItemLoad);
	setTimeout(function () {
		var pageItem = $(".bc-sf-filter-load-more-count-item").text();
		var pageItemTotal = $(".bc-sf-filter-load-more-count-total").text();
		var percentTotal = (pageItem / pageItemTotal) * 100;
		$(".load-more-count-percent").css("width", percentTotal + "%");
		if (pageItem == pageItemTotal) {
			$(".bc-sf-filter-load-more").hide();
		}
	}, 100);
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterTemplate.hasOwnProperty("sortingHtml")) {
		$(this.selector.topSorting).html("");

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = "";
			for (var k in sortingArr) {
				sortingItemsHtml +=
					'<option value="' + k + '">' + sortingArr[k] + "</option>";
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(
				/{{sortingItems}}/g,
				sortingItemsHtml
			);
			$(this.selector.topSorting).html(html);

			// Set current value
			$(this.selector.topSorting + " select").val(this.queryParams.sort);
		}
	}
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
	var itemHtml = "<span>View as: </span>";
	itemHtml +=
		'<a href="' +
		this.buildToolbarLink("display", "list", "grid") +
		'" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
	itemHtml +=
		'<a href="' +
		this.buildToolbarLink("display", "grid", "list") +
		'" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
	$(this.selector.topDisplayType).html(itemHtml);

	// Active current display type
	$(this.selector.topDisplayType)
		.find(".bc-sf-filter-display-list")
		.removeClass("active");
	$(this.selector.topDisplayType)
		.find(".bc-sf-filter-display-grid")
		.removeClass("active");

	if (this.queryParams.display == "list") {
		sessionStorage.setItem("currentViewMode", "list");
		$(this.selector.topDisplayType)
			.find(".bc-sf-filter-display-list")
			.addClass("active");
		$("#bc-sf-filter-options-wrapper a").each(function () {
			var href = $(this).attr("href");
			href = href.replace("display=grid", "display=list");
			$(this).attr("href", href);
		});
		$(".site-nav a").each(function () {
			var href = $(this).attr("href");
			href = href.replace("display=grid", "display=list");
			$(this).attr("href", href);
		});
		setTimeout(function () {
			$(".mobile-menu .mobile-nav__item").each(function () {
				var href = $(this).find("a").attr("href");
				href = href.replace("display=grid", "display=list");
				$(this).find("a").attr("href", href);
			});
		}, 1000);
		$("input.display").val("list");
		document.cookie = "currentViewMode=list; expires=; path=/;";
	} else if (this.queryParams.display == "grid") {
		sessionStorage.setItem("currentViewMode", "grid");
		$(this.selector.topDisplayType)
			.find(".bc-sf-filter-display-grid")
			.addClass("active");
		$("#bc-sf-filter-options-wrapper a").each(function () {
			var href = $(this).attr("href");
			href = href.replace("display=list", "display=grid");
			$(this).attr("href", href);
		});
		$(".site-nav a").each(function () {
			var href = $(this).attr("href");
			href = href.replace("display=list", "display=grid");
			$(this).attr("href", href);
		});
		setTimeout(function () {
			$(".mobile-menu .mobile-nav__item").each(function () {
				var href = $(this).find("a").attr("href");
				//console.log(href);
				href = href.replace("display=list", "display=grid");
				$(this).find("a").attr("href", href);
			});
		}, 1000);
		$("input.display").val("grid");
		document.cookie = "currentViewMode=grid; expires=; path=/;";
	}

	sessionStorage.setItem("firstLoad", 2);
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	/* start-initialize-bc-al */
	var self = this;
	var alEnable = true;
	if (
		self.getSettingValue("actionlist.qvEnable") != "" ||
		self.getSettingValue("actionlist.atcEnable") != ""
	) {
		alEnable =
			self.getSettingValue("actionlist.qvEnable") ||
			self.getSettingValue("actionlist.atcEnable");
	}
	if (alEnable === true && typeof BCActionList !== "undefined") {
		if (typeof bcActionList === "undefined") {
			bcActionList = new BCActionList();
		} else {
			if (
				typeof bcAlParams !== "undefined" &&
				typeof bcSfFilterParams !== "undefined"
			) {
				bcActionList.initFlag = false;
				bcActionList.alInit(bcSfFilterParams, bcAlParams);
			} else {
				bcActionList.alInit();
			}
		}
	}
	/* end-initialize-bc-al */
	var productSelector = $(this.selector.products);
	if (this.queryParams.display == "list") {
		if (productSelector.children(".list-view-items").length == 0) {
			//productSelector.children().wrapAll('<ul class="list-view-items"/>');
		}
		productSelector.removeClass("grid grid--uniform grid--view-items");
	} else {
		if (productSelector.children(".list-view-items").length > 0) {
			productSelector.children(".list-view-items").children().unwrap();
		}
		productSelector.addClass("grid grid--uniform grid--view-items");
	}
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
	var totalProduct = "";
	if (data.total_product == 1) {
		totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(
			/{{ count }}/g,
			data.total_product
		);
	} else {
		totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(
			/{{ count }}/g,
			data.total_product
		);
	}
	$("#bc-sf-filter-total-product").html(totalProduct);
	var totalProductItem = data.total_product;
	$(".bc-sf-filter-load-more-count-total").text(totalProductItem);
};

// Build Default layout
function buildDefaultLink(a, b) {
	var c = window.location.href.split("?")[0];
	return (c += "?" + a + "=" + b);
}
BCSfFilter.prototype.buildDefaultElements = function (a) {
	if (
		bcSfFilterConfig.general.hasOwnProperty("collection_count") &&
		$("#bc-sf-filter-bottom-pagination").length > 0
	) {
		var b = bcSfFilterConfig.general.collection_count,
			c = parseInt(this.queryParams.page),
			d = Math.ceil(b / this.queryParams.limit);
		if (1 == d) return $(this.selector.pagination).html(""), !1;
		if ("default" == this.getSettingValue("general.paginationType")) {
			var e = bcSfFilterTemplate.paginateHtml,
				f = "";
			(f =
				c > 1
					? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")
						? bcSfFilterTemplate.previousActiveHtml
						: bcSfFilterTemplate.previousHtml
					: bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")
					? bcSfFilterTemplate.previousDisabledHtml
					: ""),
				(f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1))),
				(e = e.replace(/{{previous}}/g, f));
			var g = "";
			(g =
				c < d
					? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")
						? bcSfFilterTemplate.nextActiveHtml
						: bcSfFilterTemplate.nextHtml
					: bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")
					? bcSfFilterTemplate.nextDisabledHtml
					: ""),
				(g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1))),
				(e = e.replace(/{{next}}/g, g));
			for (var h = [], i = c - 1; i > c - 3 && i > 0; i--) h.unshift(i);
			c - 4 > 0 && h.unshift("..."), c - 4 >= 0 && h.unshift(1), h.push(c);
			for (var j = [], k = c + 1; k < c + 3 && k <= d; k++) j.push(k);
			c + 3 < d && j.push("..."), c + 3 <= d && j.push(d);
			for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)
				"..." == m[n]
					? (l += bcSfFilterTemplate.pageItemRemainHtml)
					: (l +=
							m[n] == c
								? bcSfFilterTemplate.pageItemSelectedHtml
								: bcSfFilterTemplate.pageItemHtml),
					(l = l.replace(/{{itemTitle}}/g, m[n])),
					(l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n])));
			(e = e.replace(/{{pageItems}}/g, l)), $(this.selector.pagination).html(e);
		}
	}
	if (
		bcSfFilterTemplate.hasOwnProperty("sortingHtml") &&
		$(this.selector.topSorting).length > 0
	) {
		$(this.selector.topSorting).html("");
		var o = this.getSortingList();
		if (o) {
			var p = "";
			for (var q in o) p += '<option value="' + q + '">' + o[q] + "</option>";
			var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
			$(this.selector.topSorting).html(r);
			var s =
				void 0 !== this.queryParams.sort_by
					? this.queryParams.sort_by
					: this.defaultSorting;
			$(this.selector.topSorting + " select").val(s),
				$(this.selector.topSorting + " select").change(function (a) {
					window.location.href = buildDefaultLink("sort_by", $(this).val());
				});
		}
	}
};

BCSfFilter.prototype.prepareProductData = function (data) {
	var countData = data.length;
	for (var k = 0; k < countData; k++) {
		data[k]["images"] = data[k]["images_info"];
		if (data[k]["images"].length > 0) {
			data[k]["featured_image"] = data[k]["images"][0];
		} else {
			data[k]["featured_image"] = {
				src: bcSfFilterConfig.general.no_image_url,
				width: "",
				height: "",
				aspect_ratio: 0,
			};
		}
		data[k]["url"] = "/products/" + data[k].handle;
		var optionsArr = [];
		var countOptionsWithValues = data[k]["options_with_values"].length;
		for (var i = 0; i < countOptionsWithValues; i++) {
			optionsArr.push(data[k]["options_with_values"][i]["name"]);
		}
		data[k]["options"] = optionsArr;
		if (
			typeof bcSfFilterConfig.general.currencies != "undefined" &&
			bcSfFilterConfig.general.currencies.length > 1
		) {
			var currentCurrency = bcSfFilterConfig.general.current_currency
				.toLowerCase()
				.trim();

			function updateMultiCurrencyPrice(oldPrice, newPrice) {
				if (typeof newPrice != "undefined") {
					return newPrice;
				}
				return oldPrice;
			}
			data[k].price_min = updateMultiCurrencyPrice(
				data[k].price_min,
				data[k]["price_min_" + currentCurrency]
			);
			data[k].price_max = updateMultiCurrencyPrice(
				data[k].price_max,
				data[k]["price_max_" + currentCurrency]
			);
			data[k].compare_at_price_min = updateMultiCurrencyPrice(
				data[k].compare_at_price_min,
				data[k]["compare_at_price_min_" + currentCurrency]
			);
			data[k].compare_at_price_max = updateMultiCurrencyPrice(
				data[k].compare_at_price_max,
				data[k]["compare_at_price_max_" + currentCurrency]
			);
		}
		(data[k]["price_min"] *= 100),
			(data[k]["price_max"] *= 100),
			(data[k]["compare_at_price_min"] *= 100),
			(data[k]["compare_at_price_max"] *= 100);
		data[k]["price"] = data[k]["price_min"];
		data[k]["compare_at_price"] = data[k]["compare_at_price_min"];
		data[k]["price_varies"] = data[k]["price_min"] != data[k]["price_max"];
		var firstVariant = data[k]["variants"][0];
		if (getParam("variant") !== null && getParam("variant") != "") {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == getParam("variant");
			});
			if (typeof paramVariant[0] !== "undefined")
				firstVariant = paramVariant[0];
		} else {
			var countVariants = data[k]["variants"].length;
			for (var i = 0; i < countVariants; i++) {
				if (data[k]["variants"][i].available) {
					firstVariant = data[k]["variants"][i];
					break;
				}
			}
		}
		data[k]["selected_or_first_available_variant"] = firstVariant;
		var countVariants = data[k]["variants"].length;
		for (var i = 0; i < countVariants; i++) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]["variants"][i];
			var variantOptions = variant["merged_options"];
			if (Array.isArray(variantOptions)) {
				var countVariantOptions = variantOptions.length;
				for (var j = 0; j < countVariantOptions; j++) {
					var temp = variantOptions[j].split(":");
					data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
					data[k]["variants"][i]["option_" + temp[0]] = temp[1];
					variantOptionArr.push(temp[1]);
				}
				data[k]["variants"][i]["options"] = variantOptionArr;
			}
			data[k]["variants"][i]["compare_at_price"] =
				parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
			data[k]["variants"][i]["price"] =
				parseFloat(data[k]["variants"][i]["price"]) * 100;
		}
		data[k]["description"] = data[k]["content"] = data[k]["body_html"];
		if (
			data[k].hasOwnProperty("original_tags") &&
			data[k]["original_tags"].length > 0
		) {
			data[k].tags = data[k]["original_tags"].slice(0);
		}
	}
	return data;
};

// Show cart form on grid mode
function showAdd2CartForm(btn) {
	if (!$(btn).hasClass("btn-cancel") && !$(btn).hasClass("btn-viewcart")) {
		$(btn).parents(".grid-view-item").addClass("active");
		$(btn).parent().find(".product-card-add").addClass("active");
		$(btn)
			.addClass("btn-cancel")
			.removeClass("btn-viewcart")
			.find("span")
			.text("Cancel");
	} else if ($(btn).hasClass("btn-cancel")) {
		$(btn).parent().find(".product-card-add").removeClass("active");
		$(btn).parents(".grid-view-item").removeClass("active");
		$(btn).removeClass("btn-cancel").find("span").text("Add to cart");
		//$(btn).parent().find('.product-card-continue').hide();
		//$(btn).parent().find('.product-card-case-continue').hide();
		//$(btn).prev('.product-card-add').find('input').val(0);
	} else if ($(btn).hasClass("btn-adding")) {
		$(btn)
			.removeClass("btn-cancel btn-viewcart")
			.find("span")
			.text("Adding to cart");
	}

	if ($(btn).hasClass("btn-viewcart")) {
		window.location.href = bcSfFilterMainConfig.shop.url + "/cart";
	}
}

// Add product button on list mode
function addProductToCart(
	data,
	btn,
	itemId,
	itemName,
	producer,
	isBundlebuilder
) {
	var qty = $("#btcs_qty_" + itemId).val();
	var type = $("#type_" + itemId).val();
	var min = $("#btcs_qty_" + itemId).attr("min");
	var max = $("#btcs_qty_" + itemId).attr("max");
	var inventPolicy = $("#btcs_qty_" + itemId).attr("policy");

	if (inventPolicy == 0) {
		max = 24;
	}
	var bottleQty = 0,
		caseQty = 0;
	var totalQty = parseInt(qty);
	//console.log(totalQty);
	var testermin = parseInt(min);
	var testermax = parseInt(max);

	$("#bc-sf-filter-loading").show();

	var btnUpdate = false;
	if ($('.line-item-list li .content[data-id="' + itemId + '"]').length) {
		btnUpdate = true;
	}

	if (qty < parseInt(min) || qty > parseInt(max)) {
		if (qty < parseInt(min)) showAlertMin(itemName, min);

		if (qty > parseInt(max)) showAlertMax(itemName, max);
	} else {
		if (!$(btn).hasClass("btn-viewcart")) {
			$(btn)
				.addClass("btn-adding")
				.attr("title", "Adding to cart")
				.removeClass("btn-viewcart")
				.find("span")
				.text("Adding to cart");
			if (!$(btn).hasClass("btn-added-list")) {
				CartJS.addItem(
					itemId,
					qty,
					{},
					{
						success: function (data, textStatus, jqXHR) {
						//save producer to localStorage for displaying in minicart
						if (producer != null && "" != producer && !isBundlebuilder) {
							localStorage.setItem("producer-of-" + itemId, producer);
						}
						localStorage.setItem("max-qty-of-" + itemId, max);
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
						for (cartItem of cart.items) {
							var status12 = localStorage.getItem(cartItem.product_id + ":12");
							var status24 = localStorage.getItem(cartItem.product_id + ":24");
							var qty = 0;

							if (data.product_id == cartItem.product_id) qty = data.quantity;
							// updates mini cart total, sub total and top right price
							if (shopTaxesIncluded != "true") {
								if (cartItem.taxable) {
									if (qty >= 12 && status12) {
										var priceItem = cartItem.final_line_price * 0.95;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else if (qty >= 24 && status24) {
										var priceItem = cartItem.final_line_price * 0.9;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									}
								} else {
									if (qty >= 12 && status12) {
										var priceItem = cartItem.final_line_price * 0.95;
										price += priceItem;
									} else if (qty >= 24 && status24) {
										var priceItem = cartItem.final_line_price * 0.9;
										price += priceItem;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								}
							} else {
								if (qty >= 12 && status12) {
									var priceItem = cartItem.final_line_price * 0.95;
									price += priceItem;
								} else if (qty >= 24 && status24) {
									var priceItem = cartItem.final_line_price * 0.9;
									price += priceItem;
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}
						}

						$(".minicart-subtotal, .minicart-total, .total-value").html(
							Shopify.formatMoney(price)
						);
								var cartCount = getCartCount(cart);
								if (cartCount <= 1)
									$(".minicart-items-count").html(cartCount + " Item");
								else $(".minicart-items-count").html(cartCount + " Items");
								$(".site-header__cart-count span")
									.first()
									.next()
									.html(cartCount);
								$("#CartCount span.cart-count").html(cartCount);
							});
							var itemToGet = "Item" + itemId;
							$("#bc-sf-filter-loading").hide();
							if (totalQty < parseInt(min)) showAlertMin(itemName, min);
							else if (totalQty > parseInt(max) && parseInt(max) > 0)
								showAlertMax(itemName, max);
							else {
								$(".minicart-panel").addClass("open");
								$("html").addClass("minicart-open");
							}
							$(btn)
								.addClass("btn-viewcart")
								.attr("title", "View cart")
								.removeClass("btn-adding")
								.find("span")
								.text("View cart");
							//showPopup(itemName, 'add');
							$(".line-item-list").empty();
							loadMinicart();
							$(".minicart-success")
								.show()
								.find("span.update-text")
								.text("added to");
						},
						error: function (data, textStatus, jqXHR) {
							$("#bc-sf-filter-loading").hide();
						},
					}
				);
			} else {
				$(btn)
					.addClass("btn-adding")
					.attr("title", "Adding to cart")
					.removeClass("btn-viewcart")
					.find("span")
					.text("Adding to cart");
				CartJS.updateItemById(
					itemId,
					qty,
					{},
					{
						success: function (data, textStatus, jqXHR) {
							//save producer to localStorage for displaying in minicart
							if (producer != null && "" != producer && !isBundlebuilder) {
								localStorage.setItem("producer-of-" + itemId, producer);
							}
							var shopTaxesIncluded = $(".shop_taxes_included").text();
							jQuery.getJSON("/cart.js", function (cart) {
								var price = 0;
								for (cartItem of cart.items) {
									if (shopTaxesIncluded != "true") {
										if (cartItem.taxable) {
											var priceItem = cartItem.final_line_price;
											var tax = priceItem * 0.1;
											price += priceItem + tax;
										} else {
											var priceItem = cartItem.final_line_price;
											price += priceItem;
										}
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								}

								$(".minicart-subtotal, .minicart-total, .total-value").html(
									Shopify.formatMoney(price)
								);
								var cartCount = getCartCount(cart);
								if (cartCount <= 1)
									$(".minicart-items-count").html(cartCount + " Item");
								else $(".minicart-items-count").html(cartCount + " Items");
								$(".site-header__cart-count span")
									.first()
									.next()
									.html(cartCount);
								$("#CartCount span.cart-count").html(cartCount);
							});
							var itemToGet = "Item" + itemId;
							$("#bc-sf-filter-loading").hide();
							if (totalQty < parseInt(min)) showAlertMin(itemName, min);
							else if (totalQty > parseInt(max) && parseInt(max) > 0)
								showAlertMax(itemName, max);
							else {
								$(".minicart-panel").addClass("open");
								$("html").addClass("minicart-open");
							}
							$(btn)
								.addClass("btn-viewcart")
								.attr("title", "View cart")
								.removeClass("btn-adding")
								.find("span")
								.text("View cart");
							//showPopup(itemName, 'add');
							$(".line-item-list").empty();
							loadMinicart();
							$(".minicart-success")
								.show()
								.find("span.update-text")
								.text("updated to");
						},
						error: function (data, textStatus, jqXHR) {
							$("#bc-sf-filter-loading").hide();
						},
					}
				);
			}
		} else {
			window.location.href = bcSfFilterMainConfig.shop.url + "/cart";
		}
	}
}

// Reset qty dropdown
function updateQty(select, itemId) {
	var qtyHtml = "";
	var type = $("#type_" + itemId).val();
	var qty = 1;
	var minQty = parseInt($("#btcs_qty_" + itemId).attr("min"));
	var maxQty = parseInt($("#btcs_qty_" + itemId).attr("max"));
	var inventPolicy = $("#btcs_qty_" + itemId).attr("policy");

	if (inventPolicy == 0) {
		maxQty = 24;
	}

	var qtySelected = minQty;

	if (type == "bottle") {
		qty = parseInt($("#btcs_qty_" + itemId).data("bottle"));
		if (qty < 24 && inventPolicy == 0) {
			qty = 24;
		}
	} else if (type == "case6") {
		qty = parseInt($("#btcs_qty_" + itemId).data("case6"));
		if (qty < 24 && inventPolicy == 0) {
			qty = 4;
		}
		if (minQty < 6) qtySelected = 6;
	} else if (type == "case12") {
		qty = parseInt($("#btcs_qty_" + itemId).data("case12"));
		if (qty < 24 && inventPolicy == 0) {
			qty = 2;
		}
		if (minQty < 12) qtySelected = 12;
	}

	if (qty < 1) qty = 1;

	for (i = 1; i <= qty; i++) {
		if (type == "bottle") {
			if (i < minQty || (maxQty > 0 && i > maxQty)) {
				qtyHtml += '<option disabled value="' + i + '">' + i + "</option>";
			} else {
				if (i == minQty) {
					qtyHtml +=
						'<option selected="selected" value="' + i + '">' + i + "</option>";
				} else {
					qtyHtml += '<option value="' + i + '">' + i + "</option>";
				}
			}
		} else if (type == "case6") {
			if (i * 6 < minQty || (maxQty > 0 && i * 6 > maxQty)) {
				qtyHtml += '<option disabled value="' + i * 6 + '">' + i + "</option>";
			} else {
				if (i * 6 == minQty) {
					qtyHtml +=
						'<option selected="selected" value="' +
						i * 6 +
						'">' +
						i +
						"</option>";
				} else {
					qtyHtml += '<option value="' + i * 6 + '">' + i + "</option>";
				}
			}
		} else if (type == "case12") {
			if (i * 12 < minQty || (maxQty > 0 && i * 12 > maxQty)) {
				qtyHtml += '<option disabled value="' + i * 12 + '">' + i + "</option>";
			} else {
				if (i * 12 == minQty)
					qtyHtml +=
						'<option selected="selected" value="' +
						i * 12 +
						'">' +
						i +
						"</option>";
				else qtyHtml += '<option value="' + i * 12 + '">' + i + "</option>";
			}
		}
	}

	$("#btcs_qty_" + itemId).html(qtyHtml);
	//UPDATE FOR BOLD APP
	var wrapper = $("#type_" + itemId).closest(".list-view-item-wrapper");
	if (wrapper.find(".shappify_qb_grid").length) {
		var _totalQty = 1;
		switch (type) {
			case "bottle":
				_totalQty = 1;
				break;
			case "case6":
				_totalQty = 6;
				break;
			case "case12":
				_totalQty = 12;
				break;
			default:
				_totalQty = 1;
		}
		var _prices_handle = 0;
		var _prices_HTML = "";
		wrapper.find(".price-per-bottle").each(function () {
			var _qty = $(this).data("qty");
			if (_totalQty >= _qty) {
				_prices_HTML = $(this).data("price");
				_prices_handle = $(this).data("price");
				_prices_handle = _prices_handle.replace(".", "").substring(1);
			}
		});
		wrapper.find(".price-per-bottle .b-price").html(_prices_HTML);
		wrapper
			.find(".price-item--regular, .price-item--sale")
			.html(Shopify.formatMoney(_totalQty * _prices_handle));
	} else {
		// Update price
		var regularPrice = $("#type_" + itemId).attr("data-regular-price");
		var comparePrice = $("#type_" + itemId).attr("data-compare-price");
		updatePriceText(
			$("#type_" + itemId),
			regularPrice,
			comparePrice,
			qtySelected,
			itemId
		);

		//console.log(regularPrice);
	}
}

function updatePriceText(item, regularPrice, comparePrice, qty, itemId) {
	$('#btcs_list_' +itemId).val(qty);
	var wrapper = $(item).closest(".list-view-item-wrapper");
	if (wrapper.find(".shappify_qb_grid").length) {
		var _totalQty = $(item).val();
		var _prices_handle = 0;
		var _prices_HTML = "";
		wrapper.find(".price-per-bottle").each(function () {
			var _qty = $(this).data("qty");
			if (_totalQty >= _qty) {
				_prices_HTML = $(this).data("price");
				_prices_handle = $(this).data("price");
				_prices_handle = _prices_handle.replace(".", "").substring(1);
			}
		});
		wrapper.find(".price-per-bottle .b-price").html(_prices_HTML);
		wrapper
			.find(".price-item--regular, .price-item--sale")
			.html(Shopify.formatMoney(_totalQty * _prices_handle));
	} else {
		var price = parseFloat(regularPrice) * parseInt(qty);
		console.log("antoehr price is", price);
		var currencySymbol = "$";
		if (regularPrice != comparePrice && comparePrice != 0) {
			var comparePriceText = parseFloat(comparePrice) * parseInt(qty);
			$(item)
				.parents(".list-view-item")
				.find(".price-item--sale")
				.text(numberWithCommas(currencySymbol + price.toFixed(2)));
			$(item)
				.parents(".list-view-item")
				.find(".price-item--regular")
				.text(numberWithCommas(currencySymbol + comparePriceText.toFixed(2)));
		} else {
			$(item)
				.parents(".list-view-item")
				.find(".price-item--regular")
				.text(numberWithCommas(currencySymbol + price.toFixed(2)));
		}
	}
	var price = parseFloat(regularPrice) * parseInt(qty);
		var currencySymbol = "$";
		if (regularPrice != comparePrice && comparePrice != 0) {
			var comparePriceText = parseFloat(comparePrice) * parseInt(qty);
			$(item)
				.parents(".grid-view-item")
				.find(".price-item--sale")
				.text(numberWithCommas(currencySymbol + price.toFixed(2)));
			$(item)
				.parents(".grid-view-item")
				.find(".price-item--regular")
				.text(numberWithCommas(currencySymbol + comparePriceText.toFixed(2)));
		} else {
			$(item)
				.parents(".grid-view-item")
				.find(".price-item--regular")
				.text(numberWithCommas(currencySymbol + price.toFixed(2)));
		}

	var tier = $("#listprice_" +itemId).attr("data-tier");
	var tier24 = $("#listprice1_" +itemId).attr("data-tier");

	console.log("the tiers are", tier);

	var itemprice = regularPrice; 
	
	console.log("the numbers mason", itemprice);
	console.log("quantity is ", qty);

	var tier12price = price / qty * 0.95;
	var tier24price = price / qty * 0.90;

	var tier12Total = price * 0.95;
	var tier24Total = price * 0.90;

	var salePercent = 1 - (regularPrice / comparePrice);

	normalSale = salePercent * 100;

	var tier12Sale = (salePercent * 1.05) * 100;
	var tier24Sale = (salePercent * 1.10) * 100;

	console.log("the tier12 sale is", tier24Sale);

	console.log("tier price", tier12price);

	console.log("it is 12 !! ");

	if (tier == 12){
		if (tier24 == 24){
			if (qty >=12 && qty < 24){
				$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier12price.toFixed(2)));
				console.log("this is the one tim");

				$(item)
				.parents(".list-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier12Total.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier12Sale.toFixed() + "% Off</span>");

			}
			else if (qty >=24){
				$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier24price.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier24Total.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier24Sale.toFixed() + "% Off</span>");

			}
			else{
				$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");
			}
		}
		else {
			if (qty >=12){
				$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier12price.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier12Total.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier12Sale.toFixed() + "% Off</span>");


			}
			else {
				$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");

			}
		}
	}
	else if (qty < 12){
		$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");

	}

	if (tier24 == 24 && tier != 12){
		if (qty >=24){
			$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier24price.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier24Total.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier24Sale.toFixed() + "% Off</span>");

		}
		else {
			$(item)
				.parents(".list-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".list-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");
		}
	}
	
	//grid view update 

	var tier = $("#gridprice1_" +itemId).attr("data-tier");
	var tier24 = $("#gridprice2_" +itemId).attr("data-tier");

	console.log("the tiers are", tier);

	var itemprice = regularPrice; 
	
	console.log("the numbers mason", itemprice);
	console.log("quantity is ", qty);

	var tier12price = price / qty * 0.95;
	var tier24price = price / qty * 0.90;

	var tier12Total = price * 0.95;
	var tier24Total = price * 0.90;

	console.log("tier price", tier24price);
	

	console.log("it is 12 !! ");

	if (tier == 12){
		if (tier24 == 24){
			if (qty >=12 && qty < 24){
				$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier12price.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier12Total.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier12Sale.toFixed() + "% Off</span>");

			}
			else if (qty >=24){
				$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier24price.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier24Total.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier24Sale.toFixed() + "% Off</span>");

			}
			else{
				$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");
			}
		}
		else {
			if (qty >=12){
				$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier12price.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier12Total.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier12Sale.toFixed() + "% Off</span>");

			}
			else {
				$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");
			}
		}
	}
	else if (qty < 12){
		$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");
	}

	if (tier24 == 24 && tier != 12){
		if (qty >=24){
			$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + tier24price.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".price-item")
				.text(numberWithCommas(currencySymbol + tier24Total.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + tier24Sale.toFixed() + "% Off</span>");

		}
		else {
			$(item)
				.parents(".grid-view-item")
				.find(".b-price")
				.text(numberWithCommas(currencySymbol + itemprice.toFixed(2)));

				$(item)
				.parents(".grid-view-item")
				.find(".sale-percent-list")
				.html("<span>" + normalSale.toFixed() + "% Off</span>");
		}
	}

	console.log("we have been clicked my pal");

	var amount = $('#btcs_list_' +itemId).attr('value');

	console.log("the amount in your thing is ", amount);

	$('#btcs_qty_' +itemId+' option[value='+amount+']').attr('selected','selected');

}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function changeQty(element) {
	var valueOn = parseInt($(element).val());
	if (valueOn < 0 || isNaN(valueOn)) {
		valueOn = 0;
		$(element).val(0);
	} else {
		$(element).addClass("changed");
		var minQty = parseInt($(element).attr("min"));
		var maxQty = parseInt($(element).attr("max"));
		var itemId = $(element)
			.parents(".product-card-add")
			.attr("data-product-id");

		if (typeof $("#case_qty_" + itemId).attr("data-caseqty") != "undefined")
			var caseRatio = parseInt($("#case_qty_" + itemId).attr("data-caseqty"));
		else var caseRatio = 1;

		//ChangeQty for bottle
		if ($(element).parents(".price-variant").hasClass("price-variant-bottle")) {
			var valueCase = parseInt(
				$(element)
					.parents(".product-quantity")
					.find(".price-variant-case input")
					.val()
			);
			qty = valueOn + valueCase * caseRatio;
			var newValforCase = valueOn + (valueCase + 1) * caseRatio;

			if (qty < minQty || qty > maxQty) {
				if (qty < minQty) {
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .at-least")
						.show();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .at-most")
						.hide();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .min-continue")
						.show();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .max-continue")
						.hide();
				} else {
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .at-least")
						.hide();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .at-most")
						.show();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .min-continue")
						.hide();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue .max-continue")
						.show();
				}
				$(".bt-inc-" + itemId)
					.parents(".product-card-add")
					.find(".product-card-continue")
					.show();
				$(".bt-inc-" + itemId)
					.parents(".product-card-add")
					.find(".product-card-case-continue")
					.hide();
			} else {
				if (!$("#case_qty_" + itemId).hasClass("changed")) {
					if (newValforCase <= maxQty)
						$(".cs-inc-" + itemId).removeClass("disabled");
					else $(".cs-inc-" + itemId).addClass("disabled");
				}
			}
		} else {
			var valueBottle = parseInt(
				$(element)
					.parents(".product-quantity")
					.find(".price-variant-bottle input")
					.val()
			);
			qty = valueOn * caseRatio + valueBottle;

			if (qty < minQty || qty > maxQty) {
				if (qty < minQty) {
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .at-least")
						.show();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .at-most")
						.hide();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .min-continue")
						.show();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .max-continue")
						.hide();
				} else {
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .at-least")
						.hide();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .at-most")
						.show();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .min-continue")
						.hide();
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-case-continue .max-continue")
						.show();
				}
				$(".bt-inc-" + itemId)
					.parents(".product-card-add")
					.find(".product-card-continue")
					.hide();
				$(".bt-inc-" + itemId)
					.parents(".product-card-add")
					.find(".product-card-case-continue")
					.show();
			}

			if (qty > maxQty && maxQty > 0) {
				$(element)
					.parents(".product-card-add")
					.find("span")
					.addClass("disabled");
			} else {
				$(element)
					.parents(".product-card-add")
					.find("span")
					.removeClass("disabled");
				if (valueBottle == 0) {
					$(".bt-dec-" + itemId).addClass("disabled");
				}

				if (qty < minQty && minQty > 1) {
					$(element)
						.parents(".product-card-add")
						.find("span")
						.addClass("disabled");
					$(".bt-inc-" + itemId)
						.parents(".product-card-add")
						.find(".product-card-continue")
						.show();
				} else {
					$(element)
						.parents(".product-card-add")
						.find("span")
						.removeClass("disabled");
					if (valueBottle == 0) {
						$(".bt-dec-" + itemId).addClass("disabled");
					}
				}
			}
		}
	}
}

function btnQuantyMin(itemId, itemName, producer, isBundlebuilder, qty) {
	var btnDecDisabled = false;
	if ($(".bt-dec-" + itemId).hasClass("disabled")) {
		btnDecDisabled = true;
	}

	$(".btn-continue-" + itemId)
		.parent(".product-card-continue")
		.hide();
	$(".btn-continue-" + itemId)
		.parent(".product-card-case-continue")
		.hide();

	var oldItem = $(".bt-inc-" + itemId)
		.parent()
		.find("input");
	var oldVal = parseInt(oldItem.val());
	var caseItem = $(".bt-inc-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-case input");
	var caseQty = parseInt(caseItem.val());
	var priceBt = parseFloat(oldItem.data("price"));
	var priceCase = parseFloat(caseItem.data("price"));
	var minQty = parseInt(
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.attr("min")
	);
	var maxQty = parseInt(
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.attr("max")
	);
	var caseRatio = parseInt($("#case_qty_" + itemId).data("caseqty"));
	var newVal = qty - caseQty * caseRatio;

	if (qty > 0) {
		var price = bcsffilter.formatMoney(qty * priceBt, bcsffilter.moneyFormat);
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.val(newVal);
		$(".bt-inc-" + itemId)
			.parents(".grid-view-item")
			.find(".btn-action")
			.addClass("btn-adding")
			.removeClass("btn-cancel btn-viewcart")
			.find("span")
			.text("Adding to cart");
		$(".bt-inc-" + itemId)
			.parents(".product-card-add")
			.addClass("spinner-active")
			.find(".spinner")
			.show();
		if (
			$(".bt-inc-" + itemId)
				.parents(".product-card-add")
				.hasClass("added")
		) {
			CartJS.updateItemById(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");

							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$(".bt-dec-" + itemId).addClass("disabled");
						$("#bc-sf-filter-loading").hide();
						$(".bt-dec-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();

						$(".bt-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".bt-dec-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("updated to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}

						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");

						if (newVal > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						if (caseQty > 0) $(".cs-dec-" + itemId).removeClass("disabled");

						if ((caseQty + 1) * caseRatio + newVal <= maxQty) {
							$(".cs-inc-" + itemId).removeClass("disabled");
						} else {
							$(".cs-inc-" + itemId).addClass("disabled");
						}

						if (caseQty * caseRatio + newVal + 1 <= maxQty) {
							$(".bt-inc-" + itemId).removeClass("disabled");
						} else {
							$(".bt-inc-" + itemId).addClass("disabled");
						}

						oldItem.removeClass("changed");
						$("#case_qty_" + itemId).removeClass("changed");
						$(".bt-inc-" + itemId)
							.parent()
							.find("input")
							.val(newVal);
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		} else {
			CartJS.addItem(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						//save producer to localStorage for displaying in minicart
						if (producer != null && "" != producer && !isBundlebuilder) {
							localStorage.setItem("producer-of-" + itemId, producer);
						}
						localStorage.setItem("max-qty-of-" + itemId, maxQty);
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");

							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$("#bc-sf-filter-loading").hide();
						$(".bt-inc-" + itemId)
							.parents(".product-card-add")
							.addClass("added")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".bt-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".bt-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);
						//showPopup(itemName, 'add');

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("added to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}
						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (newVal > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						if (caseQty > 0) $(".cs-dec-" + itemId).removeClass("disabled");

						if ((caseQty + 1) * caseRatio + newVal <= maxQty) {
							$(".cs-inc-" + itemId).removeClass("disabled");
						} else {
							$(".cs-inc-" + itemId).addClass("disabled");
						}

						if (caseQty * caseRatio + newVal + 1 <= maxQty) {
							$(".bt-inc-" + itemId).removeClass("disabled");
						} else {
							$(".bt-inc-" + itemId).addClass("disabled");
						}

						$(".bt-inc-" + itemId)
							.parents(".product-card-add")
							.addClass("added");
						oldItem.removeClass("changed");
						$("#case_qty_" + itemId).removeClass("changed");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		}
	}
}

function bottleQuantyIncrease(itemId, itemName, producer, isBundlebuilder) {
	var btnDecDisabled = false;
	if ($(".bt-dec-" + itemId).hasClass("disabled")) {
		btnDecDisabled = true;
	}
	var oldItem = $(".bt-inc-" + itemId)
		.parent()
		.find("input");
	var oldVal = parseInt(oldItem.val());
	var caseItem = $(".bt-inc-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-case input");
	var caseQty = parseInt(caseItem.val());
	var priceBt = oldItem.data("price");
	var priceCase = caseItem.data("price");
	var minQty = parseInt(
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.attr("min")
	);
	var maxQty = parseInt(
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.attr("max")
	);
	var step = parseInt(
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.attr("step")
	);
	var caseRatio = parseInt($("#case_qty_" + itemId).data("caseqty"));

	if (isNaN(oldVal)) oldVal = 0;

	if (oldItem.hasClass("changed")) var newVal = oldVal;
	else var newVal = oldVal + step;

	var qty = newVal + caseQty * caseRatio;

	if (qty < minQty) {
		newVal = minQty - caseQty * caseRatio;
		qty = minQty;
	}

	if (qty < minQty) {
		$(".bt-inc-" + itemId)
			.parents(".product-card-add")
			.find(".product-card-continue")
			.show();
	} else {
		var price = bcsffilter.formatMoney(qty * priceBt, bcsffilter.moneyFormat);
		if (
			$(".bt-inc-" + itemId)
				.parents(".product-card-add")
				.hasClass("added")
		) {
			$(".bt-inc-" + itemId)
				.parents(".grid-view-item")
				.find(".btn-action")
				.addClass("btn-adding")
				.removeClass("btn-cancel btn-viewcart")
				.find("span")
				.text("Updating to cart");
			CartJS.updateItemById(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");
							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$(".bt-dec-" + itemId).addClass("disabled");
						$("#bc-sf-filter-loading").hide();
						$(".bt-dec-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".bt-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						//showPopup(itemName, 'update');
						$(".bt-dec-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("updated to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}
						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (newVal > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						if (caseQty > 0) $(".cs-dec-" + itemId).removeClass("disabled");
						oldItem.removeClass("changed");
						$("#case_qty_" + itemId).removeClass("changed");
						$(".bt-inc-" + itemId)
							.parent()
							.find("input")
							.val(newVal);

						var nextQty = (caseQty + 1) * caseRatio + newVal;
						if (nextQty > maxQty) $(".cs-inc-" + itemId).addClass("disabled");
						var nextQtyBottle = caseQty * caseRatio + newVal + 1;
						if (nextQtyBottle > maxQty)
							$(".bt-inc-" + itemId).addClass("disabled");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		} else {
			$(".bt-inc-" + itemId)
				.parents(".grid-view-item")
				.find(".btn-action")
				.addClass("btn-adding")
				.removeClass("btn-cancel btn-viewcart")
				.find("span")
				.text("Adding to cart");
			CartJS.addItem(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						//save producer to localStorage for displaying in minicart
						if (producer != null && "" != producer && !isBundlebuilder) {
							localStorage.setItem("producer-of-" + itemId, producer);
						}
						localStorage.setItem("max-qty-of-" + itemId, maxQty);
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");
							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$("#bc-sf-filter-loading").hide();
						$(".bt-inc-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".bt-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".bt-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);
						//showPopup(itemName, 'update');
						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("added to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}
						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (newVal > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						if (caseQty > 0) $(".cs-dec-" + itemId).removeClass("disabled");
						$(".bt-inc-" + itemId)
							.parents(".product-card-add")
							.addClass("added");
						oldItem.removeClass("changed");
						$("#case_qty_" + itemId).removeClass("changed");
						$(".bt-inc-" + itemId)
							.parent()
							.find("input")
							.val(newVal);

						var nextQty = (caseQty + 1) * caseRatio + newVal;
						if (nextQty > maxQty) $(".cs-inc-" + itemId).addClass("disabled");
						var nextQtyBottle = caseQty * caseRatio + newVal + 1;
						if (nextQtyBottle > maxQty)
							$(".bt-inc-" + itemId).addClass("disabled");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		}
	}
}

function bottleQuantyDecrease(itemId, itemName) {
	var btnDecDisabled = false;
	if ($(".bt-dec-" + itemId).hasClass("disabled")) {
		btnDecDisabled = true;
	}
	var oldItem = $(".bt-dec-" + itemId)
		.parent()
		.find("input");
	var oldVal = parseInt(oldItem.val());
	var caseItem = $(".bt-dec-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-case input");
	var caseQty = parseInt(caseItem.val());
	var priceBt = parseFloat(oldItem.data("price"));
	var priceCase = parseFloat(caseItem.data("price"));
	var minQty = parseInt(
		$(".bt-dec-" + itemId)
			.parent()
			.find("input")
			.attr("min")
	);
	var maxQty = parseInt(
		$(".bt-dec-" + itemId)
			.parent()
			.find("input")
			.attr("max")
	);
	var step = parseInt(
		$(".bt-inc-" + itemId)
			.parent()
			.find("input")
			.attr("step")
	);
	var caseRatio = parseInt($("#case_qty_" + itemId).data("caseqty"));

	if (isNaN(oldVal)) oldVal = 0;
	if ((btnDecDisabled || oldItem.hasClass("changed")) && oldVal > 0)
		var newVal = oldVal;
	else var newVal = oldVal - step;

	if (newVal < 0) newVal = 0;
	var qty = newVal + caseQty * caseRatio;

	if (qty >= minQty) {
		var price = bcsffilter.formatMoney(qty * priceBt, bcsffilter.moneyFormat);
		//$("#bt-dec-"+itemId).parents('.grid__item').find('#quantity').val(qty);
		$(".bc-sf-filter-loading").show();
		$(".bt-dec-" + itemId)
			.parents(".grid-view-item")
			.find(".btn-action")
			.removeClass("btn-viewcart btn-adding")
			.find("span")
			.text("Updating to cart");
		$(".bt-dec-" + itemId)
			.parents(".product-card-add")
			.addClass("spinner-active")
			.find(".spinner")
			.show();
		CartJS.updateItemById(
			itemId,
			qty,
			{},
			{
				success: function (data, textStatus, jqXHR) {
					var shopTaxesIncluded = $(".shop_taxes_included").text();
					jQuery.getJSON("/cart.js", function (cart) {
						var price = 0;
						for (cartItem of cart.items) {
							if (shopTaxesIncluded != "true") {
								if (cartItem.taxable) {
									var priceItem = cartItem.final_line_price;
									var tax = priceItem * 0.1;
									price += priceItem + tax;
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							} else {
								var priceItem = cartItem.final_line_price;
								price += priceItem;
							}
						}

						$(".minicart-subtotal, .minicart-total, .total-value").html(
							Shopify.formatMoney(price)
						);
						var cartCount = getCartCount(cart);
						if (cartCount <= 1)
							$(".minicart-items-count").html(cartCount + " Item");
						else $(".minicart-items-count").html(cartCount + " Items");

						$(".site-header__cart-count span").first().next().html(cartCount);
						$("#CartCount span.cart-count").html(cartCount);
					});

					$("#bc-sf-filter-loading").hide();
					$(".bt-dec-" + itemId)
						.parents(".product-card-add")
						.removeClass("spinner-active");
					$(".spinner").hide();
					$(".bt-dec-" + itemId)
						.parents(".grid-view-item")
						.find(".btn-action")
						.addClass("btn-viewcart")
						.removeClass("btn-adding btn-added btn-cancel")
						.find("span")
						.text("View Cart");
					//showPopup(itemName, 'update');
					$(".bt-dec-" + itemId)
						.parents(".grid-view-item")
						.find(".subtotal-price")
						.html(price);

					$(".line-item-list").empty();
					loadMinicart();
					$(".minicart-success")
						.show()
						.find("span.update-text")
						.text("updated to");

					if (data.items_subtotal_price > 0) {
						$(".minicart-panel").removeClass("minicart-empty");
						document.getElementById(
							"minicart-panel-items-loading"
						).innerHTML = null;
					} else {
						$(".minicart-panel").addClass("minicart-empty");
						$(".minicart-success").hide();
						document.getElementById("minicart-panel-items-loading").innerHTML =
							"Your cart is empty";
					}
					$(".minicart-panel").addClass("open");
					$("html").addClass("minicart-open");
					if (newVal <= 0) $(".bt-dec-" + itemId).addClass("disabled");
					if (caseQty <= 0) $(".cs-dec-" + itemId).addClass("disabled");
					oldItem.removeClass("changed");
					$("#case_qty_" + itemId).removeClass("changed");
					$(".bt-dec-" + itemId)
						.parent()
						.find("input")
						.val(newVal);

					$(".bt-inc-" + itemId).removeClass("disabled");
					var nextQty = (caseQty + 1) * caseRatio + newVal;
					if (nextQty <= maxQty) $(".cs-inc-" + itemId).removeClass("disabled");
				},
				error: function (data, textStatus, jqXHR) {
					$("#bc-sf-filter-loading").hide();
				},
			}
		);
	} else {
		var qty = (price = 0);
		$(".bt-dec-" + itemId)
			.parent()
			.find("input")
			.val(newVal);
		$(".bc-sf-filter-loading").show();
		$(".bt-dec-" + itemId)
			.parents(".grid-view-item")
			.find(".btn-action")
			.removeClass("btn-viewcart btn-adding")
			.find("span")
			.text("Removing to cart");
		$(".bt-dec-" + itemId)
			.parents(".product-card-add")
			.addClass("spinner-active")
			.find(".spinner")
			.show();
		CartJS.removeItemById(itemId, {
			success: function (data, textStatus, jqXHR) {
				$(".cs-dec-" + itemId)
					.parents()
					.eq(5)
					.find(".btn-action")
					.removeClass("btn-viewcart")
					.addClass("btn-cancel")
					.find("span")
					.text("Cancel");
				var shopTaxesIncluded = $(".shop_taxes_included").text();
				jQuery.getJSON("/cart.js", function (cart) {
					var price = 0;
					for (cartItem of cart.items) {
						if (shopTaxesIncluded != "true") {
							if (cartItem.taxable) {
								var priceItem = cartItem.final_line_price;
								var tax = priceItem * 0.1;
								price += priceItem + tax;
							} else {
								var priceItem = cartItem.final_line_price;
								price += priceItem;
							}
						} else {
							var priceItem = cartItem.final_line_price;
							price += priceItem;
						}
					}

					$(".minicart-subtotal, .minicart-total, .total-value").html(
						Shopify.formatMoney(price)
					);
					var cartCount = getCartCount(cart);
					if (cartCount <= 1)
						$(".minicart-items-count").html(cartCount + " Item");
					else $(".minicart-items-count").html(cartCount + " Items");
					$(".site-header__cart-count span").first().next().html(cartCount);
					$("#CartCount span.cart-count").html(cartCount);
				});

				$("#bc-sf-filter-loading").hide();
				$(".cs-dec-" + itemId)
					.parents(".product-card-add")
					.removeClass("spinner-active");
				$(".spinner").hide();
				$(".cs-dec-" + itemId)
					.parents(".grid-view-item")
					.find(".btn-action")
					.addClass("btn-cancel")
					.removeClass("btn-adding btn-viewcart")
					.find("span")
					.text("Cancel");
				$(".cs-dec-" + itemId)
					.parents(".grid-view-item")
					.find(".subtotal-price")
					.html(bcsffilter.formatMoney(0, bcsffilter.moneyFormat));

				$(".line-item-list").empty();
				loadMinicart();
				$(".minicart-success")
					.show()
					.find("span.update-text")
					.text("removed from");

				if (data.items_subtotal_price > 0) {
					$(".minicart-panel").removeClass("minicart-empty");
					document.getElementById(
						"minicart-panel-items-loading"
					).innerHTML = null;
				} else {
					$(".minicart-panel").addClass("minicart-empty");
					$(".minicart-success").hide();
					document.getElementById("minicart-panel-items-loading").innerHTML =
						"Your cart is empty";
				}

				$(".minicart-panel").addClass("open");
				$("html").addClass("minicart-open");

				$(".bt-dec-" + itemId).addClass("disabled");
				$(".cs-dec-" + itemId).addClass("disabled");
				oldItem.removeClass("changed");
				$("#case_qty_" + itemId).removeClass("changed");
				$(".bt-dec-" + itemId)
					.parent()
					.find("input")
					.val(0);
				$(".cs-dec-" + itemId)
					.parent()
					.find("input")
					.val(0);
				$(".bt-dec-" + itemId)
					.parents(".product-card-add")
					.removeClass("added");

				$(".bt-inc-" + itemId).removeClass("disabled");
				var nextQty = (caseQty + 1) * caseRatio + newVal;
				if (nextQty > maxQty) $(".cs-inc-" + itemId).addClass("disabled");
			},
			error: function (data, textStatus, jqXHR) {
				$("#bc-sf-filter-loading").hide();
			},
		});
	}
}

function btnCaseQuantyMin(
	itemId,
	itemName,
	producer,
	isBundlebuilder,
	checkQty
) {
	var oldItem = $(".cs-inc-" + itemId)
		.parent()
		.find("input");
	var oldVal = parseInt(
		$(".cs-inc-" + itemId)
			.parent()
			.find("input")
			.val()
	);
	var bottleItem = $(".cs-inc-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-bottle input");
	var priceCase = parseFloat(oldItem.data("price"));
	var priceBt = parseFloat(bottleItem.data("price"));
	var minQty = parseInt(
		$(".cs-inc-" + itemId)
			.parent()
			.find("input")
			.attr("min")
	);
	var maxQty = parseInt(
		$(".cs-inc-" + itemId)
			.parent()
			.find("input")
			.attr("max")
	);

	var caseRatio = parseInt($("#case_qty_" + itemId).data("caseqty"));
	var bottleQty = parseInt(
		$(".cs-inc-" + itemId)
			.parents(".product-quantity")
			.find(".price-variant-bottle input")
			.val()
	);

	var newVal = Math.floor(parseInt(checkQty) / parseInt(caseRatio));
	var qty = newVal * caseRatio + bottleQty;

	if (qty < minQty) {
		bottleQty = minQty - newVal * caseRatio;
	}

	if (qty > maxQty) {
		bottleQty = maxQty - newVal * caseRatio;
	}

	qty = newVal * caseRatio + bottleQty;

	$(".cs-inc-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-bottle input")
		.val(bottleQty);
	$(".cs-inc-" + itemId)
		.parent()
		.find("input")
		.val(newVal);

	var price = bcsffilter.formatMoney(qty * priceBt, bcsffilter.moneyFormat);

	$(".cs-inc-" + itemId)
		.parents(".grid-view-item")
		.find(".btn-action")
		.addClass("btn-adding")
		.removeClass("btn-cancel btn-viewcart")
		.find("span")
		.text("Adding to cart");
	$(".cs-inc-" + itemId)
		.parents(".product-card-add")
		.addClass("spinner-active")
		.find(".spinner")
		.show();
	$(".bc-sf-filter-loading").show();
	$(".btn-continue-" + itemId)
		.parent(".product-card-case-continue")
		.hide();
	$(".btn-continue-" + itemId)
		.parent(".product-card-continue")
		.hide();

	if (
		$(".cs-inc-" + itemId)
			.parents(".product-card-add")
			.hasClass("added")
	) {
		CartJS.updateItemById(
			itemId,
			qty,
			{},
			{
				success: function (data, textStatus, jqXHR) {
					var shopTaxesIncluded = $(".shop_taxes_included").text();
					jQuery.getJSON("/cart.js", function (cart) {
						var price = 0;
						for (cartItem of cart.items) {
							if (shopTaxesIncluded != "true") {
								if (cartItem.taxable) {
									var priceItem = cartItem.final_line_price;
									var tax = priceItem * 0.1;
									price += priceItem + tax;
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							} else {
								var priceItem = cartItem.final_line_price;
								price += priceItem;
							}
						}

						$(".minicart-subtotal, .minicart-total, .total-value").html(
							Shopify.formatMoney(price)
						);
						var cartCount = getCartCount(cart);
						if (cartCount <= 1)
							$(".minicart-items-count").html(cartCount + " Item");
						else $(".minicart-items-count").html(cartCount + " Items");
						$(".site-header__cart-count span").first().next().html(cartCount);
						$("#CartCount span.cart-count").html(cartCount);
					});

					$(".cs-inc-" + itemId)
						.parents(".product-card-add")
						.addClass("added");
					$("#bc-sf-filter-loading").hide();
					$(".cs-dec-" + itemId)
						.parents(".product-card-add")
						.removeClass("spinner-active");
					$(".spinner").hide();
					$(".cs-dec-" + itemId)
						.parents(".grid-view-item")
						.find(".btn-action")
						.addClass("btn-viewcart")
						.removeClass("btn-adding")
						.find("span")
						.text("View cart");
					$(".cs-inc-" + itemId)
						.parents(".grid-view-item")
						.find(".subtotal-price")
						.html(price);

					$(".line-item-list").empty();
					loadMinicart();
					$(".minicart-success")
						.show()
						.find("span.update-text")
						.text("updated to");

					if (data.items_subtotal_price > 0) {
						$(".minicart-panel").removeClass("minicart-empty");
						document.getElementById(
							"minicart-panel-items-loading"
						).innerHTML = null;
					} else {
						$(".minicart-panel").addClass("minicart-empty");
						$(".minicart-success").hide();
						document.getElementById("minicart-panel-items-loading").innerHTML =
							"Your cart is empty";
					}

					$(".minicart-panel").addClass("open");
					$("html").addClass("minicart-open");

					if (newVal > 0) $(".cs-dec-" + itemId).removeClass("disabled");

					if (bottleQty > 0) $(".bt-dec-" + itemId).removeClass("disabled");

					if ((newVal + 1) * caseRatio + bottleQty <= maxQty) {
						$(".cs-inc-" + itemId).removeClass("disabled");
					} else {
						$(".cs-inc-" + itemId).addClass("disabled");
					}

					if (newVal * caseRatio + bottleQty + 1 <= maxQty) {
						$(".bt-inc-" + itemId).removeClass("disabled");
					} else {
						$(".bt-inc-" + itemId).addClass("disabled");
					}

					oldItem.removeClass("changed");
					$("#bottle_qty_" + itemId).removeClass("changed");
					$(".cs-inc-" + itemId)
						.parent()
						.find("input")
						.val(newVal);
				},
				error: function (data, textStatus, jqXHR) {
					$("#bc-sf-filter-loading").hide();
				},
			}
		);
	} else {
		CartJS.addItem(
			itemId,
			qty,
			{},
			{
				success: function (data, textStatus, jqXHR) {
					//save producer to localStorage for displaying in minicart
					if (producer != null && "" != producer && !isBundlebuilder) {
						localStorage.setItem("producer-of-" + itemId, producer);
					}
					localStorage.setItem("max-qty-of-" + itemId, maxQty);
					var shopTaxesIncluded = $(".shop_taxes_included").text();

					jQuery.getJSON("/cart.js", function (cart) {
						var price = 0;
						for (cartItem of cart.items) {
							if (shopTaxesIncluded != "true") {
								if (cartItem.taxable) {
									var priceItem = cartItem.final_line_price;
									var tax = priceItem * 0.1;
									price += priceItem + tax;
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							} else {
								var priceItem = cartItem.final_line_price;
								price += priceItem;
							}
						}

						$(".minicart-subtotal, .minicart-total, .total-value").html(
							Shopify.formatMoney(price)
						);
						var cartCount = getCartCount(cart);
						if (cartCount <= 1)
							$(".minicart-items-count").html(cartCount + " Item");
						else $(".minicart-items-count").html(cartCount + " Items");

						$(".site-header__cart-count span").first().next().html(cartCount);
						$("#CartCount span.cart-count").html(cartCount);
					});

					$("#bc-sf-filter-loading").hide();
					$(".cs-inc-" + itemId)
						.parents(".product-card-add")
						.removeClass("spinner-active");
					$(".spinner").hide();
					$(".cs-inc-" + itemId)
						.parents(".grid-view-item")
						.find(".btn-action")
						.addClass("btn-viewcart")
						.removeClass("btn-adding")
						.find("span")
						.text("View cart");
					$(".cs-inc-" + itemId)
						.parents(".grid-view-item")
						.find(".subtotal-price")
						.html(price);

					$(".line-item-list").empty();
					loadMinicart();
					$(".minicart-success")
						.show()
						.find("span.update-text")
						.text("added to");

					if (data.items_subtotal_price > 0) {
						$(".minicart-panel").removeClass("minicart-empty");
						document.getElementById(
							"minicart-panel-items-loading"
						).innerHTML = null;
					} else {
						$(".minicart-panel").addClass("minicart-empty");
						$(".minicart-success").hide();
						document.getElementById("minicart-panel-items-loading").innerHTML =
							"Your cart is empty";
					}
					$(".minicart-panel").addClass("open");
					$("html").addClass("minicart-open");
					$(".product-card-case-continue").hide();
					$(".cs-dec-" + itemId).removeClass("disabled");

					if (bottleQty > 0) $(".bt-dec-" + itemId).removeClass("disabled");

					oldItem.removeClass("changed");
					$("#bottle_qty_" + itemId).removeClass("changed");
					$(".cs-inc-" + itemId)
						.parents(".product-card-add")
						.addClass("added");
				},
				error: function (data, textStatus, jqXHR) {
					$("#bc-sf-filter-loading").hide();
				},
			}
		);
	}
}

function caseQuantyIncrease(itemId, itemName, producer, isBundlebuilder) {
	var btnDecDisabled = false;
	if ($(".cs-dec-" + itemId).hasClass("disabled")) {
		btnDecDisabled = true;
	}
	var oldItem = $(".cs-inc-" + itemId)
		.parent()
		.find("input");
	var oldVal = parseInt(
		$(".cs-inc-" + itemId)
			.parent()
			.find("input")
			.val()
	);
	var bottleItem = $(".cs-inc-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-bottle input");
	var priceCase = parseFloat(oldItem.data("price"));
	var priceBt = parseFloat(bottleItem.data("price"));
	var minQty = parseInt(
		$(".cs-inc-" + itemId)
			.parent()
			.find("input")
			.attr("min")
	);
	var maxQty = parseInt(
		$(".cs-inc-" + itemId)
			.parent()
			.find("input")
			.attr("max")
	);
	var caseRatio = parseInt($("#case_qty_" + itemId).data("caseqty"));

	var bottleQty = parseInt(
		$(".cs-inc-" + itemId)
			.parents(".product-quantity")
			.find(".price-variant-bottle input")
			.val()
	);

	if (isNaN(oldVal)) oldVal = 0;
	if (isNaN(bottleQty)) bottleQty = 0;
	if (oldItem.hasClass("changed") && oldVal != 0) {
		var newVal = oldVal;
	} else {
		var newVal = oldVal + 1;
	}

	var qty = bottleQty + newVal * caseRatio;
	if (qty < minQty && minQty > 1) {
		$(".cs-inc-" + itemId)
			.parents(".product-card-add")
			.find(".product-card-case-continue")
			.show();
	} else {
		$(".cs-inc-" + itemId)
			.parents(".grid-view-item")
			.find(".btn-action")
			.addClass("btn-adding")
			.removeClass("btn-cancel btn-viewcart")
			.find("span")
			.text("Adding to cart");
		$(".cs-inc-" + itemId)
			.parents(".product-card-add")
			.addClass("spinner-active")
			.find(".spinner")
			.show();
		$(".bc-sf-filter-loading").show();
		var price = bcsffilter.formatMoney(qty * priceBt, bcsffilter.moneyFormat);
		if (
			$(".cs-inc-" + itemId)
				.parents(".product-card-add")
				.hasClass("added")
		) {
			CartJS.updateItemById(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");
							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$("#bc-sf-filter-loading").hide();
						$(".cs-dec-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".cs-dec-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".cs-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("updated to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}

						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (newVal > 0) $(".cs-dec-" + itemId).removeClass("disabled");
						if (bottleQty > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						oldItem.removeClass("changed");
						$("#bottle_qty_" + itemId).removeClass("changed");
						$(".cs-inc-" + itemId)
							.parent()
							.find("input")
							.val(newVal);
						var nextQty = (newVal + 1) * caseRatio + bottleQty;
						if (nextQty > maxQty) $(".cs-inc-" + itemId).addClass("disabled");
						var nextQtyBottle = newVal * caseRatio + 1 + bottleQty;
						if (nextQtyBottle > maxQty)
							$(".bt-inc-" + itemId).addClass("disabled");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		} else {
			//$(".cs-inc-"+itemId).parent().find('input').val(newVal);
			CartJS.addItem(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						if (producer != null && "" != producer && !isBundlebuilder) {
							localStorage.setItem("producer-of-" + itemId, producer);
						}
						localStorage.setItem("max-qty-of-" + itemId, maxQty);
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");
							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$("#bc-sf-filter-loading").hide();
						$(".cs-inc-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".cs-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".cs-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("added to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}
						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (newVal > 0) $(".cs-dec-" + itemId).removeClass("disabled");
						if (bottleQty > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						oldItem.removeClass("changed");
						$("#bottle_qty_" + itemId).removeClass("changed");
						$(".cs-inc-" + itemId)
							.parent()
							.find("input")
							.val(newVal);
						$(".cs-inc-" + itemId)
							.parents(".product-card-add")
							.addClass("added");
						var nextQty = (newVal + 1) * caseRatio + bottleQty;
						if (nextQty > maxQty) $(".cs-inc-" + itemId).addClass("disabled");
						var nextQtyBottle = newVal * caseRatio + 1 + bottleQty;
						if (nextQtyBottle > maxQty)
							$(".bt-inc-" + itemId).addClass("disabled");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		}
	}
}

function caseQuantyDecrease(itemId, itemName, producer, isBundlebuilder) {
	var oldItem = $(".cs-dec-" + itemId)
		.parent()
		.find("input");
	var oldVal = parseInt(
		$(".cs-dec-" + itemId)
			.parent()
			.find("input")
			.val()
	);
	var bottleQty = parseInt(
		$(".cs-dec-" + itemId)
			.parents(".product-quantity")
			.find(".price-variant-bottle input")
			.val()
	);
	var bottleItem = $(".cs-dec-" + itemId)
		.parents(".product-quantity")
		.find(".price-variant-bottle input");
	var priceCase = parseFloat(oldItem.data("price"));
	var priceBt = parseFloat(bottleItem.data("price"));
	var minQty = parseInt(
		$(".cs-dec-" + itemId)
			.parent()
			.find("input")
			.attr("min")
	);
	var maxQty = parseInt(
		$(".cs-dec-" + itemId)
			.parent()
			.find("input")
			.attr("max")
	);
	var caseRatio = parseInt($("#case_qty_" + itemId).data("caseqty"));

	if (isNaN(oldVal) || oldVal < 0) oldVal = 0;

	if (oldItem.hasClass("changed")) {
		var newVal = oldVal;
	} else {
		var newVal = oldVal - 1;
	}

	var qty = newVal * caseRatio + bottleQty;
	console.log("qty: " + qty);
	if (qty >= minQty) {
		var price = bcsffilter.formatMoney(
			parseInt(qty) * priceBt,
			bcsffilter.moneyFormat
		);
		$(".cs-dec-" + itemId)
			.parent()
			.find("input")
			.val(newVal);
		$(".bc-sf-filter-loading").show();
		$(".cs-dec-" + itemId)
			.parents(".grid-view-item")
			.find(".btn-action")
			.removeClass("btn-viewcart btn-adding")
			.find("span")
			.text("Updating to cart");
		$(".cs-dec-" + itemId)
			.parents(".product-card-add")
			.addClass("spinner-active")
			.find(".spinner")
			.show();
		if (
			$(".cs-dec-" + itemId)
				.parents(".product-card-add")
				.hasClass("added")
		) {
			CartJS.updateItemById(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");
							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$("#bc-sf-filter-loading").hide();
						$(".cs-dec-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".cs-dec-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".cs-dec-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("updated to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}

						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (bottleQty <= 0) $(".bt-dec-" + itemId).addClass("disabled");
						if (newVal <= 0) $(".cs-dec-" + itemId).addClass("disabled");
						oldItem.removeClass("changed");
						$("#bottle_qty_" + itemId).removeClass("changed");
						$(".cs-inc-" + itemId).removeClass("disabled");
						$(".bt-inc-" + itemId).removeClass("disabled");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		} else {
			CartJS.addItem(
				itemId,
				qty,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						if (producer != null && "" != producer && !isBundlebuilder) {
							localStorage.setItem("producer-of-" + itemId, producer);
						}
						localStorage.setItem("max-qty-of-" + itemId, maxQty);
						var shopTaxesIncluded = $(".shop_taxes_included").text();
						jQuery.getJSON("/cart.js", function (cart) {
							var price = 0;
							for (cartItem of cart.items) {
								if (shopTaxesIncluded != "true") {
									if (cartItem.taxable) {
										var priceItem = cartItem.final_line_price;
										var tax = priceItem * 0.1;
										price += priceItem + tax;
									} else {
										var priceItem = cartItem.final_line_price;
										price += priceItem;
									}
								} else {
									var priceItem = cartItem.final_line_price;
									price += priceItem;
								}
							}

							$(".minicart-subtotal, .minicart-total, .total-value").html(
								Shopify.formatMoney(price)
							);
							var cartCount = getCartCount(cart);
							if (cartCount <= 1)
								$(".minicart-items-count").html(cartCount + " Item");
							else $(".minicart-items-count").html(cartCount + " Items");
							$(".site-header__cart-count span").first().next().html(cartCount);
							$("#CartCount span.cart-count").html(cartCount);
						});

						$("#bc-sf-filter-loading").hide();
						$(".cs-inc-" + itemId)
							.parents(".product-card-add")
							.removeClass("spinner-active");
						$(".spinner").hide();
						$(".cs-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".btn-action")
							.addClass("btn-viewcart")
							.removeClass("btn-adding")
							.find("span")
							.text("View cart");
						$(".cs-inc-" + itemId)
							.parents(".grid-view-item")
							.find(".subtotal-price")
							.html(price);

						$(".line-item-list").empty();
						loadMinicart();
						$(".minicart-success")
							.show()
							.find("span.update-text")
							.text("added to");

						if (data.items_subtotal_price > 0) {
							$(".minicart-panel").removeClass("minicart-empty");
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = null;
						} else {
							$(".minicart-panel").addClass("minicart-empty");
							$(".minicart-success").hide();
							document.getElementById(
								"minicart-panel-items-loading"
							).innerHTML = "Your cart is empty";
						}
						$(".minicart-panel").addClass("open");
						$("html").addClass("minicart-open");
						if (newVal > 0) $(".cs-dec-" + itemId).removeClass("disabled");
						if (bottleQty > 0) $(".bt-dec-" + itemId).removeClass("disabled");
						oldItem.removeClass("changed");
						$("#bottle_qty_" + itemId).removeClass("changed");
						$(".cs-inc-" + itemId)
							.parent()
							.find("input")
							.val(newVal);
						$(".cs-inc-" + itemId)
							.parents(".product-card-add")
							.addClass("added");
						var nextQty = (newVal + 1) * caseRatio + bottleQty;
						if (nextQty > maxQty) $(".cs-inc-" + itemId).addClass("disabled");
						var nextQtyBottle = newVal * caseRatio + 1 + bottleQty;
						if (nextQtyBottle > maxQty)
							$(".bt-inc-" + itemId).addClass("disabled");
					},
					error: function (data, textStatus, jqXHR) {
						$("#bc-sf-filter-loading").hide();
					},
				}
			);
		}
	} else {
		var qty = (price = 0);
		$(".bc-sf-filter-loading").show();
		$(".cs-dec-" + itemId)
			.parents(".grid-view-item")
			.find(".btn-action")
			.removeClass("btn-viewcart btn-adding")
			.find("span")
			.text("Removing to cart");
		$(".cs-dec-" + itemId)
			.parents(".product-card-add")
			.addClass("spinner-active")
			.find(".spinner")
			.show();
		CartJS.removeItemById(itemId, {
			success: function (data, textStatus, jqXHR) {
				$(".cs-dec-" + itemId)
					.parents(".product-card-add")
					.find(".btn-action")
					.removeClass("btn-viewcart")
					.addClass("btn-cancel")
					.find("span")
					.text("Cancel");
				var shopTaxesIncluded = $(".shop_taxes_included").text();
				jQuery.getJSON("/cart.js", function (cart) {
					var price = 0;
					for (cartItem of cart.items) {
						if (shopTaxesIncluded != "true") {
							if (cartItem.taxable) {
								var priceItem = cartItem.final_line_price;
								var tax = priceItem * 0.1;
								price += priceItem + tax;
							} else {
								var priceItem = cartItem.final_line_price;
								price += priceItem;
							}
						} else {
							var priceItem = cartItem.final_line_price;
							price += priceItem;
						}
					}

					$(".minicart-subtotal, .minicart-total, .total-value").html(
						Shopify.formatMoney(price)
					);
					var cartCount = getCartCount(cart);
					if (cartCount <= 1)
						$(".minicart-items-count").html(cartCount + " Item");
					else $(".minicart-items-count").html(cartCount + " Items");
					$(".site-header__cart-count span").first().next().html(cartCount);
					$("#CartCount span.cart-count").html(cartCount);
				});

				$("#bc-sf-filter-loading").hide();
				$(".cs-dec-" + itemId)
					.parents(".product-card-add")
					.removeClass("spinner-active");
				$(".spinner").hide();
				$(".cs-dec-" + itemId)
					.parents(".grid-view-item")
					.find(".btn-action")
					.addClass("btn-cancel")
					.removeClass("btn-adding btn-viewcart")
					.find("span")
					.text("Cancel");
				$(".cs-dec-" + itemId)
					.parents(".grid-view-item")
					.find(".subtotal-price")
					.html(bcsffilter.formatMoney(0, bcsffilter.moneyFormat));

				$(".line-item-list").empty();
				loadMinicart();
				$(".minicart-success")
					.show()
					.find("span.update-text")
					.text("removed from");

				if (data.items_subtotal_price > 0) {
					$(".minicart-panel").removeClass("minicart-empty");
					document.getElementById(
						"minicart-panel-items-loading"
					).innerHTML = null;
				} else {
					$(".minicart-panel").addClass("minicart-empty");
					$(".minicart-success").hide();
					document.getElementById("minicart-panel-items-loading").innerHTML =
						"Your cart is empty";
				}

				$(".minicart-panel").addClass("open");
				$("html").addClass("minicart-open");

				$(".bt-dec-" + itemId).addClass("disabled");
				$(".cs-dec-" + itemId).addClass("disabled");
				oldItem.removeClass("changed");
				$("#bottle_qty_" + itemId).removeClass("changed");
				$(".bt-dec-" + itemId)
					.parent()
					.find("input")
					.val(0);
				$(".cs-dec-" + itemId)
					.parent()
					.find("input")
					.val(0);
				$(".cs-inc-" + itemId)
					.parents(".product-card-add")
					.removeClass("added");
				$(".cs-inc-" + itemId).removeClass("disabled");
				$(".bt-inc-" + itemId).removeClass("disabled");
			},
			error: function (data, textStatus, jqXHR) {
				$("#bc-sf-filter-loading").hide();
			},
		});
	}
}

/**
 * Function to caculate Qty added for item(s)
 * @param itemID
 * @param type
 * @param TypeID
 * @return Qty added for item with TypeID
 */
function getQuantityItem(data, itemID, type, TypeID) {
	var totalqty = 0;
	var case_1 = 6;
	var case_2 = 12;
	for (var i = 0; i < data.items.length; i++) {
		var itemId = data.items[i]["id"];

		if (itemID == itemId) {
			totalqty = data.items[i]["quantity"];
			break;
		}
	}

	if (TypeID > 0) {
		if (type == "case") {
			if (TypeID == case_1) {
				return Math.floor(totalqty / case_1);
			}
			if (TypeID == case_2) {
				return Math.floor(totalqty / case_2);
			}
		} else {
			if (TypeID == case_1) {
				return totalqty - Math.floor(totalqty / case_1) * case_1;
			}
			if (TypeID == case_2) {
				return totalqty - Math.floor(totalqty / case_2) * case_2;
			}
		}
	} else {
		return totalqty;
	}
}

function getQuantityBottle(data, itemID) {
	var totalqty = 0;
	for (var i = 0; i < data.items.length; i++) {
		var itemId = data.items[i]["id"];

		if (itemID == itemId) {
			totalqty = data.items[i]["quantity"];
			break;
		}
	}
	return totalqty;
}

function showPopup(itemName, type) {
	var popup = $("#addCartPopup");
	popup.addClass("show");
	popup.find(".product-name").text(itemName);
	if (type == "add") {
		popup.find(".type").text("has been added to your cart");
	} else if (type == "update") {
		popup.find(".type").text("has been updated in your cart");
	} else {
		popup.find(".type").text("has been removed from your cart");
	}
}

function showAlertMin(itemName, minQty) {
	$(".minmaxify").show();
	$(".minmaxify .product-name").text(itemName);
	$(".minmaxify .min-item").text(minQty);
	$(".minmaxify .min").show();
	$(".minmaxify .max").hide();
}

function showAlertMax(itemName, maxQty) {
	$(".minmaxify").show();
	$(".minmaxify .product-name").text(itemName);
	$(".minmaxify .max-item").text(maxQty);
	$(".minmaxify .min").hide();
	$(".minmaxify .max").show();
}

function closeAtcpPopup() {
	var popup = $("#addCartPopup");
	popup.removeClass("show");
}

function goToCheckout() {
	window.location.href = "/checkout";
}

function loadMinicart() {
	var xhr = new XMLHttpRequest();
	xhr.onload = function () {
		if (xhr.status >= 200 && xhr.status < 300) {
			var wrapper = document.querySelector("#cart-items");
			var json = JSON.parse(xhr.response);

			if (json.items.length) {
				document.getElementById(
					"minicart-panel-items-loading"
				).innerHTML = null;
				for (var i = 0; i < json.items.length; i++) {
					var newDiv = document.createElement("li");
					newDiv.innerHTML = renderCartItem(json.items[i], i);
					wrapper.appendChild(newDiv);
				}
			} else if (!json.items.length) {
				$(".minicart-success").hide();
				document.getElementById("minicart-panel-items-loading").innerHTML =
					"Your cart is empty";
			}
			//console.log(json);
			if (json.items.length == 0) {
				$(".minicart-panel").addClass("minicart-empty");
			} else {
				$(".minicart-panel").removeClass("minicart-empty");
				var cartCount = getCartCount(json);
				if (cartCount == 1) {
					$(".cart-count-mobile").text("[ " + cartCount + " item ]");
				} else {
					$(".cart-count-mobile").text("[ " + cartCount + " items ]");
				}
			}
			$("#CartCount .cart-count").text(cartCount);
			$("#CartCount .total-value").text(Shopify.formatMoney(json.total_price));
			//document.getElementById('minicartTotalPrice').innerHTML = json.total_price / 100;
			//document.getElementById('minicartNumberOfItems').innerHTML = json.item_count;
			//when done append the div into the carts wrapper location
			// set a div to innerHTML your array of shit
		} else {
			console.log("Loading the minicart data has failed");
		}
		console.log("The load minicart function has been called XXXXXXXXXXXX");
	};
	xhr.open("GET", "https://" + window.location.hostname + "/cart.js");
	xhr.send();
}

function renderCartItem(cartItem, i) {
	var handleProduct = cartItem.handle;
	if (typeof minMaxify != "undefined")
		var minMaxQty = minMaxify.getLimitsFor({ handle: handleProduct });

	var dataCart = (function () {
		var jqXHR = jQ.ajax({
			url: "/products/" + handleProduct + ".js",
			async: false,
		});
		var data = JSON.parse(jqXHR.responseText);
		return data;
	})();

	var stepQty = 1;

	if (typeof minMaxQty != "undefined") {
		console.log(minMaxQty);
		var minQty = minMaxQty.min;
		stepQty = minMaxQty.multiple;
	}

	var maxQty = localStorage.getItem("max-qty-of-" + cartItem.id);

	console.log(dataCart);
	if (stepQty <= 1) {
		if (cartItem.id == dataCart.variants[0].id) {
			if (dataCart.tags.indexOf("bottle") >= 0) {
				stepQty = 1;
			} else {
				if (dataCart.tags.indexOf("case: 6") >= 0) {
					stepQty = 6;
				} else {
					if (dataCart.tags.indexOf("case: 12") >= 0) {
						stepQty = 12;
					}
				}
			}
		}
	}

	if (cartItem.product_type == "Subscriptions") {
		if (
			cartItem.id == "23844343119953" ||
			cartItem.id == "23844338171985" ||
			cartItem.id == "23844330242129"
		) {
			stepQty = 6;
		} else {
			stepQty = 12;
		}
	}

	var disabledMinClass = "";
	var disabledMaxClass = "";
	/*if(minQty > 0 && parseInt(minQty) >= cartItem.quantity)
		disabledMinClass = 'disabled';*/
	if (maxQty > 0 && parseInt(maxQty) <= cartItem.quantity)
		disabledMaxClass = "disabled";
	var producer = localStorage.getItem("producer-of-" + cartItem.id);
	if (producer == null) {
		producer = localStorage.getItem("producer-of-" + cartItem.handle);
		if (producer == null) {
			producer = "";
		}
	}

	var productClass = cartItem.product_type;
	productClass = productClass.toLowerCase();
	productClass = productClass.split(" ").join("-");
	var taxable = cartItem.taxable;
	let price = cartItem.final_price / 100;

	/// logic to calc individual price of items if discount

	let blakeTags = dataCart.tags;
	let foundBold = false;
	for (let i = 0; i < blakeTags.length; i++) {
		let savedToLocal24 = dataCart.id.toString() + ":24";
		let savedToLocal12 = dataCart.id.toString() + ":12";

		if (blakeTags[i] == "tier: 12" && cartItem.quantity >= 12) {
			console.log("tier 12 found");
			price = dataCart.price * 0.95 * cartItem.quantity;

			// this saves the id of the product to local storage
			//the purpose of this is on the update event
			//we can check the local sorage for the id, if it is true we know to apply a tier12
			localStorage.setItem(savedToLocal12, "true");

			foundBold = true;
		}

		if (blakeTags[i] == "tier: 24" && cartItem.quantity >= 24) {
			console.log("tier 24 found");
			price = dataCart.price * 0.9 * cartItem.quantity;

			localStorage.setItem(savedToLocal24, "true");

			foundBold = true;
		}
	}
	let productPrice = 0;
	if (foundBold) {
		productPrice = price;
	} else {
		productPrice = cartItem.price * cartItem.quantity;
	}

	return (
		'<div class="content ' +
		productClass +
		'" data-id="' +
		cartItem.id +
		'" data-price="' +
		price.toFixed(2) +
		'" product-id="' +
		cartItem.product_id +
		'">' +
		'<div class="item-image">' +
		'<a href="' +
		cartItem.url +
		'">' +
		'<img src="' +
		cartItem.image +
		'" alt="">' +
		"</a>" +
		"</div>" +
		'<div class="item-details">' +
		'<div class="producer">' +
		producer +
		"</div>" +
		'<h4 class="item-title">' +
		'<a href="' +
		cartItem.url +
		'">' +
		cartItem.title +
		"</a>" +
		"</h4>" +
		'<div class="item-price">' +
		'<div class="item-total">' +
		Shopify.formatMoney(productPrice) +
		"</div>" +
		"</div>" +
		// TODO: add api calls to the buttons
		'<div class="item-quantity-wrapper" taxable="' +
		taxable +
		'">' +
		'<div class="item-quantity-selector">' +
		'<button class="item-quantity-decrement ' +
		disabledMinClass +
		'" onclick="quantityDecrement(this)"></button>' +
		'<input class="item-quantity-input" type="number" name="updates[]"' +
		'id="' +
		cartItem.variant_id +
		'" data-product-id="' +
		cartItem.product_id +
		'" data-line="1" value="' +
		cartItem.quantity +
		'" step="' +
		stepQty +
		'" min="' +
		minQty +
		'" max="' +
		maxQty +
		'"' +
		'pattern="[0-9]*">' +
		'<button class="item-quantity-increment ' +
		disabledMaxClass +
		'" onclick="quantityIncrement(this)"></button>' +
		"</div>" +
		'<div class="item-remove-wrapper">' +
		'<span onclick="minicartRemove(this)" class="btn btn-remove">Remove</span>' +
		"</div>" +
		"</div>" +
		"</div>" +
		'<div class="spinner" style="display: none;"><div class="fa-pulse"><i class="fa fa-spinner fa-3x fa-fw"></i></div></div>' +
		"</div>"
	);
}

function quantityIncrement(e) {
	var idItem = $(e).parents(".content").attr("data-id");
	var oldVal = parseInt(
		$(e).parent(".item-quantity-selector").find("input").val()
	);
	var step = parseInt(
		$(e).parent(".item-quantity-selector").find("input").attr("step")
	);

	if (step == 1) {
		if ($("#bottle_qty_" + idItem).length > 0) {
			var minVal = parseInt($("#bottle_qty_" + idItem).attr("min"));
			var dataBottle = "show";
		} else {
			var minVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("min")
			);
			var dataBottle = "hide";
		}
		if ($("#bottle_qty_" + idItem).length > 0) {
			var maxVal = parseInt($("#bottle_qty_" + idItem).attr("max"));
		} else {
			var maxVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("max")
			);
		}

		//Get dataCase
		if ($("#case_qty_" + idItem).length > 0) {
			var dataCase = parseInt($("#case_qty_" + idItem).attr("data-caseqty"));
		} else {
			var dataCase = 1;
		}
	} else {
		var dataBottle = "hide";
		if ($("#case_qty_" + idItem).length > 0) {
			var minVal = parseInt($("#case_qty_" + idItem).attr("min"));
			var dataCase = parseInt($("#case_qty_" + idItem).attr("data-caseqty"));
		} else {
			var minVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("min")
			);
			var dataCase = 1;
		}
		//Get maxQty
		if ($("#case_qty_" + idItem).length > 0) {
			var maxVal = parseInt($("#case_qty_" + idItem).attr("max"));
		} else {
			var maxVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("max")
			);
		}
	}

	$(e).parents(".content").addClass("spinner-active");
	$(e).parents(".content").find(".spinner").show();
	var caseRatio = $("#case_qty_" + idItem).data("caseqty");
	if (parseInt(oldVal) >= 0) {
		var newVal = parseInt(oldVal) + step;
		var qtyItem = newVal;
		cartUpdateAjax2(qtyItem, idItem, "update");
		$(".minicart-success").show().find("span.update-text").text("updated to");
		$(e).parents("li").show();
		$('.product-card-add[data-product-id="' + idItem + '"]')
			.next(".btn-action")
			.removeClass("btn-cancel")
			.addClass("btn-viewcart")
			.find("span")
			.text("View Cart");

		if (dataCase != 1) {
			var caseQtyValue = Math.floor(qtyItem / dataCase);

			if (dataBottle == "show") {
				var bottleQtyValue = qtyItem - caseQtyValue * dataCase;
				$("#bottle_qty_" + idItem).val(bottleQtyValue);
				if (bottleQtyValue == 0) $(".bt-dec-" + idItem).addClass("disabled");
				else $(".bt-dec-" + idItem).removeClass("disabled");

				//Check maxQty for bottle
				if (caseQtyValue * dataCase + bottleQtyValue + 1 > maxVal) {
					$(".bt-inc-" + idItem).addClass("disabled");
				} else {
					$(".bt-inc-" + idItem).removeClass("disabled");
				}
			} else {
				var bottleQtyValue = 0;
			}

			$("#case_qty_" + idItem).val(caseQtyValue);
			if (caseQtyValue == 0) $(".cs-dec-" + idItem).addClass("disabled");
			else $(".cs-dec-" + idItem).removeClass("disabled");

			//Check maxQty
			if ((caseQtyValue + 1) * dataCase + bottleQtyValue > maxVal) {
				$(".cs-inc-" + idItem).addClass("disabled");
			} else {
				$(".cs-inc-" + idItem).removeClass("disabled");
			}
		} else {
			var bottleQtyValue = qtyItem;
			$("#bottle_qty_" + idItem).val(bottleQtyValue);

			//Check maxQty
			if (bottleQtyValue + 1 > maxVal) {
				$(".bt-inc-" + idItem).addClass("disabled");
			} else {
				$(".bt-inc-" + idItem).removeClass("disabled");
			}
		}

		//var newValBottle = parseInt(newVal)%caseRatio;
		//var newValCase = parseInt(newVal/caseRatio);
		//$("#bottle_qty_"+idItem).val(newValBottle);
		//$("#case_qty_"+idItem).val(newValCase);
		if (newVal > parseInt(minVal) && minVal > 1) {
			$(e)
				.parents(".item-quantity-selector")
				.find(".item-quantity-decrement")
				.removeClass("disabled");
		}
		if (newVal >= parseInt(maxVal) && maxVal > 0) {
			$(e).addClass("disabled");
		}
	}
}

function quantityDecrement(e) {
	$(e).parents(".content").addClass("spinner-active");
	$(e).parents(".content").find(".spinner").show();

	var idItem = $(e).parents(".content").attr("data-id");
	var oldVal = parseInt(
		$(e).parent(".item-quantity-selector").find("input").val()
	);
	var step = parseInt(
		$(e).parent(".item-quantity-selector").find("input").attr("step")
	);

	if (step == 1) {
		if ($("#bottle_qty_" + idItem).length > 0) {
			var minVal = parseInt($("#bottle_qty_" + idItem).attr("min"));
			var dataBottle = "show";
		} else {
			var minVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("min")
			);
			var dataBottle = "hide";
		}
		if ($("#bottle_qty_" + idItem).length > 0) {
			var maxVal = parseInt($("#bottle_qty_" + idItem).attr("max"));
		} else {
			var maxVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("max")
			);
		}

		//Get dataCase
		if ($("#case_qty_" + idItem).length > 0) {
			var dataCase = parseInt($("#case_qty_" + idItem).attr("data-caseqty"));
		} else {
			var dataCase = 1;
		}
	} else {
		var dataBottle = "hide";
		if ($("#case_qty_" + idItem).length > 0) {
			var minVal = parseInt($("#case_qty_" + idItem).attr("min"));
			var dataCase = parseInt($("#case_qty_" + idItem).attr("data-caseqty"));
		} else {
			var minVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("min")
			);
			var dataCase = 1;
		}
		//Get maxQty
		if ($("#case_qty_" + idItem).length > 0) {
			var maxVal = parseInt($("#case_qty_" + idItem).attr("max"));
		} else {
			var maxVal = parseInt(
				$(e).parent(".item-quantity-selector").find("input").attr("max")
			);
		}
	}

	var caseRatio = 1;
	if ($("#case_qty_" + idItem).length > 0)
		caseRatio = parseInt($("#case_qty_" + idItem).data("caseqty"));
	if (parseInt(oldVal) <= 1) {
		var newVal = 0;
		$(e).parent(".item-quantity-selector").find("input").val(newVal);
		cartUpdateAjax2(qtyItem, idItem, "remove");
		$(".minicart-success").show().find("span.update-text").text("removed from");
		setTimeout(function () {
			$(e).parents("li").hide();
		}, 500);
		$('.product-card-add[data-product-id="' + idItem + '"]')
			.removeClass("added")
			.find("input")
			.val(0);
		$(".cs-dec-" + idItem).addClass("disabled");
		$(".bt-dec-" + idItem).addClass("disabled");
		$(".cs-inc-" + idItem).removeClass("disabled");
		$(".bt-inc-" + idItem).removeClass("disabled");

		//For Collection List
		$("#btn_list_" + idItem)
			.removeClass("btn-viewcart btn-added-list")
			.attr("title", "Add to cart")
			.find("span")
			.text("Add to cart");
	} else {
		var newVal = oldVal - step;
		if (newVal < minVal) {
			newVal = 0;
			$(e).parent(".item-quantity-selector").find("input").val(newVal);
			cartUpdateAjax2(qtyItem, idItem, "remove");
			$(".minicart-success")
				.show()
				.find("span.update-text")
				.text("removed from");
			setTimeout(function () {
				$(e).parents("li").hide();
			}, 500);
			$('.product-card-add[data-product-id="' + idItem + '"]')
				.removeClass("added")
				.find("input")
				.val(0);
			$(".cs-dec-" + idItem).addClass("disabled");
			$(".bt-dec-" + idItem).addClass("disabled");
			$(".cs-inc-" + idItem).removeClass("disabled");
			$(".bt-inc-" + idItem).removeClass("disabled");

			//For Collection List
			$("#btn_list_" + idItem)
				.removeClass("btn-viewcart btn-added-list")
				.attr("title", "Add to cart")
				.find("span")
				.text("Add to cart");
		} else {
			var qtyItem = newVal;
			jQuery(e).parent(".item-quantity-selector").find("input").val(newVal);
			cartUpdateAjax2(qtyItem, idItem, "update");
			$(".minicart-success").show().find("span.update-text").text("updated to");

			if (dataCase != 1) {
				var caseQtyValue = Math.floor(qtyItem / dataCase);

				if (dataBottle == "show") {
					var bottleQtyValue = qtyItem - caseQtyValue * dataCase;
					$("#bottle_qty_" + idItem).val(bottleQtyValue);
					if (bottleQtyValue == 0) $(".bt-dec-" + idItem).addClass("disabled");
					else $(".bt-dec-" + idItem).removeClass("disabled");
				}

				$("#case_qty_" + idItem).val(caseQtyValue);
				if (caseQtyValue == 0) $(".cs-dec-" + idItem).addClass("disabled");
				else $(".cs-dec-" + idItem).removeClass("disabled");

				//Check maxQty
				if ((caseQtyValue + 1) * dataCase + bottleQtyValue > maxVal) {
					$(".cs-inc-" + idItem).addClass("disabled");
				} else {
					$(".cs-inc-" + idItem).removeClass("disabled");
				}

				if (caseQtyValue * dataCase + bottleQtyValue + 1 > maxVal) {
					$(".bt-inc-" + idItem).addClass("disabled");
				} else {
					$(".bt-inc-" + idItem).removeClass("disabled");
				}
			} else {
				var bottleQtyValue = qtyItem;
				$("#bottle_qty_" + idItem).val(bottleQtyValue);

				//Check maxQty
				if (bottleQtyValue + 1 > maxVal) {
					$(".bt-inc-" + idItem).addClass("disabled");
				} else {
					$(".bt-inc-" + idItem).removeClass("disabled");
				}
			}

			if (newVal < parseInt(maxVal) && maxVal > 0) {
				$(e)
					.parents(".item-quantity-selector")
					.find(".item-quantity-increment")
					.removeClass("disabled");
			}
		}
	}
}

function getCartCount(json) {
	var cartCount = json.item_count;
	for (var i in json.items) {
		//console.log(json.items[i]);
		if (json.items[i].product_type == "Custom Bundle") {
			var handleProduct = json.items[i].handle;
			var cartItem = (function () {
				var jqXHR = jQ.ajax({
					url: "/products/" + handleProduct + ".js",
					async: false,
				});
				var data = JSON.parse(jqXHR.responseText);
				return data;
			})();
			if (cartItem.tags.includes("case: 6")) {
				cartCount -= json.items[i].quantity;
				cartCount += json.items[i].quantity * 6;
			} else {
				cartCount -= json.items[i].quantity;
				cartCount += json.items[i].quantity * 12;
			}
		}
	}
	return cartCount;
}
function changeTypeBottle(e){
	var price = jQuery(e).data('price');
	if (jQuery(e).find(":selected").val() == 'bottle') {
		jQuery(e).closest('.product-form-quantity').find('.select-quantity-bottle').show();
		jQuery(e).closest('.product-form-quantity').find('.select-quantity-case').hide();
		var valueSelected = jQuery(e).closest('.product-form-quantity').find('.select-quantity-bottle').find(":selected").val();
		//console.log(valueSelected);
        //$(this).parents('.product-form__item--quantity').find('input#Quantity-product-form').val(valueSelected);
		changePrice(e, valueSelected, price);
    } else { 
		jQuery(e).closest('.product-form-quantity').find('.select-quantity-bottle').hide();
		jQuery(e).closest('.product-form-quantity').find('.select-quantity-case').show();
		var valueSelected = jQuery(e).closest('.product-form-quantity').find('.select-quantity-case').find(":selected").val();
      	//console.log(valueSelected);
      	// jQuery(e).parents('.product-form__item--quantity').find('input#Quantity-product-form').val(valueSelected);
		//$('.per-bottle-text').show();
		changePrice(e,valueSelected, price)
	}

	var itemId = $(e)
			.parents(".product-card-add")
			.attr("data-product-id");

	console.log("we have been clicked my pal");

	$('#btcs_list_' +itemId).val(valueSelected);

	var amount = $('#btcs_list_' +itemId).attr('value');

	console.log("the amount in your thing is ", amount);

	$('#btcs_qty_' +itemId+' option[value='+amount+']').attr('selected','selected');

	console.log("the id is ", itemId);


}
function changePrice(item, valueSelect, price) {
	var totalQty = valueSelect;
	var first_price = price;
	var wrapper = jQuery(item).closest('.product-card-wrap');
	if (jQuery(wrapper).find('.tier-tag').length){
		if (totalQty >= 12 && totalQty < 24) {
			var final_price = first_price * 0.95;
			var price_html = Shopify.formatMoney(final_price);
			jQuery(wrapper).find('#pricebottle').html(price_html);
			if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
			}
			else{
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
			}
			//console.log(price_html);
		}
		else if(totalQty > 24){
			var final_price = first_price * 0.9;
			var price_html = Shopify.formatMoney(final_price);
			jQuery(wrapper).find('#pricebottle').html(price_html);
			//console.log(price_html);
			if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
			}
			else{
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
			}
		}
		else {
			var final_price = first_price;
			var price_html = Shopify.formatMoney(final_price);
			jQuery(wrapper).find('#pricebottle').html(price_html);
			//console.log(price_html);
			if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
			}
			else{
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
			}
		}
	}else {
		var final_price = first_price;
		var price_html = Shopify.formatMoney(final_price);
		jQuery(wrapper).find('#pricebottle').html(price_html);
		//console.log(price_html);
		if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
			jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
		}
		else{
			jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
		}
	}
}
function changeQtyGrid(e) {
	var totalQty = jQuery(e).val();
	var wrapper = jQuery(e).closest('.product-card-wrap');
	var first_price = jQuery(wrapper).find('#Quantity-product-form').data('price');
	if (jQuery(wrapper).find('.tier-tag').length){
		if (totalQty >= 12 && totalQty < 24) {
			var final_price = first_price * 0.95;
			var price_html = Shopify.formatMoney(final_price);
			jQuery(wrapper).find('#pricebottle').html(price_html);
			if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
			}
			else{
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
			}
			//console.log(price_html);
		}
		else if(totalQty > 24){
			var final_price = first_price * 0.9;
			var price_html = Shopify.formatMoney(final_price);
			jQuery(wrapper).find('#pricebottle').html(price_html);
			//console.log(price_html);
			if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
			}
			else{
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
			}
		}
		else {
			var final_price = first_price;
			var price_html = Shopify.formatMoney(final_price);
			jQuery(wrapper).find('#pricebottle').html(price_html);
			//console.log(price_html);
			if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
			}
			else{
				jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
			}
		}
	}else {
		var final_price = first_price;
		var price_html = Shopify.formatMoney(final_price);
		jQuery(wrapper).find('#pricebottle').html(price_html);
		//console.log(price_html);
		if (jQuery(wrapper).find('.list-view-item__price-column dl.price').hasClass('price--on-sale')) {
			jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--sale').html(Shopify.formatMoney(totalQty * final_price));
		}
		else{
			jQuery(wrapper).find('.list-view-item__price-column dl.price .price-item--regular').html(Shopify.formatMoney(totalQty * final_price));
		}
	}
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
/* Collection Product Grid/List => Filter */
function onInteractWithFilterOptionValue(a, b, c, d, e, f) {
	jQ(b).addClass("selected");
	var g = bcsffilter,
		h = jQ(b).data("count"),
		f = void 0 !== f && "true" === f;
	if (g.isMobile() && "style2" == g.mobileStyle)
		a.preventDefault(),
			(h > 0 || (!0 === f && "collection" == c)) &&
				((g.internalClick = !0),
				"single" == e &&
					jQ(".bc-sf-filter-option-block-active")
						.find("ul li")
						.children()
						.removeClass("selected"),
				jQ(b).toggleClass("selected"),
				jQ(b).siblings().toggleClass("selected"),
				g.buildFilterSelectionMobile());
	else if (
		!1 === f &&
		"sub_category" != d &&
		(a.preventDefault(), h > 0 || void 0 == h)
	) {
		g.internalClick = !0;
		var i = jQ(b).attr("data-id"),
			j = decodeURIComponent(jQ(b).attr("data-value"));
		"collection" == c &&
			(g.queryParams.collection_scope = g.collectionId = jQ(b).data(
				"collection-scope"
			));
		var k =
			("list" != d && "sub_category" != d) || "single" != e
				? g.buildFilterOptionLink(i, j, c, d, e)
				: jQ(b).attr("href");
		g.onChangeData(k, c, j, i);
	}
	sessionStorage.setItem("firstLoad", false);
}

/* Collection Product Grid/List => Filter */

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

/* Collection Filter Open Type */
BCSfFilter.prototype.buildFilterOptionSingleListData = function (
	a,
	b,
	c,
	d,
	e,
	f,
	g
) {
	setTimeout(function () {
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find(
				".bc-sf-filter-option-show-search-box-wrapper, .bc-sf-filter-block-content"
			)
			.show();
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find("span.up")
			.removeClass("up");
		var url = window.location.href;
		var urlSplit = url.split("?");
		$('.bc-sf-filter-option-block[data-type="collection"] ul li').each(
			function () {
				var urlItem = $(this).find("a").attr("href");
				if ((urlItem.indexOf("all") > -1) & (urlSplit[0].indexOf("all") > -1)) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("all-wine") > -1) &
					(urlSplit[0].indexOf("all-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("red-wine") > -1) &
					(urlSplit[0].indexOf("red-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("white-wine") > -1) &
					(urlSplit[0].indexOf("white-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("sparkling-wine") > -1) &
					(urlSplit[0].indexOf("sparkling-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("orange-wine") > -1) &
					(urlSplit[0].indexOf("orange-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
			}
		);
	}, 2000);
	if (this.checkShowFilterOptionItem(f, g)) {
		var h =
				(!!g.hasOwnProperty("keepValuesStatic") && g.keepValuesStatic, f.key),
			i = f.key;
		"collection" == a && ((h = f.label), (i = f.handle + ":" + f.key));
		var j = this.getTemplate("filterOptionSingleListItem");
		return (j = this.buildFilterOptionItem(j, h, i, a, b, c, d, e, f, g));
	}
	return "";
};

BCSfFilter.prototype.buildFilterOptionSubCategoryData = function (
	a,
	b,
	c,
	d,
	e,
	f,
	g
) {
	setTimeout(function () {
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find(
				".bc-sf-filter-option-show-search-box-wrapper, .bc-sf-filter-block-content"
			)
			.show();
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find("span.up")
			.removeClass("up");
		var url = window.location.href;
		var urlSplit = url.split("?");
		$('.bc-sf-filter-option-block[data-type="collection"] ul li').each(
			function () {
				var urlItem = $(this).find("a").attr("href");
				if ((urlItem.indexOf("all") > -1) & (urlSplit[0].indexOf("all") > -1)) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("all-wine") > -1) &
					(urlSplit[0].indexOf("all-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("red-wine") > -1) &
					(urlSplit[0].indexOf("red-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("white-wine") > -1) &
					(urlSplit[0].indexOf("white-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("sparkling-wine") > -1) &
					(urlSplit[0].indexOf("sparkling-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("orange-wine") > -1) &
					(urlSplit[0].indexOf("orange-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
			}
		);
	}, 2000);
	if (this.checkShowFilterOptionItem(f, g)) {
		var h =
				(!!g.hasOwnProperty("keepValuesStatic") && g.keepValuesStatic, f.label),
			i = f.handle,
			j = this.getTemplate("filterOptionSubCategoryItem");
		j = this.buildFilterOptionItem(j, h, i, a, b, c, d, e, f, g);
		var k = "";
		if (f.hasOwnProperty("tags"))
			for (var l in f.tags) {
				var m = this.buildFilterOptionLabel(f.tags[l], null, g),
					n = i + "/" + this.slugify(f.tags[l]),
					o = this.getTemplate("filterOptionSubCategorySubItem");
				(o = o
					.replace(/{{itemLabel}}/g, m)
					.replace(/{{itemParentId}}/g, b)
					.replace(/{{itemValue}}/g, encodeURIParamValue(m))
					.replace(/{{itemParentLabel}}/g, c)
					.replace(
						/{{itemFunc}}/g,
						"onInteractWithFilterOptionValue(event, this, '" +
							a +
							"', '" +
							d +
							"', '" +
							e +
							"')"
					)),
					(o = o.replace(
						/{{itemLink}}/g,
						this.buildFilterOptionLink("pf_cs_collection", n, a, d, e)
					)),
					(o = this.checkFilterOptionSelected("pf_cs_collection", n, a, d)
						? o.replace(/{{itemSelected}}/g, "selected")
						: o.replace(/{{itemSelected}}/g, "")),
					(k += o);
			}
		return (
			(j = this.getSettingValue("general.collapseSubCategory")
				? j.replace(/{{closeClass}}/g, "")
				: j.replace(/{{closeClass}}/g, "hidden")),
			(j = j.replace(/{{itemSubCategory}}/g, k))
		);
	}
	return "";
};

BCSfFilter.prototype.buildFilterOptionMultipleListData = function (
	a,
	b,
	c,
	d,
	e,
	f,
	g
) {
	setTimeout(function () {
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find(
				".bc-sf-filter-option-show-search-box-wrapper, .bc-sf-filter-block-content"
			)
			.show();
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find("span.up")
			.removeClass("up");
		var url = window.location.href;
		var urlSplit = url.split("?");
		$('.bc-sf-filter-option-block[data-type="collection"] ul li').each(
			function () {
				var urlItem = $(this).find("a").attr("href");
				if ((urlItem.indexOf("all") > -1) & (urlSplit[0].indexOf("all") > -1)) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("all-wine") > -1) &
					(urlSplit[0].indexOf("all-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("red-wine") > -1) &
					(urlSplit[0].indexOf("red-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("white-wine") > -1) &
					(urlSplit[0].indexOf("white-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("sparkling-wine") > -1) &
					(urlSplit[0].indexOf("sparkling-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("orange-wine") > -1) &
					(urlSplit[0].indexOf("orange-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
			}
		);
	}, 2000);
	if (this.checkShowFilterOptionItem(f, g)) {
		var h = f.key,
			i = f.key;
		"price" == a || "percent_sale" == a
			? ((i = i.replace(/\*/g, "").replace(/\-/g, ":")), (e = "multiple"))
			: "stock" == a && ((h = f.label), (i = "in-stock" == f.key));
		var j = this.getTemplate("filterOptionMultipleListItem");
		return (
			(j = this.buildFilterOptionItem(j, h, i, a, b, c, d, e, f, g)),
			"price" == a &&
				"list" == d &&
				(j = j.replace("'", '"').replace(/\$/g, "&#36;")),
			j
		);
	}
	return "";
};

BCSfFilter.prototype.buildFilterOptionBoxData = function (a, b, c, d, e, f, g) {
	setTimeout(function () {
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find(
				".bc-sf-filter-option-show-search-box-wrapper, .bc-sf-filter-block-content"
			)
			.show();
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find("span.up")
			.removeClass("up");
		var url = window.location.href;
		var urlSplit = url.split("?");
		$('.bc-sf-filter-option-block[data-type="collection"] ul li').each(
			function () {
				var urlItem = $(this).find("a").attr("href");
				if ((urlItem.indexOf("all") > -1) & (urlSplit[0].indexOf("all") > -1)) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("all-wine") > -1) &
					(urlSplit[0].indexOf("all-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("red-wine") > -1) &
					(urlSplit[0].indexOf("red-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("white-wine") > -1) &
					(urlSplit[0].indexOf("white-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("sparkling-wine") > -1) &
					(urlSplit[0].indexOf("sparkling-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("orange-wine") > -1) &
					(urlSplit[0].indexOf("orange-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
			}
		);
	}, 2000);
	if (this.checkShowFilterOptionItem(f, g)) {
		var h = f.key,
			i = f.key,
			j = this.getTemplate("filterOptionBoxItem");
		return (j = this.buildFilterOptionItem(j, h, i, a, b, c, d, e, f, g));
	}
	return "";
};

BCSfFilter.prototype.buildFilterOptionSwatchData = function (
	a,
	b,
	c,
	d,
	e,
	f,
	g
) {
	setTimeout(function () {
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find(
				".bc-sf-filter-option-show-search-box-wrapper, .bc-sf-filter-block-content"
			)
			.show();
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find("span.up")
			.removeClass("up");
		var url = window.location.href;
		var urlSplit = url.split("?");
		$('.bc-sf-filter-option-block[data-type="collection"] ul li').each(
			function () {
				var urlItem = $(this).find("a").attr("href");
				if ((urlItem.indexOf("all") > -1) & (urlSplit[0].indexOf("all") > -1)) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("all-wine") > -1) &
					(urlSplit[0].indexOf("all-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("red-wine") > -1) &
					(urlSplit[0].indexOf("red-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("white-wine") > -1) &
					(urlSplit[0].indexOf("white-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("sparkling-wine") > -1) &
					(urlSplit[0].indexOf("sparkling-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("orange-wine") > -1) &
					(urlSplit[0].indexOf("orange-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
			}
		);
	}, 2000);
	if (this.checkShowFilterOptionItem(f, g)) {
		var h = f.key,
			i = f.key,
			j = i;
		"collection" == a && ((h = f.label), (i = f.handle), (j = h));
		var k = this.getSettingValue("general.colorOptionsArr"),
			l = b.replace("pf_t_", "").replace("pf_opt_", "");
		if ("" != k) {
			void 0 !==
				k.filter(function (a) {
					return b.indexOf(a) > -1;
				})[0] && (l = "color");
		}
		j = this.customizeSwatchFileName(j, f, g);
		var m = this.getTemplate("filterOptionSwatchItem");
		m = this.buildFilterOptionItem(m, h, i, a, b, c, d, e, f, g);
		var n = getFilePath(
			l + "-" + j,
			this.swatchExtension,
			this.getSettingValue("general.swatchImageVersion")
		);
		m = m.replace(/{{itemImageValue}}/g, n);
		var o =
			g.hasOwnProperty("borderSwatch") && "" != g.borderSwatch
				? g.borderSwatch
				: "none";
		return (m = m.replace(/{{itemBorder}}/g, o));
	}
	return "";
};

BCSfFilter.prototype.buildFilterOptionRatingData = function (
	a,
	b,
	c,
	d,
	e,
	f,
	g
) {
	setTimeout(function () {
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find(
				".bc-sf-filter-option-show-search-box-wrapper, .bc-sf-filter-block-content"
			)
			.show();
		$(".bc-sf-filter-option-item.selected")
			.parents(".bc-sf-filter-option-block")
			.find("span.up")
			.removeClass("up");
		var url = window.location.href;
		var urlSplit = url.split("?");
		$('.bc-sf-filter-option-block[data-type="collection"] ul li').each(
			function () {
				var urlItem = $(this).find("a").attr("href");
				if ((urlItem.indexOf("all") > -1) & (urlSplit[0].indexOf("all") > -1)) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("all-wine") > -1) &
					(urlSplit[0].indexOf("all-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("red-wine") > -1) &
					(urlSplit[0].indexOf("red-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("white-wine") > -1) &
					(urlSplit[0].indexOf("white-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("sparkling-wine") > -1) &
					(urlSplit[0].indexOf("sparkling-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
				if (
					(urlItem.indexOf("orange-wine") > -1) &
					(urlSplit[0].indexOf("orange-wine") > -1)
				) {
					$(this).find("a").addClass("selected");
				}
			}
		);
	}, 2000);
	if (this.checkShowFilterOptionItem(f, g)) {
		var h = parseInt(f.key.replace("-*", ""));
		(void 0 !== g.starColor && "" != g.starColor && null != g.starColor) ||
			(g.starColor = this.getSettingValue("general.ratingStarItemColor"));
		var i = this.buildRatingStars(f.from, g.starColor),
			j = this.getTemplate("filterOptionRatingStar")
				.replace(/{{itemStars}}/g, i)
				.replace(/{{label.ratingUp}}/g, this.getSettingValue("label.ratingUp")),
			k = this.getTemplate("filterOptionRatingItem");
		return (k = this.buildFilterOptionItem(k, j, h, a, b, c, d, e, f, g));
	}
	return "";
};
/* Collection Filter Open Type */

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem = function (e, r, t, i) {
	(e = jQ.parseHTML(e)),
		(i = void 0 !== i ? i : this.getSelector("filterTree"));
	void 0 !== r && "before" == r ? $(i + t).prepend(e) : $(i + t).append(e);
};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
	var self = bcsffilter;
	var ext = typeof ext !== "undefined" ? ext : "png";
	var version = typeof version !== "undefined" ? version : "1";
	var prIndex = self.fileUrl.lastIndexOf("?");
	if (prIndex > 0) {
		var filePath = self.fileUrl.substring(0, prIndex);
	} else {
		var filePath = self.fileUrl;
	}
	filePath += fileName + "." + ext + "?v=" + version;
	return filePath;
}

BCSfFilter.prototype.getFilterData = function (eventType, errorCount) {
	function BCSend(eventType, errorCount) {
		var self = bcsffilter;
		var errorCount = typeof errorCount !== "undefined" ? errorCount : 0;
		self.showLoading();
		if (typeof self.buildPlaceholderProductList == "function") {
			self.buildPlaceholderProductList(eventType);
		}
		self.beforeGetFilterData(eventType);
		self.prepareRequestParams(eventType);
		self.queryParams["callback"] = "BCSfFilterCallback";
		self.queryParams["event_type"] = eventType;
		var url = self.isSearchPage()
			? self.getApiUrl("search")
			: self.getApiUrl("filter");
		var script = document.createElement("script");
		script.type = "text/javascript";
		var timestamp = new Date().getTime();
		script.src = url + "?t=" + timestamp + "&" + jQ.param(self.queryParams);
		script.id = "bc-sf-filter-script";
		script.async = true;
		var resendAPITimer, resendAPIDuration;
		resendAPIDuration = 2e3;
		script.addEventListener("error", function (e) {
			if (typeof document.getElementById(script.id).remove == "function") {
				document.getElementById(script.id).remove();
			} else {
				document.getElementById(script.id).outerHTML = "";
			}
			if (errorCount < 3) {
				errorCount++;
				if (resendAPITimer) {
					clearTimeout(resendAPITimer);
				}
				resendAPITimer = setTimeout(
					self.getFilterData("resend", errorCount),
					resendAPIDuration
				);
			} else {
				self.buildDefaultElements(eventType);
			}
		});
		document.getElementsByTagName("head")[0].appendChild(script);
		script.onload = function () {
			if (typeof document.getElementById(script.id).remove == "function") {
				document.getElementById(script.id).remove();
			} else {
				document.getElementById(script.id).outerHTML = "";
			}
		};
	}
	this.requestFilter(BCSend, eventType, errorCount);
};
BCSfFilter.prototype.requestFilter = function (
	sendFunc,
	eventType,
	errorCount
) {
	sendFunc(eventType, errorCount);
};

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (
	html,
	iLabel,
	iValue,
	fOType,
	fOId,
	fOLabel,
	fODisplayType,
	fOSelectType,
	fOItemValue,
	fOData
) {
	var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic")
		? fOData.keepValuesStatic
		: false;
	if (
		fOType == "review_ratings" &&
		this.getSettingValue("general.ratingSelectionStyle") == "text"
	) {
		var title = this.getReviewRatingsLabel(fOItemValue.from);
	} else {
		var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType);
	}
	if (keepValuesStatic === true) var productNumber = null;
	else
		var productNumber = fOItemValue.hasOwnProperty("doc_count")
			? fOItemValue.doc_count
			: 0;
	html = html.replace(
		/{{itemLabel}}/g,
		this.buildFilterOptionLabel(iLabel, productNumber, fOData)
	);
	html = html.replace(
		/{{itemLink}}/g,
		this.buildFilterOptionLink(
			fOId,
			iValue,
			fOType,
			fODisplayType,
			fOSelectType,
			keepValuesStatic
		)
	);
	html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue));
	html = html.replace(/{{itemTitle}}/g, title);
	html = html.replace(
		/{{itemFunc}}/g,
		"onInteractWithFilterOptionValue(event, this, '" +
			fOType +
			"', '" +
			fODisplayType +
			"', '" +
			fOSelectType +
			"', '" +
			keepValuesStatic +
			"')"
	);
	html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType)
		? html.replace(/{{itemSelected}}/g, "selected")
		: html.replace(/{{itemSelected}}/g, "");
	var htmlElement = jQ(html);
	htmlElement
		.children()
		.attr({
			"data-id": fOId,
			"data-value": encodeURIParamValue(iValue),
			"data-parent-label": fOLabel,
			"data-title": title,
			"data-count": productNumber,
		});
	if (fOType != "collection") {
		htmlElement.children().attr("rel", "nofollow");
	}
	if (fOType == "collection")
		htmlElement.children().attr("data-collection-scope", fOItemValue.key);
	return jQ(htmlElement)[0].outerHTML;
};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
